import React, { useMemo } from 'react'
import './PropostaAbas.css'
import { useState, useEffect, useRef } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import oikosApi from '../../../services/oikos';
import endPoints1Api from '../../../services/end_points_1';
import powerAppsApi from '../../../services/powerapps';
import qs from 'qs';
import { Button, Card, CardBody, CardHeader, Col, FormGroup, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap';
import Select from '../../../components/Template/Input/Select';
import MaskedInput from '../../../components/Template/Input/MaskedInput';
import currencyFormatter from '../../../utils/currencyFormatter';
import MaterialReactTable from 'material-react-table';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import moment from 'moment';
import TabelaEspacamentoPropItensTemporalEmMeses from '../../../components/TabelaEspacamentoPropItensTemporalEmMeses/TabelaEspacamentoPropItensTemporalEmMeses.jsx';
import { useSelector } from 'react-redux';
import { notifyError, notifySuccess } from '../../../utils/notify';
import ModalConfirmacao from '../../../components/Modals/ModalConfirmacao/ModalConfirmacao';
import TabelaEspacamentoEventosPagamentoPropTemporalEmMeses from '../../../components/TabelaEspacamentoEventosPagamentoPropTemporalEmMeses/TabelaEspacamentoEventosPagamentoPropTemporalEmMeses.jsx';
import TabelaCruzamentoFluxoMensalPropTemporalEmMeses from '../../../components/TabelaCruzamentoFluxoMensalPropTemporalEmMeses/TabelaCruzamentoFluxoMensalPropTemporalEmMeses.jsx';
import TemporalStackedBarChart from '../../../components/TemporalStackedBarChart';
import IndicacaoCotacaoRapidaForm, {
  serializeCotacoesManuaisForPayload,
} from '../../../components/Modals/ModalPedidoCotacao/IndicacaoCotacaoRapidaForm';
import BlurOverlay from '../../../components/TestPhaseComponent/BlurOverlay.jsx';

function RevisarOrcamento() {
  const { user } = useSelector(state => state.auth);
  const [activeId, setActiveId] = useState('');
  const [prodsProp, setProdsProp] = useState([]);
  const [eventosPagamentoProp, setEventosPagamentoProp] = useState([]);
  const [eventoPagamentoPropData, setEventoPagamentoPropData] = useState([]);
  const [propItens, setPropItens] = useState([]);
  const [propItensUnicos, setPropItensUnicos] = useState([]);
  const [propitemFiltrado, setPropitemFiltrado] = useState(null);
  const [servicos, setServicos] = useState([]);
  const [recTps, setRecTps] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [gruposOrcItem, setGruposOrcItem] = useState([]);
  const [escolaridades, setEscolaridades] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [gruposDeCategorias, setGruposDeCategorias] = useState([]);
  const [projAtuacoes, setProjAtuacoes] = useState([]);
  const [modalPropItemOpen, setModalPropItemOpen] = useState(false);
  const [isPropItemValorEditavel, setIsPropItemValorEditavel] = useState(false);
  const [modalProdPropOpen, setModalProdPropOpen] = useState(false);
  const [modalEventosPagamentoOpen, setModalEventosPagamentoOpen] = useState(false);
  const [openModalSalvarValorRef, setOpenModalSalvarValorRef] = useState(false);
  const [modalSalvarModeloOpen, setModalSalvarModeloOpen] = useState(false);
  const [propItemData, setPropItemData] = useState({});
  const [modeloPropostaData, setModeloPropostaData] = useState({});
  const [modalInsertPropItemOpen, setModalInsertPropItemOpen] = useState(false);
  const [insertPropItemData, setInsertPropItemData] = useState({});
  const [modalidadeQuantidadePropItem, setModalidadeQuantidadePropItem] = useState('total');
  const [quantidadeMensalPropItem, setQuantidadeMensalPropItem] = useState('');
  const [propostaData, setPropostaData] = useState({});
  const [prodPropData, setProdPropData] = useState({});
  const [isSubmitEntityLoading, setIsSubmitEntityLoading] = useState(false);
  const [isInsertPropItemLoading, setIsInsertPropItemLoading] = useState(false);
  const [isEditingProdProp, setIsEditingProdProp] = useState(false);
  const [isEditingEventoPagamentoProp, setIsEditingEventoPagamentoProp] = useState(false);
  const [precoFinalPropostaTabela, setPrecoFinalPropostaTabela] = useState(null);
  const [isEditingInfoServico, setIsEditingInfoServico] = useState(false);
  const [isEditingInfoPrazoEnvio, setIsEditingInfoPrazoEnvio] = useState(false);
  const [prazoParaEnvio, setPrazoParaEnvio] = useState('');
  const [modalPropItemEditOpen, setModalPropItemEditOpen] = useState(false);
  const [qtdProdutosParaAdicionar, setQtdProdutosParaAdicionar] = useState('');
  const [qtdEventosPagamentoParaAdicionar, setQtdEventosPagamentoParaAdicionar] = useState('');
  const [descricaoPadraoProdutosQuantidade, setDescricaoPadraoProdutosQuantidade] = useState('');
  const [prazoInicialProdutosQuantidade, setPrazoInicialProdutosQuantidade] = useState('');
  const [descricaoPadraoEventosQuantidade, setDescricaoPadraoEventosQuantidade] = useState('');
  const [valorPadraoEventosQuantidade, setValorPadraoEventosQuantidade] = useState('');
  const [prazoInicialEventosQuantidade, setPrazoInicialEventosQuantidade] = useState('');
  const [produtosComEventosPagamento, setProdutosComEventosPagamento] = useState(false);
  const [percentualEventosProdutosQuantidade, setPercentualEventosProdutosQuantidade] = useState('');
  const [indicacaoSelCentroDeCusto, setIndicacaoSelCentroDeCusto] = useState([]);
  const [indicacaoSelOrcItems, setIndicacaoSelOrcItems] = useState([]);
  const [indicacaoListaDotacoes, setIndicacaoListaDotacoes] = useState([]);
  const [indicacaoValoresLimites, setIndicacaoValoresLimites] = useState([]);
  const [indicacaoFilesPedidoCompra, setIndicacaoFilesPedidoCompra] = useState([]);
  const indicacaoCotacaoRapidaFormRef = useRef(null);
  const opcoesFrequenciaQuantidade = useMemo(() => ([
    { value: 'unico', label: 'Único', intervaloDias: 0 },
    { value: 'mensal', label: 'Mensal', intervaloDias: 30 },
    { value: 'bimestral', label: 'Bimestral', intervaloDias: 60 },
    { value: 'trimestral', label: 'Trimestral', intervaloDias: 90 },
    { value: 'semestral', label: 'Semestral', intervaloDias: 180 },
    { value: 'anual', label: 'Anual', intervaloMeses: 12 },
  ]), []);
  const [frequenciaProdutosQuantidade, setFrequenciaProdutosQuantidade] = useState(opcoesFrequenciaQuantidade[0]);
  const [frequenciaEventosQuantidade, setFrequenciaEventosQuantidade] = useState(opcoesFrequenciaQuantidade[0]);
  const { id } = useParams();
  const [valoresPorLinhaEColuna, setValoresPorLinhaEColuna] = useState({});
  const [propOrcIdPorLinhaEColuna, setPropOrcIdPorLinhaEColuna] = useState({});
  const [propOrcItemsParaDesativar, setPropOrcItemsParaDesativar] = useState([]);
  const [prodsPropParaDesativar, setProdsPropParaDesativar] = useState([]);
  const [eventosPagamentoPropParaDesativar, setEventosPagamentoPropParaDesativar] = useState([]);
  const [quantidadeColunas, setQuantidadeColunas] = useState(0);
  const [prodsPropPagination, setProdsPropPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [eventosPagamentoPagination, setEventosPagamentoPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [visaoGeralPercentuais, setVisaoGeralPercentuais] = useState({
    taxaEncargos: 72,
    taxaAdministrativa: 15,
    taxaLucro: 40,
    taxaImpostos: 16.5,
    taxaComissao: 0.5,
    custoFinanceiro: 3,
  });
  const [visaoGeralMesesQtd, setVisaoGeralMesesQtd] = useState(0);
  const controlesQuantidadeGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '8px',
    alignItems: 'center',
    width: '100%',
  };

  const controleQuantidadeStyle = {
    width: '100%',
  };

  const parseNumericValue = (value) => {
    if (value === null || value === undefined) return null;

    const raw = String(value).trim();
    if (!raw) return null;

    const cleaned = raw.replace("%", "").replace(/\s/g, "");

    // Handles both pt-BR (`1.234,56`) and unmasked (`1234.56`) shapes
    let normalized = cleaned;
    const hasComma = normalized.includes(",");
    const hasDot = normalized.includes(".");

    if (hasComma && hasDot) {
      normalized = normalized.replace(/\./g, "").replace(",", ".");
    } else if (hasComma && !hasDot) {
      normalized = normalized.replace(",", ".");
    }

    normalized = normalized.replace(/[^\d.-]/g, "");
    const num = Number(normalized);
    return Number.isFinite(num) ? num : null;
  }

  const getMesDoPrazoQuantidade = (prazo) => {
    if (prazo <= 30) return 1;
    return Math.ceil(prazo / 30);
  };

  const getPrazoPorFrequenciaQuantidade = (prazoInicial, frequencia, index) => {
    const prazoBase = Number.isFinite(prazoInicial) ? Math.max(0, Math.floor(prazoInicial)) : 0;
    const intervaloMeses = Number(frequencia?.intervaloMeses);

    if (Number.isFinite(intervaloMeses) && intervaloMeses > 0) {
      if (index === 0) return prazoBase;

      const mesBase = getMesDoPrazoQuantidade(prazoBase);
      const mesAlvo = mesBase + (index * intervaloMeses);
      const inicioMesBase = mesBase === 1 ? 0 : ((mesBase - 1) * 30);
      const diaNoMesBase = Math.max(1, prazoBase - inicioMesBase);

      return ((mesAlvo - 1) * 30) + diaNoMesBase;
    }

    const intervaloDias = Number(frequencia?.intervaloDias) || 30;
    return prazoBase + (index * intervaloDias);
  };

  const getPrazoMaximoContratoEmDias = () => {
    return Math.max(0, Math.floor(Number(quantidadeColunas) || 0)) * 30;
  };

  const getMaiorPrazoGeradoPorQuantidade = (prazoInicial, frequencia, quantidade) => {
    const quantidadeItens = Number(quantidade) || 0;
    if (quantidadeItens <= 0) return 0;
    return getPrazoPorFrequenciaQuantidade(prazoInicial, frequencia, quantidadeItens - 1);
  };

  const LIMITE_PERCENTUAL_EVENTOS_PAGAMENTO = 100;
  const EPSILON_PERCENTUAL_EVENTOS_PAGAMENTO = 0.000001;

  const getSomaPercentualEventosPagamento = (eventos = []) => {
    return (eventos || []).reduce((soma, evento) => {
      const percentual = parseNumericValue(evento?.eventoPagamentoProp_vlr) || 0;
      return soma + percentual;
    }, 0);
  };

  const validarSomaPercentualEventosPagamento = (eventos = []) => {
    const somaPercentuais = getSomaPercentualEventosPagamento(eventos);
    if (somaPercentuais > (LIMITE_PERCENTUAL_EVENTOS_PAGAMENTO + EPSILON_PERCENTUAL_EVENTOS_PAGAMENTO)) {
      notifyError('A soma dos eventos resultaria em mais de 100%.');
      return false;
    }

    return true;
  };

  const getQuantidadeTotalPropItem = () => {
    if (modalidadeQuantidadePropItem !== 'mensal') {
      return propItemData?.propOrcItem_qtd ?? '';
    }

    const quantidadeMensal = parseNumericValue(quantidadeMensalPropItem) || 0;
    const mesesAlocados = Math.max(0, Math.floor(Number(quantidadeColunas) || 0));
    return quantidadeMensal * mesesAlocados;
  };

  const getValorTotalPropItemAdicao = () => {
    const valorUnitario = parseNumericValue(propItemData?.propOrcItem_valor) || 0;

    if (modalidadeQuantidadePropItem === 'mensal') {
      const quantidadeMensal = parseNumericValue(quantidadeMensalPropItem) || 0;
      const mesesAlocados = Math.max(0, Math.floor(Number(quantidadeColunas) || 0));
      return valorUnitario * quantidadeMensal * mesesAlocados;
    }

    const quantidadeTotal = parseNumericValue(propItemData?.propOrcItem_qtd) || 0;
    return valorUnitario * quantidadeTotal;
  };

  const getValorTotalPropItemEdicao = () => {
    const valorUnitario = parseNumericValue(propItemData?.propOrcItem_valor) || 0;
    const quantidadeTotal = parseNumericValue(propItemData?.propOrcItem_qtd) || 0;
    return valorUnitario * quantidadeTotal;
  };

  const isRequiredFieldFilled = (value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === 'string') return value.trim() !== '';
    return true;
  };

  const getCamposObrigatoriosPropItemParaAdicionar = () => {
    const quantidadeTotal = getQuantidadeTotalPropItem();
    const isRecursoHumano = Number(propItemData?.propItemGr_id) === 1;

    const camposObrigatorios = isRecursoHumano
      ? [
        { label: 'Atuação', value: propItemData?.projAtuacao_id },
        { label: 'Selecione a profissão', value: propItemData?.propItem_desc },
        { label: 'Selecione a escolaridade', value: propItemData?.escol_id },
        { label: 'Unidade', value: propItemData?.unidade_id },
        { label: 'Valor unitário de referência', value: propItemData?.propOrcItem_valor },
        { label: 'Quantidade total', value: quantidadeTotal },
      ]
      : [
        { label: 'Selecione o item orçamentário', value: propItemData?.propItem_desc },
        { label: 'Unidade', value: propItemData?.unidade_id },
        { label: 'Valor unitário de referência', value: propItemData?.propOrcItem_valor },
        { label: 'Quantidade total', value: quantidadeTotal },
      ];

    return camposObrigatorios.filter((campo) => !isRequiredFieldFilled(campo.value));
  };

  const hasPropItemSelecionado = () => {
    return Boolean(propItemData?.propItem_id ?? propItemData?.value);
  };

  const getTaxaEncargosAtual = () => {
    return parseNumericValue(visaoGeralPercentuais?.taxaEncargos) || 0;
  };

  const getValorComTaxaEncargos = (valorBase, equipeClt, taxaEncargosCustomizada = null) => {
    const base = parseNumericValue(valorBase) || 0;
    if (!equipeClt) return base;
    const taxa = taxaEncargosCustomizada !== null
      ? (parseNumericValue(taxaEncargosCustomizada) || 0)
      : getTaxaEncargosAtual();
    return Number((base * (1 + (taxa / 100))).toFixed(2));
  };

  const getValorBaseSemEncargos = (valorComEncargos, equipeClt, valorBasePersistido = null, taxaEncargosCustomizada = null) => {
    const basePersistida = parseNumericValue(valorBasePersistido);
    if (basePersistida !== null) return basePersistida;

    const valorAtual = parseNumericValue(valorComEncargos) || 0;
    if (!equipeClt) return valorAtual;

    const taxaEncargos = taxaEncargosCustomizada !== null
      ? (parseNumericValue(taxaEncargosCustomizada) || 0)
      : getTaxaEncargosAtual();

    return taxaEncargos > 0
      ? (valorAtual / (1 + (taxaEncargos / 100)))
      : valorAtual;
  };

  const getProdPropRowKey = (prodProp) => {
    if (!prodProp) return null;
    return String(
      prodProp.prodProp_id ??
      prodProp.value ??
      prodProp.prodProp_nome ??
      ""
    );
  }

  const getEventoPagamentoPropRowKey = (eventoPagamentoProp) => {
    if (!eventoPagamentoProp) return null;
    return String(
      eventoPagamentoProp.eventoPagamentoProp_id ??
      eventoPagamentoProp.value ??
      eventoPagamentoProp.eventoPagamentoProp_nome ??
      ""
    );
  }

  const normalizeProdPropOption = (prodProp) => {
    if (!prodProp) return null;

    const value = prodProp.prodProp_id ?? prodProp.value;
    if (value === null || value === undefined) return null;

    return {
      ...prodProp,
      value,
      label: prodProp.prodProp_nome ?? prodProp.label ?? "Sem Nome",
      prodProp_id: value,
      prodProp_nome: prodProp.prodProp_nome ?? prodProp.label ?? "Sem Nome",
    };
  }

  const normalizeEventoPagamentoPropOption = (eventoPagamentoProp) => {
    if (!eventoPagamentoProp) return null;

    const value = eventoPagamentoProp.eventoPagamentoProp_id ?? eventoPagamentoProp.value;
    if (value === null || value === undefined) return null;

    return {
      ...eventoPagamentoProp,
      value,
      label: eventoPagamentoProp.eventoPagamentoProp_nome ?? eventoPagamentoProp.label ?? "Sem Nome",
      eventoPagamentoProp_id: value,
      eventoPagamentoProp_nome: eventoPagamentoProp.eventoPagamentoProp_nome ?? eventoPagamentoProp.label ?? "Sem Nome",
    };
  }

  const eventosPagamentoPropOptions = (propostaData.eventosPagamentoProp || [])
    .map(normalizeEventoPagamentoPropOption)
    .filter(Boolean);

  const somaPercentualEventosPagamento = useMemo(() => {
    return getSomaPercentualEventosPagamento(propostaData.eventosPagamentoProp);
  }, [propostaData.eventosPagamentoProp]);

  const prodsPropOptions = (propostaData.prodsProp || [])
    .map(normalizeProdPropOption)
    .filter(Boolean);

  const indicacaoPropItemOptions = useMemo(() => {
    const optionsByValue = new Map();

    (propItens || []).forEach((item) => {
      const value = item?.propItem_id ?? item?.value;
      if (value === null || value === undefined) return;

      const labelParts = [
        item?.propItemGr_nome,
        item?.categ_label,
        item?.propItem_desc ?? item?.label,
        item?.unidade_label,
      ].filter(Boolean);

      optionsByValue.set(String(value), {
        ...item,
        value,
        label: labelParts.length ? labelParts.join('/') : (item?.label ?? item?.propItem_desc ?? 'Item da proposta'),
      });
    });

    const currentValue = propItemData?.propItem_id ?? propItemData?.value;
    if (currentValue !== null && currentValue !== undefined && !optionsByValue.has(String(currentValue))) {
      optionsByValue.set(String(currentValue), {
        value: currentValue,
        label: propItemData?.propItem_desc ?? propItemData?.label ?? 'Item da proposta',
      });
    }

    return Array.from(optionsByValue.values()).sort((a, b) => {
      if (a.label < b.label) return -1;
      if (a.label > b.label) return 1;
      return 0;
    });
  }, [propItens, propItemData?.propItem_id, propItemData?.value, propItemData?.propItem_desc, propItemData?.label]);

  const setIndicacaoPropItemData = (nextIndicacaoData) => {
    setPropItemData((prev) => {
      const currentIndicacao = prev?.indicacao || {};
      const indicacao = typeof nextIndicacaoData === 'function'
        ? nextIndicacaoData(currentIndicacao)
        : nextIndicacaoData;

      return {
        ...prev,
        indicacao: indicacao || {},
      };
    });
  };

  const formatPercent = (value) => {
    const num = parseNumericValue(value);
    if (num === null) return "Sem Valor";

    const formatted = new Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(num);

    return `${formatted}%`;
  }

  const getPropItemFiltrado = (baseData, unidadeIdFromSelect = null) => {
    if (!baseData) return null;

    const grupoId = Number(baseData.propItemGr_id);
    const unidadeId = Number(unidadeIdFromSelect ?? baseData.unidade_id);
    const profissaoDesc = baseData.propItem_desc ?? baseData.label;

    if (!grupoId || !unidadeId || !profissaoDesc) return null;

    return (
      propItens.find((item) => {
        return (
          Number(item.propItemGr_id) === grupoId &&
          Number(item.unidade_id) === unidadeId &&
          item.propItem_desc === profissaoDesc
        );
      }) || null
    );
  };

  const getRhPropItemByProfissaoEUnidade = (profissaoDesc, unidadeId) => {
    if (!profissaoDesc || !unidadeId) return null;

    return (
      propItens.find((item) => (
        Number(item.propItemGr_id) === 1 &&
        item.propItem_desc === profissaoDesc &&
        Number(item.unidade_id) === Number(unidadeId)
      )) || null
    );
  };

  const getPropItemRowKey = (propItem) => {
    if (!propItem) return '';
    return String(
      propItem?.propOrcItem_id ??
      propItem?.value ??
      propItem?.id ??
      propItem?.propItem_id ??
      ''
    );
  };

  const getPropItemTemporalRowKey = (propItem, indiceLinha) => {
    return String(propItem?.id ?? propItem?.value ?? indiceLinha);
  };

  const getTotalEspacializadoPropItem = (propItem, indiceLinha) => {
    const linhaKey = getPropItemTemporalRowKey(propItem, indiceLinha);
    const valoresDaLinha = valoresPorLinhaEColuna?.[linhaKey] || {};
    const totalMeses = Math.max(0, Math.floor(Number(quantidadeColunas) || 0));

    return Array.from({ length: totalMeses }, (_, index) => index + 1).reduce((total, indiceColuna) => {
      return total + (parseNumericValue(valoresDaLinha?.[indiceColuna]) || 0);
    }, 0);
  };

  const validarPropItensTotalmenteEspacializados = () => {
    const propItensDaProposta = propostaData?.propItens || [];
    const tolerancia = 0.000001;

    const itensPendentes = propItensDaProposta.reduce((pendentes, propItem, indiceLinha) => {
      const totalNecessario = parseNumericValue(propItem?.propOrcItem_qtd) || 0;
      const totalEspacializado = getTotalEspacializadoPropItem(propItem, indiceLinha);

      if (Math.abs(totalNecessario - totalEspacializado) <= tolerancia) {
        return pendentes;
      }

      pendentes.push({
        descricao: propItem?.propOrcItem_desc ?? propItem?.propItem_desc ?? propItem?.label ?? 'Item orçamentário',
        totalNecessario,
        totalEspacializado,
      });

      return pendentes;
    }, []);

    if (!itensPendentes.length) {
      return true;
    }

    const itensMensagem = itensPendentes
      .slice(0, 3)
      .map((item) => `${item.descricao}: ${item.totalEspacializado}/${item.totalNecessario}`)
      .join('; ');
    const complemento = itensPendentes.length > 3 ? ` e mais ${itensPendentes.length - 3} item(ns)` : '';

    notifyError(`Distribua totalmente todos os itens orçamentários ao longo dos meses antes de concluir. Pendentes: ${itensMensagem}${complemento}.`);
    return false;
  };

  const getEscolaridadeSelecionada = (escolId) => {
    return escolaridades.find((escol) => Number(escol.value) === Number(escolId)) || null;
  };

  const getRhValorComEscolaridade = ({ propItemBase, escolId, fallbackValorBase = null }) => {
    if (!escolId) return null;

    const valorBase = parseNumericValue(propItemBase?.propItem_refVlr ?? fallbackValorBase);
    if (valorBase === null) return null;

    const adicionalEscolaridade = Number(getEscolaridadeSelecionada(escolId)?.escol_adicional) || 0;
    return Number((valorBase * (1 + adicionalEscolaridade)).toFixed(2));
  };

  const getPropItemByGrupoDescricaoEUnidade = (grupoId, itemDesc, unidadeId) => {
    if (!grupoId || !itemDesc || !unidadeId) return null;

    return (
      propItens.find((item) => (
        Number(item.propItemGr_id) === Number(grupoId) &&
        item.propItem_desc === itemDesc &&
        Number(item.unidade_id) === Number(unidadeId)
      )) || null
    );
  };

  const getUnidadesDisponiveisPorGrupoEDescricao = (grupoId, itemDesc) => {
    if (!grupoId || !itemDesc) return [];

    const unidadesMap = new Map();

    propItens.forEach((item) => {
      if (
        Number(item?.propItemGr_id) === Number(grupoId) &&
        String(item?.propItem_desc ?? item?.label ?? '') === String(itemDesc)
      ) {
        const unidadeId = Number(item?.unidade_id);

        if (!unidadesMap.has(unidadeId)) {
          unidadesMap.set(unidadeId, {
            ...item,
            value: unidadeId,
            label: item?.unidade_label,
          });
        }
      }
    });

    return Array.from(unidadesMap.values());
  };

  const unidadesDisponiveisPropItem = useMemo(() => {
    return getUnidadesDisponiveisPorGrupoEDescricao(
      propItemData?.propItemGr_id,
      propItemData?.propItem_desc ?? propItemData?.label
    );
  }, [propItens, propItemData?.propItemGr_id, propItemData?.propItem_desc, propItemData?.label]);

  const visaoGeralTotal = useMemo(() => {
    const propItensArr = propostaData.propItens || [];

    return propItensArr.reduce((propItensAcc, propItem) => {
      let refVlr = 0;
      const qtd = parseNumericValue(propItem?.propOrcItem_qtd) || 0;
      if (propItem?.propItemGr_id === 1 && Boolean(propItem?.propOrcItem_equipeClt)) {
        refVlr = parseNumericValue(propItem?.propOrcItem_valor) * 1.72 || 0;
      } else {
        refVlr = parseNumericValue(propItem?.propOrcItem_valor) || 0;
      }
      return propItensAcc + (refVlr * qtd);

    }, 0);
  }, [propostaData.propItens]);

  const visaoGeralValorTaxaEncargos = useMemo(() => {
    const propItensArr = propostaData.propItens || [];
    const taxaEncargos = parseNumericValue(visaoGeralPercentuais?.taxaEncargos) || 0;

    return propItensArr.reduce((acc, propItem) => {
      const isRecursoHumano = Number(propItem?.propItemGr_id) === 1;
      const isEquipeClt = Boolean(propItem?.propOrcItem_equipeClt);
      if (!isRecursoHumano || !isEquipeClt || taxaEncargos <= 0) return acc;

      const qtd = parseNumericValue(propItem?.propOrcItem_qtd) || 0;
      if (!qtd) return acc;

      const valorUnitario = parseNumericValue(propItem?.propOrcItem_valor) || 0;

      // Fallback for rows without explicit base value.
      const valorUnitarioComEncargos = (valorUnitario * (taxaEncargos / 100));

      const totalBase = valorUnitarioComEncargos * qtd;

      return acc + (totalBase);
    }, 0);
  }, [propostaData.propItens, visaoGeralPercentuais?.taxaEncargos]);

  const visaoGeralCustoAdministrativo = useMemo(() => {
    const total = parseNumericValue(visaoGeralTotal) || 0;
    const taxaAdministrativa = parseNumericValue(visaoGeralPercentuais?.taxaAdministrativa) || 0;
    return total * (taxaAdministrativa / 100);
  }, [visaoGeralTotal, visaoGeralPercentuais?.taxaAdministrativa]);

  const visaoGeralCustoOperacional = useMemo(() => {
    const total = parseNumericValue(visaoGeralTotal) || 0;
    const custoAdministrativo = parseNumericValue(visaoGeralCustoAdministrativo) || 0;
    return total + custoAdministrativo;
  }, [visaoGeralTotal, visaoGeralCustoAdministrativo]);

  const visaoGeralLucroDesejado = useMemo(() => {
    const custoOperacional = parseNumericValue(visaoGeralCustoOperacional) || 0;
    const taxaLucro = parseNumericValue(visaoGeralPercentuais?.taxaLucro) || 0;
    return custoOperacional * (taxaLucro / 100);
  }, [visaoGeralCustoOperacional, visaoGeralPercentuais?.taxaLucro]);

  const labelStyle = {
    fontSize: '0.75rem',
    color: '#adb5bd',
    lineHeight: '1.5',
    marginTop: 16,
  }

  const contentHeaderStyle = {
    maxWidth: '15rem'
  }

  const visaoGeralSubtotalProjeto = useMemo(() => {
    const custoOperacional = parseNumericValue(visaoGeralCustoOperacional) || 0;
    const lucroDesejado = parseNumericValue(visaoGeralLucroDesejado) || 0;
    return custoOperacional + lucroDesejado;
  }, [visaoGeralCustoOperacional, visaoGeralLucroDesejado]);

  const visaoGeralPrecoProposta = useMemo(() => {
    const taxaImpostos = parseNumericValue(visaoGeralPercentuais?.taxaImpostos) || 0;
    const taxaComissao = parseNumericValue(visaoGeralPercentuais?.taxaComissao) || 0;
    const fatorReceita = 1 - ((taxaImpostos + taxaComissao) / 100);
    if (!fatorReceita) return 0;

    return (parseNumericValue(visaoGeralSubtotalProjeto) || 0) / fatorReceita;
  }, [visaoGeralSubtotalProjeto, visaoGeralPercentuais?.taxaImpostos, visaoGeralPercentuais?.taxaComissao]);

  const calculoPrecoFinalProposta = useMemo(() => {
    const quantidadeMeses = Math.max(0, Number(quantidadeColunas) || 0);
    if (!quantidadeMeses) {
      return {
        precoFinalProposta: 0,
        precoProposta: 0,
        precoPropostaComCustoFinanceiro: 0,
        margemContribuicao: '0 %',
        totalPeriodoDespesasFiscaisCorrigido: 0,
        totalPeriodoCustoFinanceiroCorrigido: 0,
        totalPeriodoLucroDesejado: 0,
        totalPeriodoComissaoCorrigido: 0,
        totalPeriodoCustoAdministrativo: 0,
        custosSemEncargos: 0,
      };
    }

    const indicesColunas = Array.from({ length: quantidadeMeses }, (_, index) => index + 1);
    const linhasGastos = propostaData?.propItens || [];
    const linhasIncome = propostaData?.eventosPagamentoProp || [];
    const valorTotalIncome = parseNumericValue(visaoGeralPrecoProposta) || 0;

    const taxaAdministrativa = parseNumericValue(visaoGeralPercentuais?.taxaAdministrativa) || 0;
    const taxaLucro = parseNumericValue(visaoGeralPercentuais?.taxaLucro) || 0;
    const taxaDespesasFiscais = parseNumericValue(visaoGeralPercentuais?.taxaImpostos) || 0;
    const taxaComissao = parseNumericValue(visaoGeralPercentuais?.taxaComissao) || 0;
    const taxaCustoFinanceiro = parseNumericValue(visaoGeralPercentuais?.custoFinanceiro) || 0;

    const getLinhaGastoKey = (linha, indiceLinha) => linha?.id ?? linha?.value ?? indiceLinha;
    const getIndiceColunaDoPrazo = (prazoRaw) => {
      const prazo = parseNumericValue(prazoRaw);
      if (prazo === null || Number.isNaN(prazo) || prazo < 0) return null;
      if (prazo <= 30) return 1;
      return Math.ceil(prazo / 30);
    };

    const getTotalGastoPorMes = (indiceColuna) => {
      return linhasGastos.reduce((soma, linha, indiceLinha) => {
        const linhaKey = getLinhaGastoKey(linha, indiceLinha);
        const quantidade = parseNumericValue(valoresPorLinhaEColuna?.[linhaKey]?.[indiceColuna]) || 0;
        const valorUnitario = parseNumericValue(linha?.propOrcItem_valor) || 0;
        return soma + (quantidade * valorUnitario);
      }, 0);
    };

    const getTotalIncomePorMesComBase = (indiceColuna, valorBaseReceita) => {
      return linhasIncome.reduce((soma, linha) => {
        const indiceColunaDoEvento = getIndiceColunaDoPrazo(linha?.eventoPagamentoProp_prazoPgto);
        if (indiceColunaDoEvento !== indiceColuna) return soma;

        const percentual = parseNumericValue(linha?.eventoPagamentoProp_vlr) || 0;
        return soma + ((percentual / 100) * valorBaseReceita);
      }, 0);
    };

    const toNumber = (value) => {
      if (typeof value === 'number') return value;
      if (typeof value === 'string') {
        const normalized = value.replace(',', '.').trim();
        const parsed = Number(normalized);
        return Number.isNaN(parsed) ? 0 : parsed;
      }
      return 0;
    };

    const getTotalEncargosEquipeCltPorMes = (indiceColuna, taxaEncargos) => {
      return linhasGastos.reduce((soma, linha, indiceLinha) => {
        if (!Boolean(linha?.propOrcItem_equipeClt)) return soma;

        const linhaKey = getLinhaGastoKey(linha, indiceLinha);
        const quantidade = toNumber(valoresPorLinhaEColuna?.[linhaKey]?.[indiceColuna] || 0);
        if (quantidade <= 0) return soma;

        const valorUnitarioAtual = toNumber(linha?.propOrcItem_valor || 0);
        const valorBase = (taxaEncargos > 0 ? (valorUnitarioAtual * (taxaEncargos / 100)) : valorUnitarioAtual);

        //const encargosUnitarios = valorBase * (taxaEncargos / 100);
        return soma + (valorBase * quantidade);
      }, 0);
    };

    const fatorReceita = 1 - (taxaComissao / 100) - (taxaDespesasFiscais / 100);
    if (fatorReceita <= 0) {
      return {
        precoFinalProposta: 0,
        precoProposta: 0,
        precoPropostaComCustoFinanceiro: 0,
        margemContribuicao: '0 %',
        totalPeriodoDespesasFiscaisCorrigido: 0,
        totalPeriodoCustoFinanceiroCorrigido: 0,
        totalPeriodoLucroDesejado: 0,
        totalPeriodoComissaoCorrigido: 0,
        totalPeriodoCustoAdministrativo: 0,
        custosSemEncargos: 0,
      };
    }

    const calcularFluxoMensal = (valorBaseReceita) => {
      let saldoPeriodoAnterior = 0;
      let saldoAcumulado = 0;
      let totalPeriodoGasto = 0;
      let totalPeriodoSubtotalProjeto = 0;
      let totalPeriodoCustoFinanceiro = 0;
      let totalPeriodoComissao = 0;
      let totalPeriodoDespesasFiscais = 0;
      let totalPeriodoCustoAdministrativo = 0;
      let totalPeriodoLucroDesejado = 0;

      indicesColunas.forEach((indiceColuna) => {
        const gasto = getTotalGastoPorMes(indiceColuna);
        const income = getTotalIncomePorMesComBase(indiceColuna, valorBaseReceita);
        const gastoEquipeCltEncargos = getTotalEncargosEquipeCltPorMes(indiceColuna, visaoGeralPercentuais?.taxaEncargos);
        const custoAdministrativo = (gasto + gastoEquipeCltEncargos) * (taxaAdministrativa / 100);
        const custoOperacional = (gasto + gastoEquipeCltEncargos) + custoAdministrativo;
        const lucroDesejado = custoOperacional * (taxaLucro / 100);
        const despesasFiscais = income * (taxaDespesasFiscais / 100);
        const comissao = income * (taxaComissao / 100);
        const custoFinanceiro = saldoPeriodoAnterior < 0
          ? (saldoPeriodoAnterior * (taxaCustoFinanceiro / 100)) * (-1)
          : 0;
        const saldoPeriodo = income - custoOperacional - lucroDesejado - custoFinanceiro - despesasFiscais - comissao;

        totalPeriodoGasto += gasto;
        totalPeriodoCustoAdministrativo += custoAdministrativo;
        totalPeriodoLucroDesejado += lucroDesejado;
        totalPeriodoSubtotalProjeto += (custoOperacional + lucroDesejado);
        totalPeriodoCustoFinanceiro += custoFinanceiro;
        totalPeriodoComissao += comissao;
        totalPeriodoDespesasFiscais += despesasFiscais;
        saldoPeriodoAnterior = saldoPeriodo;
        saldoAcumulado += saldoPeriodo;
      });

      return {
        totalPeriodoGasto,
        totalPeriodoSubtotalProjeto,
        totalPeriodoCustoFinanceiro,
        totalPeriodoComissao,
        totalPeriodoDespesasFiscais,
        totalPeriodoCustoAdministrativo,
        totalPeriodoLucroDesejado,
        saldoAcumulado,
      };
    };

    const fluxoBase = calcularFluxoMensal(valorTotalIncome);
    const precoProposta = fluxoBase.totalPeriodoSubtotalProjeto / fatorReceita;
    const toleranciaSaldoFinal = 0.01;
    const maxIteracoes = 100;
    let precoAtual = (fluxoBase.totalPeriodoSubtotalProjeto + fluxoBase.totalPeriodoCustoFinanceiro) / fatorReceita;
    let fluxoAtual = calcularFluxoMensal(precoAtual);

    for (let iteracao = 0; iteracao < maxIteracoes; iteracao += 1) {
      if (Math.abs(fluxoAtual.saldoAcumulado) <= toleranciaSaldoFinal) break;

      const proximoPreco = (fluxoBase.totalPeriodoSubtotalProjeto + fluxoAtual.totalPeriodoCustoFinanceiro) / fatorReceita;
      if (!Number.isFinite(proximoPreco)) break;
      if (Math.abs(proximoPreco - precoAtual) <= toleranciaSaldoFinal / 10) {
        precoAtual = proximoPreco;
        fluxoAtual = calcularFluxoMensal(precoAtual);
        break;
      }

      precoAtual = proximoPreco;
      fluxoAtual = calcularFluxoMensal(precoAtual);
    }

    const precoPropostaComCustoFinanceiro = fluxoBase.totalPeriodoSubtotalProjeto + fluxoAtual.totalPeriodoCustoFinanceiro;
    const margemContribuicao = (fluxoBase.totalPeriodoSubtotalProjeto && valorTotalIncome)
      ? `${(((precoAtual - fluxoAtual.totalPeriodoGasto - (fluxoAtual.totalPeriodoComissao + fluxoAtual.totalPeriodoDespesasFiscais)) / precoAtual) * 100).toFixed(2)} %`
      : '0 %';
    const custosSemEncargos = Number(((parseNumericValue(visaoGeralTotal) || 0) - (parseNumericValue(visaoGeralValorTaxaEncargos) || 0)).toFixed(2));

    return {
      precoFinalProposta: Number(precoAtual.toFixed(2)),
      precoProposta: Number(precoProposta.toFixed(2)),
      precoPropostaComCustoFinanceiro: Number(precoPropostaComCustoFinanceiro.toFixed(2)),
      margemContribuicao,
      totalPeriodoDespesasFiscaisCorrigido: Number(fluxoAtual.totalPeriodoDespesasFiscais.toFixed(2)),
      totalPeriodoCustoFinanceiroCorrigido: Number(fluxoAtual.totalPeriodoCustoFinanceiro.toFixed(2)),
      totalPeriodoLucroDesejado: Number(fluxoBase.totalPeriodoLucroDesejado.toFixed(2)),
      totalPeriodoComissaoCorrigido: Number(fluxoAtual.totalPeriodoComissao.toFixed(2)),
      totalPeriodoCustoAdministrativo: Number(fluxoBase.totalPeriodoCustoAdministrativo.toFixed(2)),
      custosSemEncargos,
    };
  }, [
    quantidadeColunas,
    propostaData?.propItens,
    propostaData?.eventosPagamentoProp,
    valoresPorLinhaEColuna,
    visaoGeralPrecoProposta,
    visaoGeralPercentuais?.taxaAdministrativa,
    visaoGeralPercentuais?.taxaLucro,
    visaoGeralPercentuais?.taxaImpostos,
    visaoGeralPercentuais?.taxaComissao,
    visaoGeralPercentuais?.custoFinanceiro,
    visaoGeralPercentuais?.taxaEncargos,
    visaoGeralTotal,
    visaoGeralValorTaxaEncargos,
  ]);

  const precoFinalProposta = calculoPrecoFinalProposta.precoFinalProposta;

  const resumoValoresProposta = useMemo(() => {
    return {
      precoProposta: calculoPrecoFinalProposta.precoProposta,
      precoPropostaComCustoFinanceiro: calculoPrecoFinalProposta.precoPropostaComCustoFinanceiro,
      margemContribuicao: calculoPrecoFinalProposta.margemContribuicao,
    };
  }, [calculoPrecoFinalProposta]);

  const precoFinalPropostaEspelhadoDaTabela = useMemo(() => {
    return calculoPrecoFinalProposta.precoFinalProposta;
  }, [calculoPrecoFinalProposta.precoFinalProposta]);

  const precoFinalPropostaAtual = precoFinalPropostaEspelhadoDaTabela ?? precoFinalPropostaTabela ?? precoFinalProposta ?? 0;

  const eventosPagamentoTemporalChartData = useMemo(() => {
    const eventos = propostaData?.eventosPagamentoProp || [];
    const quantidadeMeses = Math.max(0, Math.floor(Number(quantidadeColunas) || 0));
    if (!quantidadeMeses) return {};

    const mesesBase = Array.from({ length: quantidadeMeses }, (_, index) => String(index + 1))
      .reduce((accumulator, monthKey) => {
        accumulator[monthKey] = {};
        return accumulator;
      }, {});

    if (!eventos.length) return mesesBase;

    const valorBaseTotal = parseNumericValue(precoFinalPropostaAtual) || 0;

    return eventos
      .slice()
      .sort((firstEvento, secondEvento) => {
        const firstPrazo = parseNumericValue(firstEvento?.eventoPagamentoProp_prazoPgto) || 0;
        const secondPrazo = parseNumericValue(secondEvento?.eventoPagamentoProp_prazoPgto) || 0;
        return firstPrazo - secondPrazo;
      })
      .reduce((accumulator, eventoPagamentoProp) => {
        const prazoDias = Math.max(0, parseNumericValue(eventoPagamentoProp?.eventoPagamentoProp_prazoPgto) || 0);
        const monthIndex = prazoDias <= 30 ? 1 : Math.ceil(prazoDias / 30);
        if (monthIndex > quantidadeMeses) {
          return accumulator;
        }

        const monthKey = String(monthIndex);
        const itemIndex = Object.keys(accumulator[monthKey] || {}).length;
        const percentualEvento = parseNumericValue(eventoPagamentoProp?.eventoPagamentoProp_vlr) || 0;
        const valorCalculado = Number(((valorBaseTotal * percentualEvento) / 100).toFixed(2));

        if (!accumulator[monthKey]) {
          accumulator[monthKey] = {};
        }

        accumulator[monthKey][itemIndex] = {
          ...eventoPagamentoProp,
          eventoPagamentoProp_valorCalculado: valorCalculado,
        };

        return accumulator;
      }, mesesBase);
  }, [
    propostaData?.eventosPagamentoProp,
    quantidadeColunas,
    precoFinalPropostaAtual,
  ]);

  const visaoGeralMesesRows = useMemo(() => {
    const monthsCount = Math.max(0, Number(visaoGeralMesesQtd) || 0);
    const propItens = propostaData.propItens || [];
    const alocacoes = propostaData.propItensAlocacoesPorMes || [];

    return Array.from({ length: monthsCount }, (_, index) => {
      const mesIndice = index + 1;

      const mesValorTotal = propItens.reduce((totalAcc, propItem) => {
        const propItemId = Number(propItem?.propItem_id ?? propItem?.value) || 0;
        if (!propItemId) return totalAcc;

        const alocacao = alocacoes.find(
          (row) => Number(row?.mes_indice) === mesIndice && Number(row?.propItem_id) === propItemId
        );
        const qtdMes = parseNumericValue(alocacao?.propOrcItem_qtd ?? alocacao?.qtd) || 0;
        const valorRef = parseNumericValue(propItem?.propOrcItem_valor) || 0;

        return totalAcc + (qtdMes * valorRef);
      }, 0);

      return {
        mes_indice: mesIndice,
        mes_label: `mês ${mesIndice}`,
        mes_valor_total: mesValorTotal,
      };
    });
  }, [visaoGeralMesesQtd, propostaData.propItens, propostaData.propItensAlocacoesPorMes]);

  const columnsVisaoGeralMeses = [
    {
      accessorKey: 'mes_label',
      header: 'Mês',
      size: 100,
      maxWidth: 200,
    },
    {
      accessorKey: 'mes_valor_total',
      header: 'Valor total do mês',
      Cell: ({ row }) => currencyFormatter.format(row.original.mes_valor_total || 0),
    },
  ];

  const propItensAlocacoesPorMes = propostaData.propItensAlocacoesPorMes || [];

  const getQtdPropItemNoMes = (mesIndice, propItemId) => {
    const mes = Number(mesIndice) || 0;
    const itemId = Number(propItemId) || 0;
    if (!mes || !itemId) return 0;

    const alocacao = propItensAlocacoesPorMes.find(
      (row) => Number(row?.mes_indice) === mes && Number(row?.propItem_id) === itemId
    );

    return parseNumericValue(alocacao?.propOrcItem_qtd ?? alocacao?.qtd) || 0;
  };

  const setQtdPropItemNoMes = (mesIndice, propItemId, qtdValue) => {
    const mes = Number(mesIndice) || 0;
    const itemId = Number(propItemId) || 0;
    if (!mes || !itemId) return;

    const qtd = parseNumericValue(qtdValue) || 0;

    setPropostaData((prev) => {
      const current = prev.propItensAlocacoesPorMes || [];
      const rowIndex = current.findIndex(
        (row) => Number(row?.mes_indice) === mes && Number(row?.propItem_id) === itemId
      );

      const next = [...current];

      if (rowIndex >= 0) {
        if (qtd > 0) {
          next[rowIndex] = {
            ...next[rowIndex],
            mes_indice: mes,
            propItem_id: itemId,
            propOrcItem_qtd: qtd,
          };
        } else {
          next.splice(rowIndex, 1);
        }
      } else if (qtd > 0) {
        next.push({
          mes_indice: mes,
          propItem_id: itemId,
          propOrcItem_qtd: qtd,
        });
      }

      return {
        ...prev,
        propItensAlocacoesPorMes: next,
      };
    });
  };

  const redistribuirQuantidadePropItemEditado = ({ rowKey, propItemId, quantidadeTotalAtualizada }) => {
    const itemId = Number(propItemId) || 0;
    const novaQuantidadeTotal = parseNumericValue(quantidadeTotalAtualizada) || 0;

    if (!rowKey || !itemId) return;

    const alocacoesAtuaisPorMes = valoresPorLinhaEColuna?.[String(rowKey)] || {};
    const totalAlocadoAtual = Object.values(alocacoesAtuaisPorMes).reduce((acc, value) => {
      return acc + (parseNumericValue(value) || 0);
    }, 0);

    if (totalAlocadoAtual <= novaQuantidadeTotal) return;

    let excessoParaRemover = totalAlocadoAtual - novaQuantidadeTotal;
    const proximaAlocacaoPorMes = { ...alocacoesAtuaisPorMes };
    const mesesOrdenadosDesc = Object.keys(proximaAlocacaoPorMes)
      .map((mes) => Number(mes) || 0)
      .filter(Boolean)
      .sort((a, b) => b - a);

    mesesOrdenadosDesc.forEach((mes) => {
      if (excessoParaRemover <= 0) return;

      const quantidadeMesAtual = parseNumericValue(proximaAlocacaoPorMes[mes]) || 0;
      if (quantidadeMesAtual <= 0) return;

      const quantidadeRemovida = Math.min(quantidadeMesAtual, excessoParaRemover);
      const quantidadeRestanteMes = quantidadeMesAtual - quantidadeRemovida;

      if (quantidadeRestanteMes > 0) {
        proximaAlocacaoPorMes[mes] = quantidadeRestanteMes;
      } else {
        delete proximaAlocacaoPorMes[mes];
      }

      excessoParaRemover -= quantidadeRemovida;
    });

    setValoresPorLinhaEColuna((prev) => {
      const next = { ...(prev || {}) };

      if (Object.keys(proximaAlocacaoPorMes).length > 0) {
        next[String(rowKey)] = proximaAlocacaoPorMes;
      } else {
        delete next[String(rowKey)];
      }

      return next;
    });

    setPropostaData((prev) => {
      const alocacoesAtuais = prev.propItensAlocacoesPorMes || [];
      const alocacoesSemItem = alocacoesAtuais.filter((row) => Number(row?.propItem_id) !== itemId);
      const alocacoesRedistribuidas = Object.entries(proximaAlocacaoPorMes).map(([mes, qtd]) => ({
        mes_indice: Number(mes) || 0,
        propItem_id: itemId,
        propOrcItem_qtd: parseNumericValue(qtd) || 0,
      })).filter((row) => row.mes_indice > 0 && row.propOrcItem_qtd > 0);

      return {
        ...prev,
        propItensAlocacoesPorMes: [...alocacoesSemItem, ...alocacoesRedistribuidas],
      };
    });
  };

  const getPropItensNoMes = (mesIndice) => {
    const mes = Number(mesIndice) || 0;
    return (propostaData.propItens || []).map((propItem) => {
      const propItemId = Number(propItem?.propItem_id ?? propItem?.value) || 0;
      const qtdMes = getQtdPropItemNoMes(mes, propItemId);
      const valorUnitario = parseNumericValue(
        propItem?.relacaoPropPropItemMes_vlr ?? propItem?.propOrcItem_valor
      ) || 0;

      return {
        ...propItem,
        mes_indice: mes,
        propItem_id: propItemId,
        propOrcItem_qtd: qtdMes,
        relacaoPropPropItemMes_vlr: valorUnitario,
      };
    });
  };

  const getValorTotalNoMes = (mesIndice) => {
    const mes = Number(mesIndice) || 0;
    if (!mes) return 0;

    return (propostaData.propItens || []).reduce((totalAcc, propItem) => {
      const propItemId = Number(propItem?.propItem_id ?? propItem?.value) || 0;
      if (!propItemId) return totalAcc;

      const qtdMes = getQtdPropItemNoMes(mes, propItemId);
      const valorRef = parseNumericValue(propItem?.propOrcItem_valor) || 0;

      return totalAcc + (qtdMes * valorRef);
    }, 0);
  };

  const adicionarProdutosPorQuantidade = () => {
    const isPeriodicidadeUnica = frequenciaProdutosQuantidade?.value === 'unico';
    const quantidade = isPeriodicidadeUnica ? 1 : Number(qtdProdutosParaAdicionar);
    if (!Number.isInteger(quantidade) || quantidade <= 0) return;
    const descricaoBase = String(descricaoPadraoProdutosQuantidade || '').trim();
    const percentualEventoAutomatico = parseNumericValue(percentualEventosProdutosQuantidade) || 0;
    const prazoInicial = Number(prazoInicialProdutosQuantidade);
    const prazoPrimeiroProduto = Number.isFinite(prazoInicial) ? Math.max(0, Math.floor(prazoInicial)) : 0;
    const prazoMaximoContrato = getPrazoMaximoContratoEmDias();
    const maiorPrazoGerado = getMaiorPrazoGeradoPorQuantidade(
      prazoPrimeiroProduto,
      frequenciaProdutosQuantidade,
      quantidade,
    );

    if (prazoMaximoContrato > 0 && maiorPrazoGerado > prazoMaximoContrato) {
      notifyError('Esse movimento criaria produtos que ultrapassariam os meses alocados no orçamento.');
      return;
    }
    const recTpProdutoId =
      recTps.find((tipo) => String(tipo?.label || '').trim().toLowerCase() === 'produto')?.value ??
      recTps.find((tipo) => String(tipo?.label || '').toLowerCase().includes('produto'))?.value ??
      null;

    const novosProdutosBase = Array.from({ length: quantidade }, (_, index) => ({
      value: Date.now() + index,
      prodProp_nome: descricaoBase ? `${descricaoBase} ${index + 1}` : `Novo produto ${index + 1}`,
      prodProp_prazoEntrega: getPrazoPorFrequenciaQuantidade(prazoPrimeiroProduto, frequenciaProdutosQuantidade, index),
      prodProp_prazoEntrega: getPrazoPorFrequenciaQuantidade(prazoPrimeiroProduto, frequenciaProdutosQuantidade, index),
      eventosPagamentoProp: [],
    }));

    if (!produtosComEventosPagamento) {
      setPropostaData((prev) => ({
        ...prev,
        prodsProp: [...(prev.prodsProp || []), ...novosProdutosBase],
      }));

      setQtdProdutosParaAdicionar('');
      return;
    }

    const novosEventosBase = novosProdutosBase.map((produto, index) => ({
      value: Date.now() + quantidade + index,
      eventoPagamentoProp_nome: `Evento ${produto.prodProp_nome}`,
      eventoPagamentoProp_vlr: percentualEventoAutomatico,
      eventoPagamentoProp_prazoPgto: produto.prodProp_prazoEntrega,
      recTp_id: recTpProdutoId,
      prodsProp: [],
    }));

    const eventosPagamentoAtualizados = [
      ...(propostaData.eventosPagamentoProp || []),
      ...novosEventosBase,
    ];

    if (!validarSomaPercentualEventosPagamento(eventosPagamentoAtualizados)) {
      return;
    }

    const novosEventos = novosEventosBase.map((evento, index) => ({
      ...evento,
      prodsProp: [novosProdutosBase[index]],
    }));

    const novosProdutos = novosProdutosBase.map((produto, index) => ({
      ...produto,
      eventosPagamentoProp: [novosEventos[index]],
    }));

    setPropostaData((prev) => ({
      ...prev,
      prodsProp: [...(prev.prodsProp || []), ...novosProdutos],
      eventosPagamentoProp: [...(prev.eventosPagamentoProp || []), ...novosEventos],
    }));

    setQtdProdutosParaAdicionar('');
  };

  const handleChangeQuantidadeColunas = (event) => {
    const { value } = event.target;

    const inteiro = value === '' ? 0 : Math.max(0, Math.floor(Number(value)));
    const novaQuantidadeColunas = Number.isNaN(inteiro) ? 0 : inteiro;

    setQuantidadeColunas(novaQuantidadeColunas);

    setValoresPorLinhaEColuna((prev) => {
      const estadoFiltrado = {};

      Object.entries(prev).forEach(([linhaKey, valoresColunas]) => {
        const valoresColunasFiltrados = Object.entries(valoresColunas).reduce((acc, [coluna, valor]) => {
          const indiceColuna = Number(coluna);
          if (indiceColuna <= novaQuantidadeColunas) {
            acc[indiceColuna] = valor;
          }
          return acc;
        }, {});

        if (Object.keys(valoresColunasFiltrados).length > 0) {
          estadoFiltrado[linhaKey] = valoresColunasFiltrados;
        }
      });

      return estadoFiltrado;
    });
  };

  const adicionarEventosPagamentoPorQuantidade = () => {
    if (!validarSomaPercentualEventosPagamento(propostaData.eventosPagamentoProp)) return;
    const quantidade = Number(qtdEventosPagamentoParaAdicionar);
    if (!Number.isInteger(quantidade) || quantidade <= 0) return;
    const descricaoBase = String(descricaoPadraoEventosQuantidade || '').trim();
    const valorPadrao = Number(valorPadraoEventosQuantidade);
    const valorEvento = Number.isFinite(valorPadrao) ? valorPadrao : 0;
    const prazoInicial = Number(prazoInicialEventosQuantidade);
    const prazoPrimeiroEvento = Number.isFinite(prazoInicial) ? Math.max(0, Math.floor(prazoInicial)) : 0;
    const prazoMaximoContrato = getPrazoMaximoContratoEmDias();
    const maiorPrazoGerado = getMaiorPrazoGeradoPorQuantidade(
      prazoPrimeiroEvento,
      frequenciaEventosQuantidade,
      quantidade,
    );

    if (prazoMaximoContrato > 0 && maiorPrazoGerado > prazoMaximoContrato) {
      notifyError('Esse movimento criaria eventos de pagamento que ultrapassariam os meses alocados no orçamento.');
      return;
    }

    const novosEventos = Array.from({ length: quantidade }, (_, index) => ({
      value: Date.now() + index,
      eventoPagamentoProp_nome: descricaoBase ? `${descricaoBase} ${index + 1}` : `Novo evento ${index + 1}`,
      eventoPagamentoProp_vlr: valorEvento,
      eventoPagamentoProp_prazoPgto: getPrazoPorFrequenciaQuantidade(prazoPrimeiroEvento, frequenciaEventosQuantidade, index),
      eventoPagamentoProp_prazoPgto: getPrazoPorFrequenciaQuantidade(prazoPrimeiroEvento, frequenciaEventosQuantidade, index),
      recTp_id: null,
      prodsProp: [],
    }));

    setPropostaData((prev) => {
      const eventosAtualizados = [...(prev.eventosPagamentoProp || []), ...novosEventos];
      if (!validarSomaPercentualEventosPagamento(eventosAtualizados)) return prev;

      return {
        ...prev,
        eventosPagamentoProp: eventosAtualizados,
      };
    });

    setQtdEventosPagamentoParaAdicionar('');
    setDescricaoPadraoEventosQuantidade('');
    setValorPadraoEventosQuantidade('');
    setPrazoInicialEventosQuantidade('');
  };

  const columnsPropItensAlocadosMes = [
    {
      accessorKey: 'propItem_desc',
      header: 'Descrição',
      accessorFn: (row) => row.unidade_label ? `${row.propItem_desc} (${row.unidade_label})` : row.propItem_desc,
    },
    {
      header: 'Qtd. no mês',
      Cell: ({ row }) => (
        <Input
          type="number"
          min={0}
          step="0.01"
          value={String(row.original.propOrcItem_qtd ?? 0)}
          onChange={(e) => {
            setQtdPropItemNoMes(
              row.original.mes_indice,
              row.original.propItem_id,
              e.target.value
            );
          }}
          onWheel={(e) => {
            e.target.blur();
          }}
        />
      ),
    },
    {
      header: 'Valor unitário',
      accessorFn: (row) => currencyFormatter.format(row.relacaoPropPropItemMes_vlr ?? 0),
    },
    {
      header: 'Valor total',
      accessorFn: (row) => currencyFormatter.format(
        (parseNumericValue(row.propOrcItem_qtd) || 0) *
        (parseNumericValue(row.relacaoPropPropItemMes_vlr) || 0)
      ),
    },
  ];

  const itensOrcamentariosTotaisPorGrupo = useMemo(() => {
    const propItensArr = propostaData.propItens || [];
    const totais = {
      1: 0, // Recursos Humanos
      4: 0, // Logística
      2: 0, // Equipamentos
      3: 0, // Despesas Gerais
      5: 0, // Serviços terceirizados
    };

    propItensArr.forEach((propItem) => {
      const groupId = Number(propItem?.propItemGr_id);
      if (!Object.prototype.hasOwnProperty.call(totais, groupId)) return;

      const qtd = parseNumericValue(propItem?.propOrcItem_qtd) || 0;
      const vlr = parseNumericValue(Number(propItem?.propOrcItem_valor)) || 0;
      totais[groupId] += (vlr * qtd);
    });

    return totais;
  }, [propostaData.propItens]);

  const custoTotalResumoPorGrupo = useMemo(() => {
    return Object.values(itensOrcamentariosTotaisPorGrupo || {}).reduce((acc, value) => {
      return acc + (Number(value) || 0);
    }, 0);
  }, [itensOrcamentariosTotaisPorGrupo]);

  const handleDeletePropItem = (propItem) => {
    const propOrcItemId = Number(propItem?.propOrcItem_id ?? propItem?.value) || 0;
    const linhaKey = String(
      propItem?.value ??
      propItem?.propOrcItem_id ??
      propItem?.id ??
      ''
    );

    if (propOrcItemId) {
      setPropOrcItemsParaDesativar((prev) => (
        prev.includes(propOrcItemId) ? prev : [...prev, propOrcItemId]
      ));
    }

    setPropostaData((prev) => ({
      ...prev,
      propItens: (prev.propItens || []).filter((pi) => {
        const currentId = Number(pi?.propOrcItem_id ?? pi?.value) || 0;
        if (propOrcItemId) return currentId !== propOrcItemId;
        return pi?.value !== propItem?.value;
      }),
    }));

    if (linhaKey) {
      setValoresPorLinhaEColuna((prev) => {
        const next = { ...(prev || {}) };
        delete next[linhaKey];
        return next;
      });

      setPropOrcIdPorLinhaEColuna((prev) => {
        const next = { ...(prev || {}) };
        delete next[linhaKey];
        return next;
      });
    }
  };

  const handleDuplicatePropItem = (propItem) => {
    if (!propItem) return;

    const newRowKey = Date.now();
    const sourceRowKey = getPropItemRowKey(propItem);
    const isRecursoHumano = Number(propItem?.propItemGr_id) === 1;
    const itemBase = isRecursoHumano
      ? getRhPropItemByProfissaoEUnidade(propItem?.propItem_desc ?? propItem?.label, propItem?.unidade_id)
      : getPropItemByGrupoDescricaoEUnidade(
        propItem?.propItemGr_id,
        propItem?.propItem_desc ?? propItem?.label,
        propItem?.unidade_id
      );
    const equipeClt = isRecursoHumano && Boolean(propItem?.propOrcItem_equipeClt);
    const duplicatedPropItem = {
      ...propItem,
      propItem_id: propItem?.propItem_id ?? itemBase?.propItem_id ?? itemBase?.value,
      propItem_refVlr: propItem?.propItem_refVlr ?? itemBase?.propItem_refVlr,
      value: newRowKey,
    };

    delete duplicatedPropItem.propOrcItem_id;
    delete duplicatedPropItem.id;
    delete duplicatedPropItem.propOrcItem_usuarioCria;
    delete duplicatedPropItem.propOrcItem_usuarioMod;
    delete duplicatedPropItem.propOrcItem_ativo;

    if (duplicatedPropItem.indicacao) {
      duplicatedPropItem.indicacao = {
        pedidoCompra_desc: duplicatedPropItem.indicacao?.pedidoCompra_desc || '',
        pedidoCompra_vlrLimite: duplicatedPropItem.indicacao?.pedidoCompra_vlrLimite || 0,
        filesPedidoCompra: [],
      };
    }

    if (isRecursoHumano) {
      duplicatedPropItem.propOrcItem_equipeClt = equipeClt;
      duplicatedPropItem.propEstrut_id = equipeClt ? 1 : 2;
      duplicatedPropItem.escol_id = propItem?.escol_id ?? null;
      duplicatedPropItem.projAtuacao_id = propItem?.projAtuacao_id ?? null;
    } else {
      delete duplicatedPropItem.propOrcItem_equipeClt;
      delete duplicatedPropItem.escol_id;
      delete duplicatedPropItem.projAtuacao_id;
    }

    setPropostaData((prev) => ({
      ...prev,
      propItens: [...(prev.propItens || []), duplicatedPropItem],
    }));

    if (sourceRowKey && valoresPorLinhaEColuna?.[sourceRowKey]) {
      setValoresPorLinhaEColuna((prev) => ({
        ...prev,
        [String(newRowKey)]: { ...(prev?.[sourceRowKey] || {}) },
      }));

      setPropOrcIdPorLinhaEColuna((prev) => {
        const next = { ...(prev || {}) };
        delete next[String(newRowKey)];
        return next;
      });
    }
  };

  const handleDeleteProdProp = (prodPropRow) => {
    const prodPropId = Number(prodPropRow?.prodProp_id) || 0;

    if (prodPropId) {
      setProdsPropParaDesativar((prev) => (
        prev.includes(prodPropId) ? prev : [...prev, prodPropId]
      ));
    }

    const deletedProdKey = getProdPropRowKey(prodPropRow);
    setPropostaData((prev) => ({
      ...prev,
      prodsProp: (prev.prodsProp || []).filter((prodProp) => {
        const prodKey = getProdPropRowKey(prodProp);
        if (deletedProdKey) return prodKey !== deletedProdKey;
        return prodProp?.value !== prodPropRow?.value;
      }),
      eventosPagamentoProp: (prev.eventosPagamentoProp || []).map((eventoPagamentoProp) => ({
        ...eventoPagamentoProp,
        prodsProp: (eventoPagamentoProp.prodsProp || []).filter((prodProp) => {
          const prodKey = getProdPropRowKey(prodProp);
          if (deletedProdKey) return prodKey !== deletedProdKey;
          return prodProp?.value !== prodPropRow?.value;
        }),
      })),
    }));
  };

  const handleDeleteEventoPagamentoProp = (eventoPagamentoPropRow) => {
    const eventoPagamentoPropId = Number(eventoPagamentoPropRow?.eventoPagamentoProp_id) || 0;

    if (eventoPagamentoPropId) {
      setEventosPagamentoPropParaDesativar((prev) => (
        prev.includes(eventoPagamentoPropId) ? prev : [...prev, eventoPagamentoPropId]
      ));
    }

    const deletedEventoKey = getEventoPagamentoPropRowKey(eventoPagamentoPropRow);
    setPropostaData((prev) => ({
      ...prev,
      eventosPagamentoProp: (prev.eventosPagamentoProp || []).filter((eventoPagamentoProp) => {
        const eventoKey = getEventoPagamentoPropRowKey(eventoPagamentoProp);
        if (deletedEventoKey) return eventoKey !== deletedEventoKey;
        return eventoPagamentoProp?.value !== eventoPagamentoPropRow?.value;
      }),
      prodsProp: (prev.prodsProp || []).map((prodProp) => ({
        ...prodProp,
        eventosPagamentoProp: (prodProp.eventosPagamentoProp || []).filter((eventoPagamentoProp) => {
          const eventoKey = getEventoPagamentoPropRowKey(eventoPagamentoProp);
          if (deletedEventoKey) return eventoKey !== deletedEventoKey;
          return eventoPagamentoProp?.value !== eventoPagamentoPropRow?.value;
        }),
      })),
    }));
  };

  const columnsSelectedPropPropItens = [
    {
      accessorKey: 'propItem_desc',
      header: 'Item Orc.',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.propItem_desc) {
          return row.propItem_desc + ` (${row.unidade_label})`;
        } else {
          return 'Sem descrição';
        }
      },
    },
    {
      accessorKey: 'propOrcItem_desc',
      header: 'Descrição',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.propOrcItem_desc) {
          return row.propOrcItem_desc;
        } else {
          return 'Sem descrição';
        }
      },
    },
    {
      accessorKey: 'propOrcItem_qtd',
      header: 'Quantidade total',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.propOrcItem_qtd) {
          return row.propOrcItem_qtd;
        } else {
          return 'Sem quantidade';
        }
      },
    },
    {
      header: 'Valor unitário',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.propOrcItem_valor) {
          return currencyFormatter.format(row.propOrcItem_valor);
        } else {
          return 'Sem valor';
        }
      },
    },
    {
      header: 'Valor total',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.propOrcItem_valor) {
          return currencyFormatter.format(row.propOrcItem_valor * row.propOrcItem_qtd);
        } else {
          return 'Sem valor';
        }
      },
    },
    {
      header: ' ',
      size: 100,
      maxWidth: 200,
      Cell: ({ row }) => (
        <div style={{ display: 'flex', gap: '0.2rem' }}>
          <Button size="sm" className="px-2 py-1" onClick={() => {
            setPropItemData(row.original);
            setModalPropItemEditOpen(true)
          }}>
            Editar
          </Button>
          <Button size="sm" className="px-2 py-1" onClick={() => handleDuplicatePropItem(row.original)}>
            Duplicar
          </Button>
          <Button size="sm" className="px-2 py-1" onClick={() => handleDeletePropItem(row.original)}>
            Deletar
          </Button>
        </div>
      ),
    }
  ]

  const columnsSelectedProdsProp = [
    {
      accessorKey: 'prodProp_nome',
      header: 'Nome',
      size: 100,
      maxWidth: 200,
      Cell: ({ row }) => (
        <Input
          value={row.original?.prodProp_nome || ''}
          onChange={(e) => {
            const currentRowKey = getProdPropRowKey(row.original);
            const nome = e.target.value;

            setPropostaData((prev) => ({
              ...prev,
              prodsProp: (prev.prodsProp || []).map((prodProp) => {
                const prodKey = getProdPropRowKey(prodProp);
                const isCurrentRow =
                  (currentRowKey && prodKey && currentRowKey === prodKey) ||
                  prodProp === row.original;

                if (!isCurrentRow) return prodProp;
                return { ...prodProp, prodProp_nome: nome };
              }),
            }));
          }}
        />
      ),
    },
    {
      accessorKey: 'prodProp_prazoEntrega',
      header: 'Prazo (dias)',
      size: 100,
      maxWidth: 200,
      Cell: ({ row }) => (
        <Input
          type="number"
          min={0}
          value={row.original?.prodProp_prazoEntrega ?? ''}
          onChange={(e) => {
            const currentRowKey = getProdPropRowKey(row.original);
            const value = e.target.value;
            const prazo = value === '' ? null : Number(value);

            setPropostaData((prev) => ({
              ...prev,
              prodsProp: (prev.prodsProp || []).map((prodProp) => {
                const prodKey = getProdPropRowKey(prodProp);
                const isCurrentRow =
                  (currentRowKey && prodKey && currentRowKey === prodKey) ||
                  prodProp === row.original;

                if (!isCurrentRow) return prodProp;
                return { ...prodProp, prodProp_prazoEntrega: prazo };
              }),
            }));
          }}
          onWheel={(e) => {
            e.target.blur();
          }}
        />
      ),
    },
    {
      header: ' ',
      size: 100,
      maxWidth: 200,
      Cell: ({ row }) => (
        <>
          <Button onClick={() => handleDeleteProdProp(row.original)}>
            Deletar
          </Button>
        </>
      ),
    }
  ]

  const columnsSelectedEventosPagamentoProp = [
    {
      accessorKey: 'eventoPagamentoProp_nome',
      header: 'Nome',
      size: 100,
      maxWidth: 200,
      Cell: ({ row }) => (
        <Input
          value={row.original?.eventoPagamentoProp_nome || ''}
          onChange={(e) => {
            const currentRowKey = getEventoPagamentoPropRowKey(row.original);
            const nome = e.target.value;

            setPropostaData((prev) => ({
              ...prev,
              eventosPagamentoProp: (prev.eventosPagamentoProp || []).map((eventoPagamentoProp) => {
                const eventoKey = getEventoPagamentoPropRowKey(eventoPagamentoProp);
                const isCurrentRow =
                  (currentRowKey && eventoKey && currentRowKey === eventoKey) ||
                  eventoPagamentoProp === row.original;

                if (!isCurrentRow) return eventoPagamentoProp;
                return { ...eventoPagamentoProp, eventoPagamentoProp_nome: nome };
              }),
            }));
          }}
        />
      ),
    },
    {
      accessorKey: 'eventoPagamentoProp_vlr',
      header: 'Valor (%)',
      size: 100,
      maxWidth: 200,
      Cell: ({ row }) => (
        <Input
          type="number"
          min={0}
          step="0.01"
          value={row.original?.eventoPagamentoProp_vlr ?? ''}
          onChange={(e) => {
            const currentRowKey = getEventoPagamentoPropRowKey(row.original);
            const value = e.target.value;
            const vlr = value === '' ? null : Number(value);

            setPropostaData((prev) => {
              const eventosAtualizados = (prev.eventosPagamentoProp || []).map((eventoPagamentoProp) => {
                const eventoKey = getEventoPagamentoPropRowKey(eventoPagamentoProp);
                const isCurrentRow =
                  (currentRowKey && eventoKey && currentRowKey === eventoKey) ||
                  eventoPagamentoProp === row.original;

                if (!isCurrentRow) return eventoPagamentoProp;
                return { ...eventoPagamentoProp, eventoPagamentoProp_vlr: vlr };
              });

              if (!validarSomaPercentualEventosPagamento(eventosAtualizados)) return prev;

              return {
                ...prev,
                eventosPagamentoProp: eventosAtualizados,
              };
            });
          }}
          onWheel={(e) => {
            e.target.blur();
          }}
        />
      ),
    },
    {
      accessorKey: 'eventoPagamentoProp_prazoPgto',
      header: 'Prazo (dias)',
      size: 100,
      maxWidth: 200,
      Cell: ({ row }) => (
        <Input
          type="number"
          min={0}
          value={row.original?.eventoPagamentoProp_prazoPgto ?? ''}
          onChange={(e) => {
            const currentRowKey = getEventoPagamentoPropRowKey(row.original);
            const value = e.target.value;
            const prazo = value === '' ? null : Number(value);

            setPropostaData((prev) => ({
              ...prev,
              eventosPagamentoProp: (prev.eventosPagamentoProp || []).map((eventoPagamentoProp) => {
                const eventoKey = getEventoPagamentoPropRowKey(eventoPagamentoProp);
                const isCurrentRow =
                  (currentRowKey && eventoKey && currentRowKey === eventoKey) ||
                  eventoPagamentoProp === row.original;

                if (!isCurrentRow) return eventoPagamentoProp;
                return { ...eventoPagamentoProp, eventoPagamentoProp_prazoPgto: prazo };
              }),
            }));
          }}
          onWheel={(e) => {
            e.target.blur();
          }}
        />
      ),
    },
    {
      accessorKey: 'recTp_id',
      header: 'Tipo',
      size: 100,
      maxWidth: 200,
      Cell: ({ row }) => (
        <div
          onClick={() => {
            const menus = document.querySelectorAll('.select__menu')
            menus.forEach(menu => {
              menu.style.zIndex = "100"
            })
          }}
        >
          <Select
            className="basic-single"
            classNamePrefix="select"
            isClearable={true}
            isSearchable={true}
            options={recTps}
            value={recTps.find((recTp) => Number(recTp.value) === Number(row.original?.recTp_id)) || null}
            onChange={(e) => {
              const currentRowKey = getEventoPagamentoPropRowKey(row.original);
              const recTpId = e?.value ?? null;

              setPropostaData((prev) => ({
                ...prev,
                eventosPagamentoProp: (prev.eventosPagamentoProp || []).map((eventoPagamentoProp) => {
                  const eventoKey = getEventoPagamentoPropRowKey(eventoPagamentoProp);
                  const isCurrentRow =
                    (currentRowKey && eventoKey && currentRowKey === eventoKey) ||
                    eventoPagamentoProp === row.original;

                  if (!isCurrentRow) return eventoPagamentoProp;
                  return { ...eventoPagamentoProp, recTp_id: recTpId };
                }),
              }));
            }}
          />
        </div>
      ),
    },
    {
      header: ' ',
      size: 100,
      maxWidth: 200,
      Cell: ({ row }) => (
        <>
          <Button onClick={() => handleDeleteEventoPagamentoProp(row.original)}>
            Deletar
          </Button>
        </>
      ),
    }
  ]

  const renderEntidadesPropostaContent = (selectedIndex) => (
        <>
          <label htmlFor="quantidade-colunas-meses" style={{marginRight: '1rem'}}>Quantidade de meses</label>
          <input
            id="quantidade-colunas-meses"
            type="number"
            min="0"
            step="1"
            value={quantidadeColunas}
            onChange={handleChangeQuantidadeColunas}
          />
          <Tabs className="orcamento-content-tabs" selectedIndex={selectedIndex} onSelect={() => false}>
            <TabList style={{ display: 'none' }}>
              <Tab>Itens orçamentários</Tab>
              <Tab>Produtos</Tab>
              <Tab>Eventos de pagamento</Tab>
            </TabList>
            <TabPanel>
              <Tabs>
                <TabList>
                  <Tab>Recursos Humanos</Tab>
                  <Tab>Logística</Tab>
                  <Tab>Equipamentos</Tab>
                  <Tab>Despesas Gerais</Tab>
                  <Tab>Serviços terceirizados</Tab>
                </TabList>
                <TabPanel>
                  <div className='d-flex justify-content-between align-items-center'>
                    <span>Recursos Humanos</span>
                    <Button
                      size="sm"
                      color="link"
                      className="ml-2 px-0"
                      onClick={(e)=>{
                        setPropItemData({
                          propItemGr_id: 1,
                          propItemGr_label: 'Recurso Humano',
                          propOrcItem_equipeClt: false,
                          propEstrut_id: 2,
                        });
                        setModalPropItemOpen(true);
                      }}
                    >
                      Adicionar recursos humanos
                    </Button>
                  </div>
                  <MaterialReactTable
                    columns={columnsSelectedPropPropItens}
                    data={propostaData.propItens ? propostaData.propItens.filter(pi => Number(pi.propItemGr_id) === 1) : []}
                    initialState={{
                      density: 'compact',
                      expanded: {}, //expand all groups by default
                      pagination: { pageIndex: 0, pageSize: 10 },
                      sorting: [], //sort by state by default,
                    }}
                    enableColumnResizing={true}
                    enableGrouping={false}
                    enableGlobalFilter={true}
                    enableFilters={true}
                    muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                    muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                    muiTablePaginationProps={{
                      sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                      labelRowsPerPage: <span style={{fontSize: "12px"}}>Recursos humanos por página</span>,
                      rowsPerPageOptions: [10, 50, 100],
                    }}
                    positionPagination='bottom'
                    muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                    enableDensityToggle={false}
                    enableColumnFilters={false}
                    muiTableHeadCellProps={{
                      sx: {
                        '.MuiSvgIcon-root': {fontSize: "18px"},
                        fontSize: '12px',
                        fontWeight: 'normal', // Remove bold text in the header
                        padding: '8px', // Adjust padding to reduce white space
                      },
                    }}
                  />
                </TabPanel>
                <TabPanel>
                  <div className='d-flex justify-content-between align-items-center'>
                    <span>Logística</span>
                    <Button
                      size="sm"
                      color="link"
                      className="ml-2 px-0"
                      onClick={(e)=>{
                        setPropItemData({propItemGr_id: 4, propItemGr_label: 'Logística', propEstrut_id: 5});
                        setModalPropItemOpen(true);
                      }}
                    >
                      Adicionar logística
                    </Button>
                  </div>

                  <MaterialReactTable
                    columns={columnsSelectedPropPropItens}
                    data={propostaData.propItens ? propostaData.propItens.filter(pi => Number(pi.propItemGr_id) === 4) : []}
                    initialState={{
                      density: 'compact',
                      expanded: {}, //expand all groups by default
                      pagination: { pageIndex: 0, pageSize: 10 },
                      sorting: [], //sort by state by default,
                    }}
                    enableColumnResizing={true}
                    enableGrouping={false}
                    enableGlobalFilter={true}
                    enableFilters={true}
                    muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                    muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                    muiTablePaginationProps={{
                      sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                      labelRowsPerPage: <span style={{fontSize: "12px"}}>Log?stica por p?gina</span>,
                      rowsPerPageOptions: [10, 50, 100],
                    }}
                    positionPagination='bottom'
                    muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                    enableDensityToggle={false}
                    enableColumnFilters={false}
                    muiTableHeadCellProps={{
                      sx: {
                        '.MuiSvgIcon-root': {fontSize: "18px"},
                        fontSize: '12px',
                        fontWeight: 'normal', // Remove bold text in the header
                        padding: '8px', // Adjust padding to reduce white space
                      },
                    }}
                  />
                </TabPanel>
                <TabPanel>
                  <div className='d-flex justify-content-between align-items-center'>
                    <span>Equipamentos</span>
                    <Button
                      size="sm"
                      color="link"
                      className="ml-2 px-0"
                      onClick={(e)=>{
                        setPropItemData({
                          propItemGr_id: 2,
                          propItemGr_label: 'Equipamentos',
                          propEstrut_id: 4,
                        });
                        setModalPropItemOpen(true);
                      }}
                    >
                      Adicionar equipamentos
                    </Button>
                  </div>

                  <MaterialReactTable
                    columns={columnsSelectedPropPropItens}
                    data={propostaData.propItens ? propostaData.propItens.filter(pi => Number(pi.propItemGr_id) === 2) : []}
                    initialState={{
                      density: 'compact',
                      expanded: {}, //expand all groups by default
                      pagination: { pageIndex: 0, pageSize: 10 },
                      sorting: [], //sort by state by default,
                    }}
                    enableColumnResizing={true}
                    enableGrouping={false}
                    enableGlobalFilter={true}
                    enableFilters={true}
                    muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                    muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                    muiTablePaginationProps={{
                      sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                      labelRowsPerPage: <span style={{fontSize: "12px"}}>Equipamentos por p?gina</span>,
                      rowsPerPageOptions: [10, 50, 100],
                    }}
                    positionPagination='bottom'
                    muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                    enableDensityToggle={false}
                    enableColumnFilters={false}
                    muiTableHeadCellProps={{
                      sx: {
                        '.MuiSvgIcon-root': {fontSize: "18px"},
                        fontSize: '12px',
                        fontWeight: 'normal', // Remove bold text in the header
                        padding: '8px', // Adjust padding to reduce white space
                      },
                    }}
                  />
                </TabPanel>
                <TabPanel>
                  <div className='d-flex justify-content-between align-items-center'>
                    <span>Despesas Gerais</span>
                    <Button
                      size="sm"
                      color="link"
                      className="ml-2 px-0"
                      onClick={(e)=>{
                        setPropItemData({
                          propItemGr_id: 3,
                          propItemGr_label: 'Despesas gerais',
                          propEstrut_id: 6,
                        });
                        setModalPropItemOpen(true);
                      }}
                    >
                      Adicionar despesas gerais
                    </Button>
                  </div>

                  <MaterialReactTable
                    columns={columnsSelectedPropPropItens}
                    data={propostaData.propItens ? propostaData.propItens.filter(pi => Number(pi.propItemGr_id) === 3) : []}
                    initialState={{
                      density: 'compact',
                      expanded: {}, //expand all groups by default
                      pagination: { pageIndex: 0, pageSize: 10 },
                      sorting: [], //sort by state by default,
                    }}
                    enableColumnResizing={true}
                    enableGrouping={false}
                    enableGlobalFilter={true}
                    enableFilters={true}
                    muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                    muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                    muiTablePaginationProps={{
                      sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                      labelRowsPerPage: <span style={{fontSize: "12px"}}>Despesas gerais por p?gina</span>,
                      rowsPerPageOptions: [10, 50, 100],
                    }}
                    positionPagination='bottom'
                    muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                    enableDensityToggle={false}
                    enableColumnFilters={false}
                    muiTableHeadCellProps={{
                      sx: {
                        '.MuiSvgIcon-root': {fontSize: "18px"},
                        fontSize: '12px',
                        fontWeight: 'normal', // Remove bold text in the header
                        padding: '8px', // Adjust padding to reduce white space
                      },
                    }}
                  />
                </TabPanel>
                <TabPanel>
                  <div className='d-flex justify-content-between align-items-center'>
                    <span>Serviços terceirizados</span>
                    <Button
                      size="sm"
                      color="link"
                      className="ml-2 px-0"
                      onClick={(e)=>{
                        setPropItemData({propItemGr_id: 5, propItemGr_label: 'Serviços terceirizados', propEstrut_id: 3});
                        setModalPropItemOpen(true);
                      }}
                    >
                      Adicionar Serviços terceirizados
                    </Button>
                  </div>

                  <MaterialReactTable
                    columns={columnsSelectedPropPropItens}
                    data={propostaData.propItens ? propostaData.propItens.filter(pi => Number(pi.propItemGr_id) === 5) : []}
                    initialState={{
                      density: 'compact',
                      expanded: {}, //expand all groups by default
                      pagination: { pageIndex: 0, pageSize: 10 },
                      sorting: [], //sort by state by default,
                    }}
                    enableColumnResizing={true}
                    enableGrouping={false}
                    enableGlobalFilter={true}
                    enableFilters={true}
                    muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                    muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                    muiTablePaginationProps={{
                      sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                      labelRowsPerPage: <span style={{fontSize: "12px"}}>Subcontrata??es por p?gina</span>,
                      rowsPerPageOptions: [10, 50, 100],
                    }}
                    positionPagination='bottom'
                    muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                    enableDensityToggle={false}
                    enableColumnFilters={false}
                    muiTableHeadCellProps={{
                      sx: {
                        '.MuiSvgIcon-root': {fontSize: "18px"},
                        fontSize: '12px',
                        fontWeight: 'normal', // Remove bold text in the header
                        padding: '8px', // Adjust padding to reduce white space
                      },
                    }}
                  />
                </TabPanel>
              </Tabs>
              <div style={{overflow: 'auto', marginTop: "2rem"}}>
                <TabelaEspacamentoPropItensTemporalEmMeses
                  linhas={propostaData.propItens}
                  chaveCabecalhoLinhas="propItem_desc"
                  chaveAgrupamento="propItemGr_nome"
                  chaveValor="propOrcItem_valor"
                  chaveIdentificador="value"
                  setValoresPorLinhaEColuna={setValoresPorLinhaEColuna}
                  valoresPorLinhaEColuna={valoresPorLinhaEColuna}
                  setQuantidadeColunas={setQuantidadeColunas}
                  quantidadeColunas={quantidadeColunas}
                  handleChangeQuantidadeColunas={handleChangeQuantidadeColunas}
                />
              </div>

              <div style={{ marginTop: "16px" }}>
                <Card>
                  <CardHeader>Resumo por grupo</CardHeader>
                  <CardBody>
                    <Row className="gy-3">
                      <div className="col-12 col-md-6">
                        <small>Recursos humanos</small>
                        <h5 style={{ margin: 0 }}>
                          {currencyFormatter.format(itensOrcamentariosTotaisPorGrupo[1] || 0)}
                        </h5>
                      </div>
                      <div className="col-12 col-md-6">
                        <small>Logística</small>
                        <h5 style={{ margin: 0 }}>
                          {currencyFormatter.format(itensOrcamentariosTotaisPorGrupo[4] || 0)}
                        </h5>
                      </div>
                      <div className="col-12 col-md-6">
                        <small>Equipamentos</small>
                        <h5 style={{ margin: 0 }}>
                          {currencyFormatter.format(itensOrcamentariosTotaisPorGrupo[2] || 0)}
                        </h5>
                      </div>
                      <div className="col-12 col-md-6">
                        <small>Despesas gerais</small>
                        <h5 style={{ margin: 0 }}>
                          {currencyFormatter.format(itensOrcamentariosTotaisPorGrupo[3] || 0)}
                        </h5>
                      </div>
                      <div className="col-12 col-md-6">
                        <small>Serviços terceirizados</small>
                        <h5 style={{ margin: 0 }}>
                          {currencyFormatter.format(itensOrcamentariosTotaisPorGrupo[5] || 0)}
                        </h5>
                      </div>
                      <div className="col-12 col-md-6">
                        <small><strong>Custo Total</strong></small>
                        <h5 style={{ margin: 0 }}>
                          {currencyFormatter.format(custoTotalResumoPorGrupo || 0)}
                        </h5>
                      </div>
                    </Row>
                  </CardBody>
                </Card>
              </div>
            </TabPanel>
            <TabPanel>
              <div className='d-flex justify-content-between align-items-center' style={{width: "100%", position: "relative", zIndex: 2}}>
                <div
                  style={{
                    display: 'flex',
                    gap: '12px',
                    width: '100%',
                    alignItems: 'stretch',
                  }}
                >
                  <Button
                    type="button"
                    color="primary"
                    onClick={adicionarProdutosPorQuantidade}
                    style={{
                      alignSelf: 'stretch',
                      minWidth: '52px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: 0,
                      borderRadius: '10px',
                      fontSize: '28px',
                      lineHeight: 1,
                      fontWeight: 500,
                    }}
                    title="Adicionar por quantidade"
                  >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                      <path
                        d="M10 4V16M4 10H16"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </Button>
                  <div
                    style={{
                      flex: 1,
                      display: 'grid',
                      gridTemplateColumns: frequenciaProdutosQuantidade?.value === 'unico'
                        ? 'repeat(2, minmax(0, 1fr))'
                        : 'repeat(3, minmax(0, 1fr))',
                      gap: '10px 12px',
                      alignItems: 'center',
                    }}
                  >
                    <Input
                      type="text"
                      placeholder="Descrição padrão"
                      value={descricaoPadraoProdutosQuantidade}
                      onChange={(e) => setDescricaoPadraoProdutosQuantidade(e.target.value)}
                    />
                    {frequenciaProdutosQuantidade?.value !== 'unico' && (
                      <Input
                        type="number"
                        min={1}
                        step={1}
                        placeholder="Qtd de produtos p/ período selecionado"
                        value={qtdProdutosParaAdicionar}
                        onChange={(e) => setQtdProdutosParaAdicionar(e.target.value)}
                        onWheel={(e) => {
                          e.target.blur();
                        }}
                      />
                    )}
                    <Input
                      type="number"
                      min={0}
                      step={1}
                      placeholder="Prazo inicial (dias)"
                      value={prazoInicialProdutosQuantidade}
                      onChange={(e) => setPrazoInicialProdutosQuantidade(e.target.value)}
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                    />
                    <div
                      style={{
                        minHeight: '38px',
                        paddingLeft: '2rem',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        flexWrap: 'wrap',
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <Input
                          id="produtos-com-eventos-pagamento"
                          type="checkbox"
                          checked={Boolean(produtosComEventosPagamento)}
                          onChange={(e) => setProdutosComEventosPagamento(e.target.checked)}
                          style={{ marginRight: '8px' }}
                        />
                        <label htmlFor="produtos-com-eventos-pagamento" style={{ marginBottom: 0 }}>
                          Criar evento de pagamento automático
                        </label>
                      </div>
                      {produtosComEventosPagamento && (
                        <Input
                          type="number"
                          min={0}
                          step="0.01"
                          placeholder="Percentual dos eventos (%)"
                          value={percentualEventosProdutosQuantidade}
                          onChange={(e) => setPercentualEventosProdutosQuantidade(e.target.value)}
                          onWheel={(e) => {
                            e.target.blur();
                          }}
                          style={{ maxWidth: '220px' }}
                        />
                      )}
                    </div>
                    <div
                      style={{
                        gridColumn: frequenciaProdutosQuantidade?.value === 'unico' ? 'span 1' : 'span 2',
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '8px',
                        alignItems: 'center',
                      }}
                    >
                      {opcoesFrequenciaQuantidade.map((opcao) => {
                        const isSelected = frequenciaProdutosQuantidade?.value === opcao.value;
                        return (
                          <button
                            key={opcao.value}
                            type="button"
                            onClick={() => setFrequenciaProdutosQuantidade(opcao)}
                            style={{
                              border: isSelected ? '1px solid #111827' : '1px solid #ced4da',
                              backgroundColor: isSelected ? '#111827' : '#ffffff',
                              color: isSelected ? '#ffffff' : '#495057',
                              borderRadius: '8px',
                              padding: '8px 12px',
                              fontSize: '12px',
                              fontWeight: 600,
                              lineHeight: 1,
                              cursor: 'pointer',
                            }}
                          >
                            {opcao.label}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
              <div style={{paddingTop: '2rem'}}>
                <MaterialReactTable
                  columns={columnsSelectedProdsProp}
                  data={propostaData.prodsProp ? propostaData.prodsProp : []}
                  initialState={{
                    density: 'compact',
                    expanded: {}, //expand all groups by default
                    sorting: [], //sort by state by default,
                  }}
                  state={{ pagination: prodsPropPagination }}
                  onPaginationChange={setProdsPropPagination}
                  autoResetPageIndex={false}
                  enableColumnResizing={true}
                  enableGrouping={false}
                  enableGlobalFilter={true}
                  enableFilters={true}
                  muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                  muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                  muiTablePaginationProps={{
                    sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                    labelRowsPerPage: <span style={{fontSize: "12px"}}>Produtos por página</span>,
                    rowsPerPageOptions: [10, 50, 100],
                  }}
                  positionPagination='bottom'
                  muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                  enableDensityToggle={false}
                  enableColumnFilters={false}
                  /* enableExpanding={true}
                  renderDetailPanel={({ row }) => {
                    const rowData = row.original || {};
                    const selectedEventos = (rowData.eventosPagamentoProp || [])
                      .map(normalizeEventoPagamentoPropOption)
                      .filter(Boolean);

                    return (
                      <div style={{ padding: "12px 16px", background: "#fafafa" }}>
                        <FormGroup style={{ marginBottom: 0 }}>
                          <span style={{ display: "block", marginBottom: "8px", fontSize: "13px" }}>
                            Vincular eventos de pagamento ao produto
                          </span>
                          <Select
                            className="basic-single"
                            classNamePrefix="select"
                            isClearable={true}
                            isSearchable={true}
                            isMulti
                            options={eventosPagamentoPropOptions}
                            value={selectedEventos}
                            onChange={(selected) => {
                              const selectedEventosPagamentoProp = (selected || [])
                                .map(normalizeEventoPagamentoPropOption)
                                .filter(Boolean);

                              const currentRowKey = getProdPropRowKey(rowData);
                              const selectedEventoKeys = new Set(
                                selectedEventosPagamentoProp.map((evento) => getEventoPagamentoPropRowKey(evento)).filter(Boolean)
                              );
                              setPropostaData((prev) => ({
                                ...prev,
                                prodsProp: (prev.prodsProp || []).map((prodProp) => {
                                  const prodPropKey = getProdPropRowKey(prodProp);
                                  const isCurrentRow =
                                    (currentRowKey && prodPropKey && currentRowKey === prodPropKey) ||
                                    prodProp === rowData;

                                  if (!isCurrentRow) return prodProp;

                                  return {
                                    ...prodProp,
                                    eventosPagamentoProp: selectedEventosPagamentoProp,
                                  };
                                }),
                                eventosPagamentoProp: (prev.eventosPagamentoProp || []).map((eventoPagamentoProp) => {
                                  const eventoKey = getEventoPagamentoPropRowKey(eventoPagamentoProp);
                                  if (!eventoKey) return eventoPagamentoProp;

                                  const currentEventoProds = (eventoPagamentoProp.prodsProp || [])
                                    .map(normalizeProdPropOption)
                                    .filter(Boolean);
                                  const currentEventoProdKeys = new Set(
                                    currentEventoProds.map((prod) => getProdPropRowKey(prod)).filter(Boolean)
                                  );

                                  if (selectedEventoKeys.has(eventoKey)) {
                                    if (currentRowKey) currentEventoProdKeys.add(currentRowKey);
                                  } else {
                                    if (currentRowKey) currentEventoProdKeys.delete(currentRowKey);
                                  }

                                  const normalizedProds = (prev.prodsProp || [])
                                    .map(normalizeProdPropOption)
                                    .filter((prod) => {
                                      const prodKey = getProdPropRowKey(prod);
                                      return prodKey && currentEventoProdKeys.has(prodKey);
                                    });

                                  return {
                                    ...eventoPagamentoProp,
                                    prodsProp: normalizedProds,
                                  };
                                }),
                              }));
                            }}
                          />
                        </FormGroup>
                      </div>
                    );
                  }} */
                  muiTableHeadCellProps={{
                    sx: {
                      '.MuiSvgIcon-root': {fontSize: "18px"},
                      fontSize: '12px',
                      fontWeight: 'normal', // Remove bold text in the header
                      padding: '8px', // Adjust padding to reduce white space
                    },
                  }}
                />
              </div>
            </TabPanel>
            <TabPanel>
              <div className='d-flex justify-content-between align-items-center' style={{width: "100%", position: "relative", zIndex: 2}}>
                <div
                  style={{
                    display: 'flex',
                    gap: '12px',
                    width: '100%',
                    alignItems: 'stretch',
                  }}
                >
                  <Button
                    type="button"
                    color="primary"
                    onClick={adicionarEventosPagamentoPorQuantidade}
                    style={{
                      alignSelf: 'stretch',
                      minWidth: '52px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: 0,
                      borderRadius: '10px',
                    }}
                    title="Adicionar por quantidade"
                  >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                      <path
                        d="M10 4V16M4 10H16"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </Button>
                  <div
                    style={{
                      flex: 1,
                      display: 'grid',
                      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                      gap: '10px 12px',
                      alignItems: 'center',
                    }}
                  >
                    <Input
                      type="text"
                      placeholder="Descrição padrão"
                      value={descricaoPadraoEventosQuantidade}
                      onChange={(e) => setDescricaoPadraoEventosQuantidade(e.target.value)}
                    />
                    <Input
                      type="number"
                      min={0}
                      step="0.01"
                      placeholder="Valor padrão (%)"
                      value={valorPadraoEventosQuantidade}
                      onChange={(e) => setValorPadraoEventosQuantidade(e.target.value)}
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                    />
                    <Input
                      type="number"
                      min={1}
                      step={1}
                      placeholder="Qtd de eventos p/ período selecionado"
                      value={qtdEventosPagamentoParaAdicionar}
                      onChange={(e) => setQtdEventosPagamentoParaAdicionar(e.target.value)}
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                    />
                    <Input
                      type="number"
                      min={0}
                      step={1}
                      placeholder="Prazo inicial (dias)"
                      value={prazoInicialEventosQuantidade}
                      onChange={(e) => setPrazoInicialEventosQuantidade(e.target.value)}
                      onWheel={(e) => {
                        e.target.blur();
                      }}
                    />
                    <div
                      style={{
                        gridColumn: 'span 2',
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '8px',
                        alignItems: 'center',
                      }}
                    >
                      {opcoesFrequenciaQuantidade.map((opcao) => {
                        const isSelected = frequenciaEventosQuantidade?.value === opcao.value;
                        return (
                          <button
                            key={opcao.value}
                            type="button"
                            onClick={() => setFrequenciaEventosQuantidade(opcao)}
                            style={{
                              border: isSelected ? '1px solid #111827' : '1px solid #ced4da',
                              backgroundColor: isSelected ? '#111827' : '#ffffff',
                              color: isSelected ? '#ffffff' : '#495057',
                              borderRadius: '8px',
                              padding: '8px 12px',
                              fontSize: '12px',
                              fontWeight: 600,
                              lineHeight: 1,
                              cursor: 'pointer',
                            }}
                          >
                            {opcao.label}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
              <div style={{overflow: 'visible'}}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    marginTop: '12px',
                    marginBottom: '8px',
                    fontSize: '13px',
                    fontWeight: 600,
                  }}
                >
                  Soma dos eventos de pagamento: {formatPercent(somaPercentualEventosPagamento)}
                </div>
                <MaterialReactTable
                  columns={columnsSelectedEventosPagamentoProp}
                  data={propostaData.eventosPagamentoProp ? propostaData.eventosPagamentoProp : []}
                  initialState={{
                    density: 'compact',
                    expanded: {}, //expand all groups by default
                    sorting: [], //sort by state by default,
                  }}
                  state={{ pagination: eventosPagamentoPagination }}
                  onPaginationChange={setEventosPagamentoPagination}
                  autoResetPageIndex={false}
                  enableColumnResizing={true}
                  enableGrouping={false}
                  enableGlobalFilter={true}
                  enableFilters={true}
                  muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                  muiTableBodyCellProps={{sx: {fontSize: "13px", overflow: 'visible !important'}}}
                  muiTablePaginationProps={{
                    sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px",},
                    labelRowsPerPage: <span style={{fontSize: "12px"}}>Eventos por página</span>,
                    rowsPerPageOptions: [10, 50, 100],
                  }}
                  muiTableContainerProps={{sx: {overflow: 'visible !important'}}}
                  positionPagination='bottom'
                  muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                  enableDensityToggle={false}
                  enableColumnFilters={false}
                  enableExpanding={true}
                  renderDetailPanel={({ row }) => {
                    const rowData = row.original || {};
                    const isEventoTipoProduto = Number(rowData?.recTp_id) === 1;
                    const selectedProds = (rowData.prodsProp || [])
                      .map(normalizeProdPropOption)
                      .filter(Boolean);
                    const selectedProdsValue = isEventoTipoProduto
                      ? (selectedProds[0] || null)
                      : selectedProds;

                    return (
                      <div style={{ padding: "12px 16px", background: "#fafafa" }}>
                        <FormGroup style={{ marginBottom: 0 }}>
                          <span style={{ display: "block", marginBottom: "8px", fontSize: "13px" }}>
                            Vincular produtos ao evento de pagamento
                          </span>
                          <div
                            onClick={() => {
                              const menus = document.querySelectorAll('.select__menu')
                              menus.forEach(menu => {
                                menu.style.zIndex = "100"
                              })
                            }}
                          >
                            <Select
                              className="basic-single"
                              classNamePrefix="select"
                              isClearable={true}
                              isSearchable={true}
                              isMulti={!isEventoTipoProduto}
                              options={prodsPropOptions}
                              value={selectedProdsValue}
                              onChange={(selected) => {
                                const selectedItems = Array.isArray(selected)
                                  ? selected
                                  : (selected ? [selected] : []);
                                const selectedProdsProp = selectedItems
                                  .map(normalizeProdPropOption)
                                  .filter(Boolean);
                                const selectedProdsPropFinal = isEventoTipoProduto
                                  ? selectedProdsProp.slice(0, 1)
                                  : selectedProdsProp;

                                const currentRowKey = getEventoPagamentoPropRowKey(rowData);
                                const selectedProdKeys = new Set(
                                  selectedProdsPropFinal.map((prod) => getProdPropRowKey(prod)).filter(Boolean)
                                );
                                setPropostaData((prev) => ({
                                  ...prev,
                                  eventosPagamentoProp: (prev.eventosPagamentoProp || []).map((eventoPagamentoProp) => {
                                    const eventoPagamentoPropKey = getEventoPagamentoPropRowKey(eventoPagamentoProp);
                                    const isCurrentRow =
                                      (currentRowKey && eventoPagamentoPropKey && currentRowKey === eventoPagamentoPropKey) ||
                                      eventoPagamentoProp === rowData;

                                    if (!isCurrentRow) return eventoPagamentoProp;

                                    return {
                                      ...eventoPagamentoProp,
                                      prodsProp: selectedProdsPropFinal,
                                    };
                                  }),
                                  prodsProp: (prev.prodsProp || []).map((prodProp) => {
                                    const prodKey = getProdPropRowKey(prodProp);
                                    if (!prodKey) return prodProp;

                                    const currentProdEventos = (prodProp.eventosPagamentoProp || [])
                                      .map(normalizeEventoPagamentoPropOption)
                                      .filter(Boolean);
                                    const currentProdEventoKeys = new Set(
                                      currentProdEventos.map((evento) => getEventoPagamentoPropRowKey(evento)).filter(Boolean)
                                    );

                                    if (selectedProdKeys.has(prodKey)) {
                                      if (currentRowKey) currentProdEventoKeys.add(currentRowKey);
                                    } else {
                                      if (currentRowKey) currentProdEventoKeys.delete(currentRowKey);
                                    }

                                    const normalizedEventos = (prev.eventosPagamentoProp || [])
                                      .map(normalizeEventoPagamentoPropOption)
                                      .filter((evento) => {
                                        const eventoKey = getEventoPagamentoPropRowKey(evento);
                                        return eventoKey && currentProdEventoKeys.has(eventoKey);
                                      });

                                    return {
                                      ...prodProp,
                                      eventosPagamentoProp: normalizedEventos,
                                    };
                                  }),
                                }));
                              }}
                            />
                          </div>
                        </FormGroup>
                      </div>
                    );
                  }}
                  muiTableHeadCellProps={{
                    sx: {
                      '.MuiSvgIcon-root': {fontSize: "18px"},
                      fontSize: '12px',
                      fontWeight: 'normal', // Remove bold text in the header
                      padding: '8px', // Adjust padding to reduce white space
                    },
                  }}
                />
              </div>
              {/* <div style={{overflow: 'auto', marginTop: "2rem"}}>
                <TabelaEspacamentoEventosPagamentoPropTemporalEmMeses
                  linhas={propostaData.eventosPagamentoProp}
                  valorTotal={precoFinalPropostaAtual}
                  chaveCabecalhoLinhas="eventoPagamentoProp_nome"
                  chaveValor="eventoPagamentoProp_vlr"
                  chaveIdentificador="value"
                  setValoresPorLinhaEColuna={setValoresPorLinhaEColuna}
                  valoresPorLinhaEColuna={valoresPorLinhaEColuna}
                  setQuantidadeColunas={setQuantidadeColunas}
                  quantidadeColunas={quantidadeColunas}
                  handleChangeQuantidadeColunas={handleChangeQuantidadeColunas}
                />
              </div> */}
              <div style={{ marginTop: '2rem' }}>
                <Card>
                  <CardHeader>
                    Receitas por evento de pagamento
                  </CardHeader>
                  <CardBody>
                    <TemporalStackedBarChart
                      data={eventosPagamentoTemporalChartData}
                      valueKey="eventoPagamentoProp_valorCalculado"
                      labelKey="eventoPagamentoProp_nome"
                      axisLabel="Receitas (R$)"
                      timeKeyType="month"
                      height={320}
                      totalColumns={quantidadeColunas}
                      yLabel={'Receitas'}
                    />
                  </CardBody>
                </Card>
              </div>
            </TabPanel>
          </Tabs>
        </>
  );

  const TABS = [
    /* {
      id: "tab-1",
      label: "Informações gerais",
      subtitle: "Dados gerais da proposta",
      content: (
        <div>
          <h2>Informações gerais</h2>
          <p><strong>Tipo (a definir):</strong> {propostaData?.servico_nome || "Sem Tipo"}</p>
          <div className="d-flex align-items-center mb-2">
            <strong className="mr-2">Serviço:</strong>
            {!isEditingInfoServico ? (
              <>
                <span>{propostaData?.servico_nome || "Sem serviço"}</span>
                <Button
                  size="sm"
                  color="link"
                  className="ml-2 p-0"
                  onClick={() => setIsEditingInfoServico(true)}
                >
                  Editar
                </Button>
              </>
            ) : (
              <div className="d-flex align-items-center" style={{ minWidth: 340 }}>
                <div style={{width: "30rem"}}>
                  <Select
                    options={servicos}
                    value={servicos.find((servico) => Number(servico?.value) === Number(propostaData?.servico_id)) || null}
                    onChange={(servicoSelecionado) => {
                      setPropostaData((prev) => ({
                        ...prev,
                        servico_id: servicoSelecionado?.value ?? null,
                        servico_nome: servicoSelecionado?.label ?? null,
                      }));
                    }}
                  />
                </div>
                <Button
                  size="sm"
                  color="link"
                  className="ml-2 p-0"
                  onClick={() => {
                    console.log(propostaData.servico_id)
                    setIsEditingInfoServico(false)
                  }}
                >
                  Concluir
                </Button>
              </div>
            )}
          </div>
          <div className="d-flex align-items-center mb-2">
            <strong className="mr-2">Prazo para envio:</strong>
            {!isEditingInfoPrazoEnvio ? (
              <>
                <span>{propostaData.prop_prazoEnvio ? moment(propostaData.prop_prazoEnvio).format('DD/MM/YYYY') : "Sem prazo definido"}</span>
                <Button
                  size="sm"
                  color="link"
                  className="ml-2 p-0"
                  onClick={() => setIsEditingInfoPrazoEnvio(true)}
                >
                  Editar
                </Button>
              </>
            ) : (
              <div className="d-flex align-items-center">
                <Input
                  type="date"
                  value={propostaData.prop_prazoEnvio}
                  onChange={(e) => setPropostaData((prev) => ({ ...prev, prop_prazoEnvio: e.target.value }))}
                />
                <Button
                  size="sm"
                  color="link"
                  className="ml-2 p-0"
                  onClick={() => {
                    console.log(propostaData.prop_prazoEnvio)
                    setIsEditingInfoPrazoEnvio(false)
                  }}
                >
                  Concluir
                </Button>
              </div>
            )}
          </div>
          <p><strong>Cliente:</strong> {propostaData?.pj_nomefanta || "Sem cliente"}</p>
          <p><strong>ID do bitrix:</strong> {propostaData?.bitrix_id || "Sem ID"}</p>
          <p><strong>Data de abertura :</strong> {propostaData?.prop_dtCria ? moment(propostaData?.prop_dtCria).format('DD/MM/YYYY') : "Sem data"}</p>
          <p><strong>Status:</strong> {propostaData?.propStatus_nome || "Sem status"}</p>
        </div>
      ),
    }, */
    {
      id: "tab-itens-orcamentarios",
      label: "Itens Orçamentários",
      subtitle: "Defina os itens orçamentários da proposta",
      content: renderEntidadesPropostaContent(0),
    },
    {
      id: "tab-produtos",
      label: "Produtos",
      subtitle: "Defina os produtos da proposta",
      content: renderEntidadesPropostaContent(1),
    },
    {
      id: "tab-eventos-pagamento",
      label: "Eventos de pagamento",
      subtitle: "Defina os eventos de pagamento da proposta",
      content: renderEntidadesPropostaContent(2),
    },
    {
      id: "tab-3",
      label: "Visão geral",
      subtitle: "Resumo dos itens",
      content: (
        <div className="orcamento-content-panel">
          <Card style={{marginTop: "2rem"}}>
            <CardHeader>
              Total de itens selecionados
            </CardHeader>
            <CardBody>
              <Row className="gy-3">
                <div className="col-12 col-md-6">
                  <FormGroup>
                    <span>TAXA ENCARGOS (%)</span>
                    <MaskedInput
                      unmask
                      mask="num %"
                      blocks={{
                        num: {
                          mask: Number,
                          scale: 2,
                          signed: false,
                          thousandsSeparator: '.',
                          padFractionalZeros: false,
                          normalizeZeros: false,
                          radix: ',',
                          min: 0,
                          max: 100,
                        },
                      }}
                      lazy={false}
                      value={String(visaoGeralPercentuais.taxaEncargos ?? "")}
                      onAccept={(value) => {
                        setVisaoGeralPercentuais((prev) => ({
                          ...prev,
                          taxaEncargos: parseNumericValue(value) || 0,
                        }));
                      }}
                    />
                  </FormGroup>
                </div>

                <div className="col-12 col-md-6">
                  <FormGroup>
                    <span>TAXA ADMINISTRATIVA (%)</span>
                    <MaskedInput
                      unmask
                      mask="num %"
                      blocks={{
                        num: {
                          mask: Number,
                          scale: 2,
                          signed: false,
                          thousandsSeparator: '.',
                          padFractionalZeros: false,
                          normalizeZeros: false,
                          radix: ',',
                          min: 0,
                          max: 100,
                        },
                      }}
                      lazy={false}
                      value={String(visaoGeralPercentuais.taxaAdministrativa ?? "")}
                      onAccept={(value) => {
                        setVisaoGeralPercentuais((prev) => ({
                          ...prev,
                          taxaAdministrativa: parseNumericValue(value) || 0,
                        }));
                      }}
                    />
                  </FormGroup>
                </div>

                <div className="col-12 col-md-6">
                  <FormGroup>
                    <span>TAXA LUCRO (%)</span>
                    <MaskedInput
                      unmask
                      mask="num %"
                      blocks={{
                        num: {
                          mask: Number,
                          scale: 2,
                          signed: false,
                          thousandsSeparator: '.',
                          padFractionalZeros: false,
                          normalizeZeros: false,
                          radix: ',',
                          min: 0,
                          max: 100,
                        },
                      }}
                      lazy={false}
                      value={String(visaoGeralPercentuais.taxaLucro ?? "")}
                      onAccept={(value) => {
                        setVisaoGeralPercentuais((prev) => ({
                          ...prev,
                          taxaLucro: parseNumericValue(value) || 0,
                        }));
                      }}
                    />
                  </FormGroup>
                </div>

                <div className="col-12 col-md-6">
                  <FormGroup>
                    <span>TAXA IMPOSTOS (%)</span>
                    <MaskedInput
                      unmask
                      mask="num %"
                      blocks={{
                        num: {
                          mask: Number,
                          scale: 2,
                          signed: false,
                          thousandsSeparator: '.',
                          padFractionalZeros: false,
                          normalizeZeros: false,
                          radix: ',',
                          min: 0,
                          max: 100,
                        },
                      }}
                      lazy={false}
                      value={String(visaoGeralPercentuais.taxaImpostos ?? "")}
                      onAccept={(value) => {
                        setVisaoGeralPercentuais((prev) => ({
                          ...prev,
                          taxaImpostos: parseNumericValue(value) || 0,
                        }));
                      }}
                    />
                  </FormGroup>
                </div>

                <div className="col-12 col-md-6">
                  <FormGroup>
                    <span>TAXA COMISSAO (%)</span>
                    <MaskedInput
                      unmask
                      mask="num %"
                      blocks={{
                        num: {
                          mask: Number,
                          scale: 2,
                          signed: false,
                          thousandsSeparator: '.',
                          padFractionalZeros: false,
                          normalizeZeros: false,
                          radix: ',',
                          min: 0,
                          max: 100,
                        },
                      }}
                      lazy={false}
                      value={String(visaoGeralPercentuais.taxaComissao ?? "")}
                      onAccept={(value) => {
                        setVisaoGeralPercentuais((prev) => ({
                          ...prev,
                          taxaComissao: parseNumericValue(value) || 0,
                        }));
                      }}
                    />
                  </FormGroup>
                </div>

                <div className="col-12 col-md-6">
                  <FormGroup>
                    <span>CUSTO FINANCEIRO (%)</span>
                    <MaskedInput
                      unmask
                      mask="num %"
                      disabled
                      blocks={{
                        num: {
                          mask: Number,
                          scale: 2,
                          signed: false,
                          thousandsSeparator: '.',
                          padFractionalZeros: false,
                          normalizeZeros: false,
                          radix: ',',
                          min: 0,
                          max: 100,
                        },
                      }}
                      lazy={false}
                      value={String(visaoGeralPercentuais.custoFinanceiro ?? "")}
                      onAccept={(value) => {
                        setVisaoGeralPercentuais((prev) => ({
                          ...prev,
                          custoFinanceiro: parseNumericValue(value) || 0,
                        }));
                      }}
                    />
                  </FormGroup>
                </div>
              </Row>
            </CardBody>
          </Card>

          {/* <div style={{ marginTop: '0.5rem', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontWeight: 600 }}>Subtotal do projeto</span>
            <span>{currencyFormatter.format(visaoGeralSubtotalProjeto || 0)}</span>
          </div>
          <div style={{ marginTop: '0.75rem', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontWeight: 600 }}>Custos diretos</span>
            <span>{currencyFormatter.format(visaoGeralTotal || 0)}</span>
          </div>
          <div style={{ marginTop: '0.5rem', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontWeight: 600 }}>Encargos sociais</span>
            <span>{currencyFormatter.format(visaoGeralValorTaxaEncargos || 0)}</span>
          </div>
          <div style={{ marginTop: '0.5rem', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontWeight: 600 }}>Base de custos</span>
            <span>{currencyFormatter.format((visaoGeralTotal + visaoGeralValorTaxaEncargos) || 0)}</span>
          </div>
          <div style={{ marginTop: '0.75rem', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontWeight: 600 }}>Custo administrativo</span>
            <span>{currencyFormatter.format(visaoGeralCustoAdministrativo || 0)}</span>
          </div>
          <div style={{ marginTop: '0.5rem', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontWeight: 600 }}>Custo operacional</span>
            <span>{currencyFormatter.format(visaoGeralCustoOperacional || 0)}</span>
          </div>
          <div style={{ marginTop: '0.5rem', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontWeight: 600 }}>Lucro desejado</span>
            <span>{currencyFormatter.format(visaoGeralLucroDesejado || 0)}</span>
          </div>
          <div style={{ marginTop: '0.5rem', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontWeight: 600 }}>Subtotal do projeto</span>
            <span>{currencyFormatter.format(visaoGeralSubtotalProjeto || 0)}</span>
          </div>
          <div style={{ marginTop: '0.5rem', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <span
              style={{ fontWeight: 600 }}
              onClick={
                () => console.log(visaoGeralSubtotalProjeto, visaoGeralTotal, visaoGeralValorTaxaEncargos, visaoGeralPercentuais)
              }
            >
                Margem de contribuição
            </span>
            <span>
              { (visaoGeralSubtotalProjeto && visaoGeralTotal) ?
                ((((visaoGeralSubtotalProjeto/(1-(visaoGeralPercentuais.taxaImpostos+visaoGeralPercentuais.taxaComissao)/100)) - (visaoGeralTotal + visaoGeralValorTaxaEncargos) - (visaoGeralPercentuais.taxaImpostos/100 * (visaoGeralSubtotalProjeto/(1-(visaoGeralPercentuais.taxaImpostos+visaoGeralPercentuais.taxaComissao)/100))))/(visaoGeralSubtotalProjeto/(1-(visaoGeralPercentuais.taxaImpostos+visaoGeralPercentuais.taxaComissao)/100)))*100).toFixed(2) + " %"
                : 0 + " %"
              }
            </span>
          </div>
          <div style={{ marginTop: '0.5rem', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontWeight: 600 }}>Preço da proposta</span>
            <span>{currencyFormatter.format(visaoGeralPrecoProposta || 0)}</span>
          </div> */}

          <div style={{ overflow: 'auto', marginTop: '2rem' }}>
            <TabelaCruzamentoFluxoMensalPropTemporalEmMeses
              linhasGastos={propostaData.propItens}
              linhasIncome={propostaData.eventosPagamentoProp}
              valoresPorLinhaEColuna={valoresPorLinhaEColuna}
              quantidadeColunas={quantidadeColunas}
              valorTotalIncome={visaoGeralPrecoProposta}
              valorTotalCustoOperacional={visaoGeralCustoOperacional}
              visaoGeralValorTaxaEncargos={visaoGeralValorTaxaEncargos}
              custosSemEncargos={(visaoGeralTotal - visaoGeralValorTaxaEncargos) || 0}
              valorTotalLucroDesejado={visaoGeralLucroDesejado}
              percentualDespesasFiscais={visaoGeralPercentuais?.taxaImpostos}
              percentualComissao={visaoGeralPercentuais?.taxaComissao}
              percentualCustoFinanceiro={visaoGeralPercentuais?.custoFinanceiro}
              percentualTaxaAdministrativa={visaoGeralPercentuais?.taxaAdministrativa}
              percentualTaxaLucro={visaoGeralPercentuais?.taxaLucro}
              percentualTaxaEncargos={visaoGeralPercentuais?.taxaEncargos}
              chaveValorGasto="propOrcItem_valor"
              chaveValorIncome="eventoPagamentoProp_vlr"
              chavePrazoIncome="eventoPagamentoProp_prazoPgto"
              chaveIdentificadorGasto="value"
              setPrecoFinalProposta={setPrecoFinalPropostaTabela}
            />
          </div>
        </div>
      ),
    },
  ];

  const activeTab = TABS.find((tab) => tab.id === activeId) || TABS[0];
  const nomeProposta = propostaData?.prop_nome || 'Sem Bitrix ID';

  const infoHeaderTopItems = [
    {
      label: 'Serviço',
      value: propostaData?.servico_nome || 'Sem serviço',
    },
    {
      label: 'Cliente',
      value: propostaData?.pj_nomefanta || 'Sem cliente',
    },
    {
      label: 'Prazo de envio',
      value: propostaData?.negociacao_prazo
        ? moment(propostaData.negociacao_prazo).format('DD/MM/YYYY')
        : 'Sem prazo',
    },
  ];

  const infoHeaderBottomItems = [
    {
      label: 'Preço final',
      value: currencyFormatter.format(
        precoFinalPropostaAtual
      ),
      highlight: true,
    },
    {
      label: 'Margem de cont.',
      value: resumoValoresProposta.margemContribuicao || '0 %',
    },
    {
      label: 'Soma dos eventos de pagamento',
      value: formatPercent(somaPercentualEventosPagamento),
    },
  ];

  const fetchProdsProp = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'prodProp',
        data: {
          prodProp_ativo: 1,
        },
        fields: {
          prodProp_id: 'value',
          prodProp_nome: 'label'
        }
      })}`
    )

    setProdsProp(res.data);
  }

  const fetchEventosPagamento = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'eventoPagamentoProp',
        data: {
          eventoPagamentoProp_ativo: 1,
        },
        fields: {
          eventoPagamentoProp_id: 'value',
          eventoPagamentoProp_nome: 'label'
        }
      })}`
    )

    setEventosPagamentoProp(res.data);
  }

  const handleSaveValorRef = async (data) => {
    const propOrcItemBody = {
      action: 'update',
      table: 'propItem',
      data: {
        propItem_id: data.propItem_id,
        propItem_refVlr: data.propOrcItem_valor,
        propItem_usuarioCria: user.pf_id,
        propItem_usuarioMod: user.pf_id,
      },
    };

    await oikosApi.post('/', propOrcItemBody);

    notifySuccess('Valor atualizado com sucesso')

    fetchItensOrcamentarios();
    setOpenModalSalvarValorRef(false);
  }

  const fetchItensOrcamentarios = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'propItem',
        data: {
          propItem_ativo: 1,
        },
        fields: {
          propItem_id : "value",
          propItem_desc: 'label',
          "(SELECT propItemGr_nome FROM propItemGr WHERE propItemGr_id = propItem.propItemGr_id)" : "propItemGr_nome"
        }
      })}`
    )

    const propItensFromRes = res.data || [];
    const profissoesUnicasFromRes = Array.from(
      new Map(
        propItensFromRes
          .map(item => [(item.propItem_desc ?? item.label), item]) // key = propItem_desc
      ).values()
    );

    setPropItens(propItensFromRes);
    setPropItensUnicos(profissoesUnicasFromRes);
    console.log('Prop Itens:', propItensFromRes);
    console.log('Profissões únicas:', profissoesUnicasFromRes);
    return {
      propItens: propItensFromRes,
      propItensUnicos: profissoesUnicasFromRes,
    };
  }

  const fetchServicos = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'servico',
        data: {
          servico_ativo: 1,
        },
        fields: {
          servico_id: 'value',
          servico_nome: 'label'
        }
      })}`
    )

    setServicos([...res.data]);
  }

  const fetchIndicacaoCentroDeCustoForSelect = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'orcRubr',
        data: {
          orcRubr_ativo: 1,
          orcRubr_mae: '!IN!(1, 2)',
        },
        fields: {
          orcRubr_id: 'value',
          orcRubr_nome: 'label',
        },
        order: 'label',
      })}`
    );

    const sortedCentrosDeCusto = (res?.data || []).sort((a, b) => {
      if (a.label < b.label) return -1;
      if (a.label > b.label) return 1;
      return 0;
    });

    setIndicacaoSelCentroDeCusto(sortedCentrosDeCusto);
  };

  const fetchIndicacaoOrcItemsForSelect = async (centroId) => {
    if (!centroId) {
      setIndicacaoSelOrcItems([]);
      return;
    }

    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'viewRubr_OrcItem',
        fields: {
          orcItem_id: 'value',
          item_orcamentario: 'label',
          nivel2_id: 'cc_id',
          nivel2: 'cc_nome',
        },
        data: {
          orcItem_ativo: 1,
          nivel2_id: centroId,
        },
        order: 'label',
      })}`
    );

    setIndicacaoSelOrcItems(res?.data || []);
  };

  const getIndicacaoOrcDots = async (orcItemId) => {
    if (!orcItemId) {
      setIndicacaoListaDotacoes([]);
      setIndicacaoValoresLimites([]);
      return;
    }

    const resOrcDots = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'orcDot',
      data: {
        orcItem_id: orcItemId,
        orcDot_ativo: 1,
      },
    })}`);

    setIndicacaoListaDotacoes(resOrcDots?.data || []);

    const verificaBody = {
      acao: 'verificar_disponibilidade_orcItem',
      orcItem_id: orcItemId,
    };

    const res = await powerAppsApi.post('/', verificaBody, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    });

    setIndicacaoValoresLimites(res?.data || []);
  };

  const hasIndicacaoPedidoCompraData = (indicacao = {}) => {
    if (!indicacao || typeof indicacao !== 'object') return false;

    const descricao = String(indicacao?.pedidoCompra_desc ?? '').trim();
    const valorLimite = parseNumericValue(indicacao?.pedidoCompra_vlrLimite);
    const pedidoCompraId = Number(indicacao?.pedidoCompra_id) || 0;
    const cotacoesManuais = Array.isArray(indicacao?.cotacoesManuais)
      ? indicacao.cotacoesManuais
      : [];

    return Boolean(
      descricao
      || pedidoCompraId
      || (valorLimite !== null && valorLimite > 0)
      || cotacoesManuais.length > 0
    );
  };

  const fetchCompraCotacoesIndicacaoByPedidoCompraId = async (pedidoCompraId) => {
    const pedidoCompraIdNormalizado = Number(pedidoCompraId) || 0;
    if (!pedidoCompraIdNormalizado) return [];

    const response = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'compraCotacao',
      data: {
        pedidoCompra_id: pedidoCompraIdNormalizado,
        compraCotacao_ativo: 1,
      },
      fields: {
        compraCotacao_id: 'compraCotacao_id',
        compraCotacao_desc: 'compraCotacao_desc',
        compraCotacao_vlr: 'compraCotacao_vlr',
        compraCotacao_link: 'compraCotacao_link',
        compraCotacao_nomeInteressado: 'compraCotacao_nomeInteressado',
        pedidoCompra_id: 'pedidoCompra_id',
      },
      order: 'compraCotacao_id ASC',
    })}`);

    return (Array.isArray(response?.data) ? response.data : []).map((cotacao) => ({
      compraCotacao_id: Number(cotacao?.compraCotacao_id) || null,
      compraCotacao_desc: cotacao?.compraCotacao_desc || '',
      compraCotacao_vlr: cotacao?.compraCotacao_vlr ?? 0,
      compraCotacao_link: cotacao?.compraCotacao_link || '',
      compraCotacao_nomeInteressado: cotacao?.compraCotacao_nomeInteressado || '',
      _tempId: `persisted-${cotacao?.compraCotacao_id}`,
    }));
  };

  const fetchPedidoCompraIndicacaoByPropOrcItemId = async (propOrcItemId) => {
    if (!propOrcItemId) return null;

    const response = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'pedidoCompra',
      data: {
        propOrcItem_id: propOrcItemId,
        pedidoCompra_ativo: 1,
      },
      fields: {
        pedidoCompra_id: 'pedidoCompra_id',
        pedidoCompra_desc: 'pedidoCompra_desc',
        pedidoCompra_vlrLimite: 'pedidoCompra_vlrLimite',
        propOrcItem_id: 'propOrcItem_id',
      },
      order: 'pedidoCompra_id DESC',
    })}`);

    return response?.data?.[0] || null;
  };

  const salvarPedidoCompraIndicacao = async ({ indicacao = {}, propOrcItemId }) => {
    const propOrcItemIdNormalizado = Number(propOrcItemId) || 0;
    if (!propOrcItemIdNormalizado || !hasIndicacaoPedidoCompraData(indicacao)) return null;

    const pedidoCompraExistente = Number(indicacao?.pedidoCompra_id)
      ? { pedidoCompra_id: Number(indicacao.pedidoCompra_id) }
      : await fetchPedidoCompraIndicacaoByPropOrcItemId(propOrcItemIdNormalizado);

    const pedidoCompraId = Number(pedidoCompraExistente?.pedidoCompra_id) || 0;
    const isUpdatingPedidoCompra = pedidoCompraId > 0;
    const valorLimite = parseNumericValue(indicacao?.pedidoCompra_vlrLimite);

    const pedidoCompraBody = {
      action: isUpdatingPedidoCompra ? 'update' : 'insert',
      table: 'pedidoCompra',
      data: {
        ...(isUpdatingPedidoCompra ? { pedidoCompra_id: pedidoCompraId } : {
          pedidoCompra_dtSolicitacao: moment().format('YYYY-MM-DD'),
          compraStatus_id: 1,
          pf_id: user.pf_id,
        }),
        pedidoCompra_desc: String(indicacao?.pedidoCompra_desc ?? '').trim(),
        pedidoCompra_vlrLimite: valorLimite ?? 0,
        propOrcItem_id: propOrcItemIdNormalizado,
      },
    };

    const response = await oikosApi.post('/', pedidoCompraBody);
    return isUpdatingPedidoCompra
      ? pedidoCompraId
      : (Number(response?.data?.[0]?.pedidoCompra_id) || null);
  };

  const savePedidoCompraDocuments = async (files = [], pedidoCompraId) => {
    const pedidoCompraIdNormalizado = Number(pedidoCompraId) || 0;
    const filesValidos = (files || []).filter((file) => {
      return file?.data && !file?.props?.isPersisted && Number(file?.props?.documentType?.tpDocumento_id);
    });

    if (!pedidoCompraIdNormalizado || filesValidos.length <= 0) return;

    await Promise.all(filesValidos.map(async (file) => {
      const documentBody = {
        action: 'insert',
        table: 'documento',
        data: {
          tpDocumento_id: file.props.documentType.tpDocumento_id,
          documento_desc: file.props.description || file.data.path,
          documento_iniVig: undefined,
          documento_fimVig: undefined,
          documento_dtEmissao: undefined,
          documento_prazo: undefined,
          documento_ref: undefined,
          privacidade_id: 2,
        },
      };

      const documentCreated = await oikosApi.post('/', documentBody);
      const documentoId = Number(documentCreated?.data?.[0]?.documento_id) || 0;
      if (!documentoId) return;

      await oikosApi.post('/', {
        action: 'insert',
        table: 'documentoVinc',
        data: {
          documento_id: documentoId,
          documentoVinc_tabRef: 'pedidoCompra',
          documentoVinc_tabId: pedidoCompraIdNormalizado,
        },
      });

      const formData = new FormData();
      formData.append('file', new Blob([file.data], { type: file.data.type }), file.data.path);
      formData.append('table', 'arquivo');
      formData.append('action', 'upload_file');
      formData.append('arquivo_tabRef', 'documento');
      formData.append('arquivo_tabId', documentoId);
      formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id);
      formData.append('arquivo_desc', file.data.path);

      await oikosApi.post('/', formData);
    }));
  };

  const updatePedidoCompraDocuments = async (files = []) => {
    const filesPersistidos = (files || []).filter((file) => {
      return file?.props?.isPersisted && Number(file?.props?.documento_id);
    });

    await Promise.all(filesPersistidos.map(async (file) => {
      const documentoId = Number(file?.props?.documento_id) || 0;
      const tpDocumentoId = Number(file?.props?.documentType?.tpDocumento_id) || 0;

      if (!documentoId) return;

      await oikosApi.post('/', {
        action: 'update',
        table: 'documento',
        data: {
          documento_id: documentoId,
          ...(tpDocumentoId ? { tpDocumento_id: tpDocumentoId } : {}),
          documento_desc: file?.props?.description || file?.data?.path || undefined,
        },
      });
    }));
  };

  const getArquivoExtension = (path = '') => {
    const normalizedPath = String(path || '').split('?')[0];
    const extension = normalizedPath.split('.').pop();
    return extension && extension !== normalizedPath ? extension : '';
  };

  const getArquivoIconByExtension = (extension = '') => {
    const normalizedExtension = String(extension || '').toLowerCase();

    if (normalizedExtension === 'pdf') {
      return {
        color: '#ffcfcc',
        labelColor: '#FF2116',
        type: 'acrobat',
      };
    }

    if (['png', 'jpg', 'jpeg', 'gif'].includes(normalizedExtension)) {
      return {
        color: '#ffe6cc',
        labelColor: '#ff9933',
        type: 'image',
      };
    }

    if (['xls', 'xlsx'].includes(normalizedExtension)) {
      return {
        color: '#d7f4e4',
        labelColor: '#207245',
        type: 'spreadsheet',
      };
    }

    if (['doc', 'docx'].includes(normalizedExtension)) {
      return {
        color: '#d7e3f4',
        labelColor: '#2a5699',
        type: 'document',
      };
    }

    return {};
  };

  const formatPedidoCompraDocumentoFile = (documento) => {
    const arquivoPath = documento?.arquivo_caminho || documento?.documento_desc || 'Documento salvo';
    const extension = getArquivoExtension(arquivoPath);
    const name = String(arquivoPath).replace(/\.[^/.]+$/, '');

    return {
      data: {
        path: arquivoPath,
        size: 0,
        type: '',
      },
      props: {
        id: `pedido-compra-doc-${documento?.documentoVinc_id || documento?.documento_id || documento?.arquivo_id || arquivoPath}`,
        preview: '',
        modified: '',
        icon: getArquivoIconByExtension(extension),
        extension,
        name,
        documentType: documento?.tpDocumento_id
          ? {
            tpDocumento_id: documento.tpDocumento_id,
            tpDocumento_desc: documento.tpDocumento_desc,
          }
          : null,
        description: documento?.documento_desc || null,
        documento_id: documento?.documento_id,
        documentoVinc_id: documento?.documentoVinc_id,
        arquivo_id: documento?.arquivo_id,
        arquivo_caminho: documento?.arquivo_caminho,
        isPersisted: true,
      },
    };
  };

  const fetchPedidoCompraDocuments = async (pedidoCompraId) => {
    const pedidoCompraIdNormalizado = Number(pedidoCompraId) || 0;
    if (!pedidoCompraIdNormalizado) return [];

    const response = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'documentoVinc',
      data: {
        documentoVinc_tabRef: 'pedidoCompra',
        documentoVinc_tabId: pedidoCompraIdNormalizado,
        documentoVinc_ativo: 1,
      },
      fields: {
        documentoVinc_id: 'documentoVinc_id',
        documento_id: 'documento_id',
        '(SELECT documento_desc FROM documento WHERE documento.documento_id = documentoVinc.documento_id LIMIT 1)': 'documento_desc',
        '(SELECT documento_ativo FROM documento WHERE documento.documento_id = documentoVinc.documento_id LIMIT 1)': 'documento_ativo',
        '(SELECT tpDocumento_id FROM documento WHERE documento.documento_id = documentoVinc.documento_id LIMIT 1)': 'tpDocumento_id',
        '(SELECT tpDocumento_desc FROM tpDocumento WHERE tpDocumento.tpDocumento_id = (SELECT tpDocumento_id FROM documento WHERE documento.documento_id = documentoVinc.documento_id LIMIT 1) LIMIT 1)': 'tpDocumento_desc',
        '(SELECT arquivo_id FROM arquivo WHERE arquivo.arquivo_tabRef = "documento" AND arquivo.arquivo_tabId = documentoVinc.documento_id AND arquivo.arquivo_ativo = 1 ORDER BY arquivo_id DESC LIMIT 1)': 'arquivo_id',
        '(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabRef = "documento" AND arquivo.arquivo_tabId = documentoVinc.documento_id AND arquivo.arquivo_ativo = 1 ORDER BY arquivo_id DESC LIMIT 1)': 'arquivo_caminho',
      },
    })}`);

    return (response?.data || [])
      .filter((documento) => Number(documento?.documento_ativo) === 1)
      .map(formatPedidoCompraDocumentoFile);
  };

  const fetchPedidoCompraDocumentosVinculados = async (pedidoCompraId) => {
    const pedidoCompraIdNormalizado = Number(pedidoCompraId) || 0;
    if (!pedidoCompraIdNormalizado) return [];

    const response = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'documentoVinc',
      data: {
        documentoVinc_tabRef: 'pedidoCompra',
        documentoVinc_tabId: pedidoCompraIdNormalizado,
        documentoVinc_ativo: 1,
      },
      fields: {
        documentoVinc_id: 'documentoVinc_id',
        documento_id: 'documento_id',
      },
    })}`);

    return response?.data || [];
  };

  const desativarDocumentoPedidoCompraVinculado = async (documentoVinc) => {
    const documentoVincId = Number(documentoVinc?.documentoVinc_id) || 0;
    const documentoId = Number(documentoVinc?.documento_id) || 0;

    if (documentoVincId) {
      await oikosApi.post('/', {
        action: 'update',
        table: 'documentoVinc',
        data: {
          documentoVinc_id: documentoVincId,
          documentoVinc_ativo: 0,
        },
      });
    }

    if (documentoId) {
      await oikosApi.post('/', {
        action: 'update',
        table: 'documento',
        data: {
          documento_id: documentoId,
          documento_ativo: 0,
        },
      });

      const arquivosResponse = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'arquivo',
        data: {
          arquivo_tabRef: 'documento',
          arquivo_tabId: documentoId,
          arquivo_ativo: 1,
        },
        fields: {
          arquivo_id: 'arquivo_id',
        },
      })}`);

      const arquivos = arquivosResponse?.data || [];

      for (const arquivo of arquivos) {
        const arquivoId = Number(arquivo?.arquivo_id) || 0;
        if (!arquivoId) continue;

        await oikosApi.post('/', {
          action: 'update',
          table: 'arquivo',
          data: {
            arquivo_id: arquivoId,
            arquivo_ativo: 0,
          },
        });
      }
    }
  };

  const desativarDocumentosRemovidosPedidoCompra = async (pedidoCompraId, filesAtuais = []) => {
    const documentosVinculados = await fetchPedidoCompraDocumentosVinculados(pedidoCompraId);
    const documentoVincIdsAtuais = new Set(
      (filesAtuais || [])
        .map((file) => Number(file?.props?.documentoVinc_id) || 0)
        .filter(Boolean)
    );
    const documentoIdsAtuais = new Set(
      (filesAtuais || [])
        .map((file) => Number(file?.props?.documento_id) || 0)
        .filter(Boolean)
    );

    for (const documentoVinc of documentosVinculados) {
      const documentoVincId = Number(documentoVinc?.documentoVinc_id) || 0;
      const documentoId = Number(documentoVinc?.documento_id) || 0;
      const documentoContinuaNaLista =
        (documentoVincId && documentoVincIdsAtuais.has(documentoVincId)) ||
        (documentoId && documentoIdsAtuais.has(documentoId));

      if (documentoContinuaNaLista) continue;

      await desativarDocumentoPedidoCompraVinculado(documentoVinc);
    }
  };

  const desativarDocumentosPedidoCompra = async (pedidoCompraId) => {
    const documentosVinculados = await fetchPedidoCompraDocumentosVinculados(pedidoCompraId);

    for (const documentoVinc of documentosVinculados) {
      await desativarDocumentoPedidoCompraVinculado(documentoVinc);
    }
  };

  const desativarPedidosCompraIndicacaoByPropOrcItemId = async (propOrcItemId) => {
    const propOrcItemIdNormalizado = Number(propOrcItemId) || 0;
    if (!propOrcItemIdNormalizado) return;

    const response = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'pedidoCompra',
      data: {
        propOrcItem_id: propOrcItemIdNormalizado,
        pedidoCompra_ativo: 1,
      },
      fields: {
        pedidoCompra_id: 'pedidoCompra_id',
      },
    })}`);

    const pedidosCompra = response?.data || [];

    for (const pedidoCompra of pedidosCompra) {
      const pedidoCompraId = Number(pedidoCompra?.pedidoCompra_id) || 0;
      if (!pedidoCompraId) continue;

      await desativarDocumentosPedidoCompra(pedidoCompraId);

      await oikosApi.post('/', {
        action: 'update',
        table: 'pedidoCompra',
        data: {
          pedidoCompra_id: pedidoCompraId,
          pedidoCompra_ativo: 0,
        },
      });
    }
  };

  const fetchProjAtuacoes = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'projAtuacao',
        data: {
          projAtuacao_ativo: 1,
        },
        fields: {
          projAtuacao_id: 'value',
          projAtuacao_nome: 'label'
        }
      })}`
    )

    setProjAtuacoes([...res.data]);
  }

  const fetchRecTps = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'recTp',
        data: {
          recTp_ativo: 1,
        },
        fields: {
          recTp_id: 'value',
          recTp_nome: 'label'
        }
      })}`
    )

    setRecTps([...res.data]);
  }

  const fetchUnidades = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'unidade',
        fields: {
          unidade_id: 'value',
          unidade_nome: 'label'
        }
      })}`
    )
    setUnidades([...res.data]);
  }

  const fetchGruposOrcItem = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'propItemGr',
        fields: {
          propItemGr_id: 'value',
          propItemGr_nome: 'label'
        }
      })}`
    )
    setGruposOrcItem([...res.data]);
  }

  const fetchEscolaridades = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'escol',
        fields: {
          escol_id: 'value',
          escol_nivel: 'label'
        }
      })}`
    )

    setEscolaridades([...res.data.filter(escol => [8, 9, 10, 11].includes(escol.escol_id))]);
  }

  const fetchCategorias = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'categ',
        fields: {
          categ_id: 'value',
          categ_nome: 'label'
        }
      })}`
    )
    setCategorias([...res.data]);
  }

  const fetchGruposDeCategorias = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'categGr',
        fields: {
          categGr_id: 'value',
          categGr_nome: 'label'
        }
      })}`
    )
    setGruposDeCategorias([...res.data]);
  }

  const fetchPropostaData = async () => {

  }

  const fetchInitialPropostaData = async () => {
    const propId = Number(id);

    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'prop',
        data: {
          prop_id: Number(id),
          prop_ativo: 1,
        },
        fields: {
          prop_id: 'value',
          prop_nome: 'label',
          bitrix_id: 'bitrix_id',
          prop_dtCria: 'prop_dtCria',
          '(SELECT pj_id FROM negociacao WHERE negociacao_id = prop.negociacao_id)': 'pj_id',
          '(SELECT servico_id FROM negociacao WHERE negociacao_id = prop.negociacao_id)': 'servico_id',
          '(SELECT servico_nome FROM servico WHERE servico_id = (SELECT servico_id FROM negociacao WHERE negociacao_id = prop.negociacao_id))': 'servico_nome',
          '(SELECT pj_nomefanta FROM pj WHERE pj_id = (SELECT pj_id FROM negociacao WHERE negociacao_id = prop.negociacao_id))': 'pj_nomefanta',
          '(SELECT propStatus_nome FROM propStatus WHERE propStatus_id = prop.propStatus_id)': 'propStatus_nome',
          '(SELECT negociacao_prazo FROM negociacao WHERE negociacao_id = prop.negociacao_id)': 'negociacao_prazo',
        }
      })}`
    )

    if (!Array.isArray(res?.data) || !res.data.length) {
      console.error('Resposta invalida ao carregar proposta inicial', res?.data);
      return;
    }

    setVisaoGeralPercentuais({
      taxaEncargos: res.data[0].prop_aliqCLT || 72,
      taxaImpostos: res.data[0].prop_aliqImposto || 16.5,
      taxaAdministrativa: res.data[0].prop_aliqAdmin || 15,
      taxaLucro: res.data[0].prop_aliqLucro || 40,
      custoFinanceiro: res.data[0].prop_aliqCustoFin || 3,
      taxaComissao: res.data[0].prop_aliqRemFin || 0.5,
    });

    setQuantidadeColunas(res.data[0].prop_prazoExec);

    const [propItensRes, prodsPropRes, eventosPagamentoPropRes, relacoesProdEventoRes] = await Promise.all([
      oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'propOrcItem',
        data: {
          prop_id: propId,
          propOrcItem_ativo: 1,
        },
        fields: {
          propOrcItem_id: 'value',
          propOrcItem_desc: 'label',
          '(SELECT propItemGr_id FROM propItem WHERE propItem.propItem_id = propOrcItem.propItem_id AND propOrcItem.propOrcItem_ativo = 1)':'propItemGr_id',
          '(SELECT propItem_desc FROM propItem WHERE propItem.propItem_id = propOrcItem.propItem_id AND propOrcItem.propOrcItem_ativo = 1)':'propItem_desc',
          '(SELECT propItem_refVlr FROM propItem WHERE propItem.propItem_id = propOrcItem.propItem_id AND propOrcItem.propOrcItem_ativo = 1)':'propItem_refVlr',
          '(SELECT categ_id FROM propItem WHERE propItem.propItem_id = propOrcItem.propItem_id AND propOrcItem.propOrcItem_ativo = 1)':'categ_id',
          "(SELECT propItemGr_nome FROM propItemGr WHERE propItemGr_id = (SELECT propItemGr_id FROM propItem WHERE propItem.propItem_id = propOrcItem.propItem_id AND propOrcItem.propOrcItem_ativo = 1))" : "propItemGr_nome",
          '(SELECT unidade_id FROM propItem WHERE propItem.propItem_id = propOrcItem.propItem_id AND propOrcItem.propOrcItem_ativo = 1)':'unidade_id',
          '(SELECT unidade_label FROM propItem WHERE propItem.propItem_id = propOrcItem.propItem_id AND propOrcItem.propOrcItem_ativo = 1)':'unidade_label',
          '(SELECT escol_nivel FROM escol WHERE escol.escol_id = propOrcItem.escol_id AND propOrcItem.propOrcItem_ativo = 1)':'escol_nivel',
        }
      })}`),
      oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'prodProp',
        data: {
          prop_id: propId,
          prodProp_ativo: 1,
        },
      })}`),
      oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'eventoPagamentoProp',
        data: {
          prop_id: propId,
          eventoPagamentoProp_ativo: 1,
        },
      })}`),
      oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'relacaoPropEPPropProdProp',
        data: {
          prop_id: propId,
          relacaoPropEPPropProdProp_ativo: 1
        },
      })}`),
    ]);

    const taxaEncargosDaProposta = Number(res.data[0].prop_aliqCLT) || 0;
    const propItensBaseData = propItensRes?.data.map((item) => {
      const propOrcItemEquipeClt = Boolean(item?.propEstrut_id === 1);
      return {
        ...item,
        propOrcItem_equipeClt: propOrcItemEquipeClt,
      };
    }) || [];

    const pedidoCompraIndicacaoResponses = await Promise.all(
      propItensBaseData.map(async (propOrcItem) => {
        const propOrcItemId = Number(propOrcItem?.propOrcItem_id ?? propOrcItem?.value) || 0;
        if (!propOrcItemId) return null;

        try {
          const pedidoCompra = await fetchPedidoCompraIndicacaoByPropOrcItemId(propOrcItemId);
          if (!pedidoCompra?.pedidoCompra_id) return null;

          const [filesPedidoCompra, cotacoesManuais] = await Promise.all([
            fetchPedidoCompraDocuments(pedidoCompra.pedidoCompra_id),
            fetchCompraCotacoesIndicacaoByPedidoCompraId(pedidoCompra.pedidoCompra_id),
          ]);

          return {
            ...pedidoCompra,
            filesPedidoCompra,
            cotacoesManuais,
          };
        } catch (error) {
          return null;
        }
      })
    );

    const propItensData = propItensBaseData.map((item, index) => {
      const pedidoCompraIndicacao = pedidoCompraIndicacaoResponses[index];

      return {
        ...item,
        indicacao: pedidoCompraIndicacao
          ? {
            pedidoCompra_id: pedidoCompraIndicacao.pedidoCompra_id,
            pedidoCompra_desc: pedidoCompraIndicacao.pedidoCompra_desc,
            pedidoCompra_vlrLimite: pedidoCompraIndicacao.pedidoCompra_vlrLimite,
            propOrcItem_id: pedidoCompraIndicacao.propOrcItem_id,
            cotacoesManuais: pedidoCompraIndicacao.cotacoesManuais || [],
            filesPedidoCompra: pedidoCompraIndicacao.filesPedidoCompra || [],
          }
          : {
            pedidoCompra_desc: item?.propOrcItem_indicacao || '',
            cotacoesManuais: [],
            filesPedidoCompra: [],
          },
      };
    });

    const propOrcResponses = await Promise.all(
      propItensData.map(async (propOrcItem) => {
        const propOrcItemId = Number(propOrcItem?.propOrcItem_id ?? propOrcItem?.value) || 0;
        if (!propOrcItemId) return { data: [] };

        try {
          const resposta = await oikosApi.get(`/?${qs.stringify({
            action: 'get',
            table: 'propOrc',
            data: {
              propOrcItem_id: propOrcItemId,
              propOrc_ativo: 1,
            },
          })}`);
          return resposta
        } catch (error) {
          return { data: [] };
        }
      })
    );

    const valoresIniciaisPorLinhaEColuna = {};
    const propOrcIdsIniciaisPorLinhaEColuna = {};

    propItensData.forEach((propOrcItem, index) => {
      const linhaKey = String(
        propOrcItem?.value ??
        propOrcItem?.propOrcItem_id ??
        propOrcItem?.id ??
        ''
      );

      if (!linhaKey) return;

      const alocacoes = propOrcResponses[index]?.data || [];

      alocacoes.forEach((alocacao) => {
        const mes = Number(alocacao?.propOrc_mes) || 0;
        const qtd = Number(alocacao?.propOrc_qtde) || 0;

        if (!mes || qtd <= 0) return;

        if (!valoresIniciaisPorLinhaEColuna[linhaKey]) {
          valoresIniciaisPorLinhaEColuna[linhaKey] = {};
        }

        valoresIniciaisPorLinhaEColuna[linhaKey][mes] = qtd;

        if (!propOrcIdsIniciaisPorLinhaEColuna[linhaKey]) {
          propOrcIdsIniciaisPorLinhaEColuna[linhaKey] = {};
        }

        propOrcIdsIniciaisPorLinhaEColuna[linhaKey][mes] = Number(alocacao?.propOrc_id) || 0;
      });
    });

    setValoresPorLinhaEColuna(valoresIniciaisPorLinhaEColuna);
    setPropOrcIdPorLinhaEColuna(propOrcIdsIniciaisPorLinhaEColuna);

    const prodsData = (prodsPropRes?.data || []).map((prod) => ({ ...prod, eventosPagamentoProp: [] }));
    const eventosData = (eventosPagamentoPropRes?.data || []).map((evento) => ({ ...evento, prodsProp: [] }));
    const relacoesProdEventoData = relacoesProdEventoRes?.data || [];

    const prodById = new Map(
      prodsData.map((prod) => {
        const prodId = Number(prod?.prodProp_id ?? prod?.value) || 0;
        return [prodId, prod];
      })
    );

    const eventoById = new Map(
      eventosData.map((evento) => {
        const eventoId = Number(evento?.eventoPagamentoProp_id ?? evento?.value) || 0;
        return [eventoId, evento];
      })
    );

    relacoesProdEventoData.forEach((relacao) => {
      const prodId = Number(relacao?.prodProp_id) || 0;
      const eventoId = Number(relacao?.eventoPagamentoProp_id) || 0;
      if (!prodId || !eventoId) return;

      const prodRelacionado = prodById.get(prodId);
      const eventoRelacionado = eventoById.get(eventoId);
      if (!prodRelacionado || !eventoRelacionado) return;

      const prodJaTemEvento = (prodRelacionado.eventosPagamentoProp || []).some((evento) => {
        return Number(evento?.eventoPagamentoProp_id ?? evento?.value) === eventoId;
      });

      if (!prodJaTemEvento) {
        prodRelacionado.eventosPagamentoProp = [...(prodRelacionado.eventosPagamentoProp || []), eventoRelacionado];
      }

      const eventoJaTemProd = (eventoRelacionado.prodsProp || []).some((prod) => {
        return Number(prod?.prodProp_id ?? prod?.value) === prodId;
      });

      if (!eventoJaTemProd) {
        eventoRelacionado.prodsProp = [...(eventoRelacionado.prodsProp || []), prodRelacionado];
      }
    });

    setPropostaData((prev) => ({
      ...prev,
      ...res.data[0],
      propItens: propItensData,
      prodsProp: prodsData,
      eventosPagamentoProp: eventosData,
    }));
  };

  const buildSalvarRascunhoProdsPropRequest = () => {
    const formData = new FormData();
    const createUploadField = (rowKey, index) => {
      const safeRowKey = String(rowKey || 'sem-chave').replace(/[^a-zA-Z0-9_-]/g, '_');
      return `pedido_compra_${safeRowKey}_${index}_${Date.now()}`;
    };

    const serializePedidoCompraFiles = (files = [], rowKey) => {
      return (files || []).map((file, index) => {
        const isPersisted = Boolean(file?.props?.isPersisted && Number(file?.props?.documento_id));
        const uploadField = !isPersisted && file?.data ? createUploadField(rowKey, index) : null;

        if (uploadField && file?.data) {
          formData.append(
            uploadField,
            file.data,
            file?.data?.path || file?.data?.name || file?.props?.name || `arquivo-${index}`
          );
        }

        return {
          uploadField,
          isPersisted,
          name: file?.data?.path || file?.data?.name || file?.props?.arquivo_caminho || file?.props?.name || '',
          description: file?.props?.description || null,
          documentType: file?.props?.documentType
            ? {
              tpDocumento_id: Number(file.props.documentType.tpDocumento_id) || null,
              tpDocumento_desc: file.props.documentType.tpDocumento_desc || null,
            }
            : null,
          documento_id: Number(file?.props?.documento_id) || null,
          documentoVinc_id: Number(file?.props?.documentoVinc_id) || null,
          arquivo_id: Number(file?.props?.arquivo_id) || null,
          arquivo_caminho: file?.props?.arquivo_caminho || null,
        };
      });
    };

    const payload = {
      acao: 'salvar_rascunho_revisar_orcamento',
      propId: Number(id),
      userId: Number(user?.pf_id) || 0,
      quantidadeColunas: Math.max(0, Math.floor(Number(quantidadeColunas) || 0)),
      propostaData: {
        prop_prazoEnvio: propostaData?.prop_prazoEnvio ?? null,
      },
      visaoGeralPercentuais,
      calculoPrecoFinalProposta,
      precoFinalPropostaAtual,
      visaoGeralValorTaxaEncargos: Number((parseNumericValue(visaoGeralValorTaxaEncargos) || 0).toFixed(2)),
      propOrcItemsParaDesativar: [...propOrcItemsParaDesativar],
      prodsPropParaDesativar: [...prodsPropParaDesativar],
      eventosPagamentoPropParaDesativar: [...eventosPagamentoPropParaDesativar],
      valoresPorLinhaEColuna,
      propOrcIdPorLinhaEColuna,
      propItens: (propostaData?.propItens || []).map((propItem) => {
        const rowKey = getPropItemRowKey(propItem);
        return {
          rowKey,
          propItem_id: Number(propItem?.propItem_id ?? propItem?.value) || 0,
          propOrcItem_id: Number(propItem?.propOrcItem_id) || 0,
          propOrcItem_desc: propItem?.propOrcItem_desc ?? propItem?.propItem_desc ?? '',
          propItem_desc: propItem?.propItem_desc ?? '',
          propOrcItem_valor: propItem?.propOrcItem_valor ?? null,
          propOrcItem_qtd: propItem?.propOrcItem_qtd ?? null,
          propEstrut_id: Number(propItem?.propEstrut_id) || null,
          propItemGr_id: Number(propItem?.propItemGr_id) || null,
          projAtuacao_id: Number(propItem?.projAtuacao_id) || null,
          escol_id: Number(propItem?.escol_id) || null,
          indicacao: {
            pedidoCompra_id: Number(propItem?.indicacao?.pedidoCompra_id) || null,
            pedidoCompra_desc: propItem?.indicacao?.pedidoCompra_desc || '',
            pedidoCompra_vlrLimite: propItem?.indicacao?.pedidoCompra_vlrLimite ?? null,
            cotacoesManuais: serializeCotacoesManuaisForPayload(propItem?.indicacao?.cotacoesManuais || []),
            filesPedidoCompra: serializePedidoCompraFiles(propItem?.indicacao?.filesPedidoCompra || [], rowKey),
          },
        };
      }),
      eventosPagamentoProp: (propostaData?.eventosPagamentoProp || []).map((eventoPagamentoProp) => ({
        rowKey: getEventoPagamentoPropRowKey(eventoPagamentoProp),
        eventoPagamentoProp_id: Number(eventoPagamentoProp?.eventoPagamentoProp_id) || 0,
        eventoPagamentoProp_nome: eventoPagamentoProp?.eventoPagamentoProp_nome || '',
        eventoPagamentoProp_prazoPgto: eventoPagamentoProp?.eventoPagamentoProp_prazoPgto ?? null,
        eventoPagamentoProp_vlr: eventoPagamentoProp?.eventoPagamentoProp_vlr ?? null,
        recTp_id: Number(eventoPagamentoProp?.recTp_id) || null,
      })),
      prodsProp: (propostaData?.prodsProp || []).map((prodProp) => ({
        rowKey: getProdPropRowKey(prodProp),
        prodProp_id: Number(prodProp?.prodProp_id) || 0,
        prodProp_nome: prodProp?.prodProp_nome || '',
        prodProp_prazoEntrega: prodProp?.prodProp_prazoEntrega ?? null,
        eventoRowKeys: (prodProp?.eventosPagamentoProp || [])
          .map(normalizeEventoPagamentoPropOption)
          .filter(Boolean)
          .map((eventoPagamentoProp) => getEventoPagamentoPropRowKey(eventoPagamentoProp))
          .filter(Boolean),
      })),
    };

    formData.append('acao', payload.acao);
    formData.append('payload', JSON.stringify(payload));

    return formData;
  };

  const salvarRascunhoProdsProp = async () => {
    const eventosPagamentoPropDaProposta = propostaData?.eventosPagamentoProp || [];
    const eventosSemRecTp = eventosPagamentoPropDaProposta.filter((evento) => {
      return !(Number(evento?.recTp_id) > 0);
    });

    if (eventosSemRecTp.length > 0) {
      const eventosSemRecTpNomes = eventosSemRecTp
        .map((evento) => evento?.eventoPagamentoProp_nome || evento?.label || `ID ${evento?.eventoPagamentoProp_id || evento?.value || 'sem identificação'}`)
        .join(', ');

      notifyError(`Defina o tipo (recTp_id) para os seguintes eventos de pagamento: ${eventosSemRecTpNomes}`);
      return;
    }

    setIsSubmitEntityLoading(true);

    try {
      const formData = buildSalvarRascunhoProdsPropRequest();
      const response = await endPoints1Api.post(
        '/',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: 'multipart/form-data',
          },
        }
      );

      if (response?.data?.ok === false) {
        throw new Error(response?.data?.message || 'erro_ao_salvar_rascunho_revisar_orcamento');
      }

      setPropOrcItemsParaDesativar([]);
      setProdsPropParaDesativar([]);
      setEventosPagamentoPropParaDesativar([]);
      await fetchInitialPropostaData();
    } catch (error) {
      console.error('Erro ao salvar rascunho de produtos', error);
      const backendDetail = error?.data?.detail || error?.response?.data?.detail || error?.message;
      notifyError(backendDetail || 'Ocorreu um erro ao salvar o rascunho da proposta.');
    } finally {
      setIsSubmitEntityLoading(false);
    }
  }

  const handleConcluirOrcamento = async () => {
    setIsSubmitEntityLoading(true);

    if(propostaData.propStatus_id === 6) {
      setIsSubmitEntityLoading(false);
      notifyError('Salve um rascunho antes')
      return;
    }

    if (!validarPropItensTotalmenteEspacializados()) {
      setIsSubmitEntityLoading(false);
      return;
    }

    const somaEPs = Number(getSomaPercentualEventosPagamento(propostaData.eventosPagamentoProp).toFixed(2));
    if (somaEPs !== 100) {
      setIsSubmitEntityLoading(false);
      return notifyError(`A soma das % dos eventos de pagamento deve ser igual a 100%. Valor atual: ${somaEPs}%`);
    }

    try {

      await salvarRascunhoProdsProp();

      const propBody = {
        action: 'update',
        table: 'prop',
        data: {
          prop_id: Number(id),
          propStatus_id: 4
        },
      };

      await oikosApi.post('/', propBody);

      await fetchInitialPropostaData();
    } catch (error) {
      console.error('Erro ao fechar orçamento', error);
      notifyError('Ocorreu um erro ao fechar o orçamento.');
    } finally {
      setIsSubmitEntityLoading(false);
    }
  };

  const handleOpenSalvarModeloModal = () => {
    if (!propostaData?.servico_id) {
      notifyError('Atribua um serviço à negociação desta proposta para salvar um modelo baseado nela.');
    }
    if (!propostaData?.servico_id) {
      notifyError('Atribua um serviço à negociação desta proposta para salvar um modelo baseado nela.');
    }
    setModeloPropostaData({ modeloProp_nome: '' });
    setModalSalvarModeloOpen(true);
  };

  const handleCloseSalvarModeloModal = () => {
    setModalSalvarModeloOpen(false);
    setModeloPropostaData({});
  };

  const handleSalvarModeloProposta = async () => {
    const nomeModelo = (modeloPropostaData?.modeloProp_nome || '').trim();

    if (!nomeModelo) {
      notifyError('Informe o nome do modelo antes de salvar.');
      return;
    }

    setIsSubmitEntityLoading(true);

    try {
      const modeloPropBody = {
        action: 'insert',
        table: 'modeloProp',
        data: {
          prop_id: Number(id),
          modeloProp_nome: nomeModelo
        },
      };

      await oikosApi.post('/', modeloPropBody);

      notifySuccess('Modelo salvo com sucesso.');
      handleCloseSalvarModeloModal();
      await fetchInitialPropostaData();
    } catch (error) {
      console.error('Erro ao salvar modelo da proposta', error);
      notifyError('Ocorreu um erro ao salvar o modelo da proposta.');
    } finally {
      setIsSubmitEntityLoading(false);
    }
  };

  const verificaCamposNovoPropItem = () => {
    const { propItemGr_id, propItem_desc, unidade_id, propItem_refVlr, categ_id } = insertPropItemData;
    if (!propItemGr_id || !propItem_desc || !unidade_id || !propItem_refVlr || !categ_id) {
      notifyError('Preencha todos os campos para inserir um novo item orçamentário.');
      return false;
    }
    return true;
  }

  const handleInsertPropItem = async () => {
    setIsInsertPropItemLoading(true);

    if(!verificaCamposNovoPropItem()) {
      return setIsInsertPropItemLoading(false);
    }

    try {
      let insertedPropItem = null;
      const grupoInserido = Number(insertPropItemData.propItemGr_id);
      const descricaoInserida = insertPropItemData.propItem_desc;
      if (grupoInserido !== 1) {
        const propItemBody = {
          action: 'insert',
          table: 'propItem',
          data: {
            propItemGr_id: insertPropItemData.propItemGr_id,
            propItemGr_label: gruposOrcItem.find(grupo => grupo.propItemGr_id === insertPropItemData.propItemGr_id)?.propItemGr_nome,
            propItem_desc: insertPropItemData.propItem_desc,
            unidade_id: insertPropItemData.unidade_id,
            unidade_label: unidades.find(unidade => unidade.unidade_id === insertPropItemData.unidade_id)?.unidade_nome,
            propItem_refVlr: insertPropItemData.propItem_refVlr,
            propItem_orcVlr: insertPropItemData.propItem_refVlr,
            categ_id: insertPropItemData.categ_id,
            categ_label: insertPropItemData.categ_nome,
          },
        };

        const res = await oikosApi.post('/', propItemBody);
        insertedPropItem = res?.data?.[0] ?? null;
      } else {
        const propItemBodyHora = {
          action: 'insert',
          table: 'propItem',
          data: {
            propItemGr_id: insertPropItemData.propItemGr_id,
            propItemGr_label: gruposOrcItem.find(grupo => grupo.propItemGr_id === insertPropItemData.propItemGr_id)?.propItemGr_nome,
            propItem_desc: insertPropItemData.propItem_desc,
            unidade_id: unidades.find(unidade => unidade.unidade_nome === "Hora")?.unidade_id,
            unidade_label: "Hora",
            propItem_refVlr: insertPropItemData.propItem_refVlr,
            propItem_orcVlr: insertPropItemData.propItem_refVlr,
            categ_id: insertPropItemData.categ_id,
            categ_label: insertPropItemData.categ_nome,
          },
        };

        const resHora = await oikosApi.post('/', propItemBodyHora);
        insertedPropItem = resHora?.data?.[0] ?? null;

        const propItemBodyDia = {
          action: 'insert',
          table: 'propItem',
          data: {
            propItemGr_id: insertPropItemData.propItemGr_id,
            propItemGr_label: gruposOrcItem.find(grupo => grupo.propItemGr_id === insertPropItemData.propItemGr_id)?.propItemGr_nome,
            propItem_desc: insertPropItemData.propItem_desc,
            unidade_id: unidades.find(unidade => unidade.unidade_nome === "Dia")?.unidade_id,
            unidade_label: "Dia",
            propItem_refVlr: insertPropItemData.propItem_refVlr,
            propItem_orcVlr: insertPropItemData.propItem_refVlr,
            categ_id: insertPropItemData.categ_id,
            categ_label: insertPropItemData.categ_nome,
          },
        };

        await oikosApi.post('/', propItemBodyDia);

        const propItemBodyMes = {
          action: 'insert',
          table: 'propItem',
          data: {
            propItemGr_id: insertPropItemData.propItemGr_id,
            propItemGr_label: gruposOrcItem.find(grupo => grupo.propItemGr_id === insertPropItemData.propItemGr_id)?.propItemGr_nome,
            propItem_desc: insertPropItemData.propItem_desc,
            unidade_id: unidades.find(unidade => unidade.unidade_nome === "Mês")?.unidade_id,
            unidade_label: "Mês",
            propItem_refVlr: insertPropItemData.propItem_refVlr,
            propItem_orcVlr: insertPropItemData.propItem_refVlr,
            categ_id: insertPropItemData.categ_id,
            categ_label: insertPropItemData.categ_nome,
          },
        };

        await oikosApi.post('/', propItemBodyMes);
      }

      const itensAtualizados = await fetchItensOrcamentarios();

      if (grupoInserido === 1) {
        const profissaoSelecionada = (itensAtualizados?.propItensUnicos || []).find((item) => {
          return Number(item?.propItemGr_id) === grupoInserido &&
            String(item?.propItem_desc ?? item?.label ?? '') === String(descricaoInserida ?? '');
        });

        if (profissaoSelecionada) {
          const itemComUnidadeSelecionada = (itensAtualizados?.propItens || []).find((item) => {
            return Number(item?.propItemGr_id) === grupoInserido &&
              String(item?.propItem_desc ?? item?.label ?? '') === String(descricaoInserida ?? '') &&
              Number(item?.unidade_id) === Number(insertPropItemData?.unidade_id);
          });
          const unidadeSelecionada = unidades.find((unidade) => {
            return String(unidade?.unidade_id ?? unidade?.value) === String(insertPropItemData?.unidade_id);
          });

          setPropitemFiltrado(itemComUnidadeSelecionada || null);
          setPropItemData((prev) => ({
            ...prev,
            ...profissaoSelecionada,
            ...(itemComUnidadeSelecionada || {}),
            propItemGr_id: grupoInserido,
            propItem_desc: profissaoSelecionada.propItem_desc ?? profissaoSelecionada.label ?? descricaoInserida,
            label: profissaoSelecionada.label ?? profissaoSelecionada.propItem_desc ?? descricaoInserida,
            value: profissaoSelecionada.value ?? profissaoSelecionada.propItem_id,
            unidade_id: insertPropItemData?.unidade_id ?? itemComUnidadeSelecionada?.unidade_id ?? prev?.unidade_id ?? null,
            unidade_label: unidadeSelecionada?.unidade_nome ?? unidadeSelecionada?.label ?? itemComUnidadeSelecionada?.unidade_label ?? prev?.unidade_label,
            //propOrcItem_valor_base: itemComUnidadeSelecionada?.propItem_refVlr ?? insertPropItemData?.propItem_refVlr,
            propOrcItem_valor: itemComUnidadeSelecionada?.propItem_refVlr ?? insertPropItemData?.propItem_refVlr
            ,
          }));
        }
      } else if (insertedPropItem) {
        const itemSelecionado = (itensAtualizados?.propItens || []).find((item) => {
          const itemId = item?.propItem_id ?? item?.value;
          const insertedId = insertedPropItem?.propItem_id ?? insertedPropItem?.value;
          return itemId && insertedId && String(itemId) === String(insertedId);
        });

        const proximoItem = itemSelecionado || insertedPropItem;
        setPropItemData((prev) => ({
          ...prev,
          ...proximoItem,
          propItemGr_id: grupoInserido,
          propItem_desc: proximoItem?.propItem_desc ?? proximoItem?.label ?? descricaoInserida,
          label: proximoItem?.label ?? proximoItem?.propItem_desc ?? descricaoInserida,
          value: proximoItem?.value ?? proximoItem?.propItem_id,
          propOrcItem_valor: proximoItem?.propItem_refVlr ?? insertPropItemData.propItem_refVlr,
        }));
      }
    } catch (error) {
      console.error('Erro ao fechar orçamento', error);
    } finally {
      setIsInsertPropItemLoading(false);
    }
  };

  useEffect(() => {
    fetchPropostaData();
    fetchInitialPropostaData();
    //fetchProdsProp();
    //fetchEventosPagamento();
    fetchItensOrcamentarios();
    fetchRecTps();
    fetchServicos();
    fetchUnidades();
    fetchProjAtuacoes();
    fetchGruposOrcItem();
    fetchEscolaridades();
    fetchCategorias();
    fetchGruposDeCategorias();
    fetchIndicacaoCentroDeCustoForSelect();
    setActiveId(TABS[0].id);
  }, [])

  useEffect(() => {
    if (modalPropItemOpen) {
      setIsPropItemValorEditavel(false);
      setModalidadeQuantidadePropItem('total');
      setQuantidadeMensalPropItem('');
      setIndicacaoFilesPedidoCompra([]);
      setIndicacaoListaDotacoes([]);
      setIndicacaoValoresLimites([]);
      setPropItemData((prev) => ({
        ...prev,
        indicacao: {
          ...(prev?.indicacao || {}),
          cotacoesManuais: Array.isArray(prev?.indicacao?.cotacoesManuais)
            ? prev.indicacao.cotacoesManuais
            : [],
        },
      }));
      indicacaoCotacaoRapidaFormRef.current?.resetDraft?.();
    }
  }, [modalPropItemOpen]);

  useEffect(() => {
    if (modalPropItemEditOpen) {
      setModalidadeQuantidadePropItem('total');
      setQuantidadeMensalPropItem('');
      setIndicacaoListaDotacoes([]);
      setIndicacaoValoresLimites([]);
      setIndicacaoFilesPedidoCompra(propItemData?.indicacao?.filesPedidoCompra || []);
      setPropItemData((prev) => ({
        ...prev,
        indicacao: {
          ...(prev?.indicacao || {}),
          cotacoesManuais: Array.isArray(prev?.indicacao?.cotacoesManuais)
            ? prev.indicacao.cotacoesManuais
            : [],
        },
      }));
      indicacaoCotacaoRapidaFormRef.current?.resetDraft?.();
    }
  }, [modalPropItemEditOpen]);

  useEffect(() => {
    const centroId = propItemData?.indicacao?.centroDeCustoRubr_id;
    if (!centroId) {
      setIndicacaoSelOrcItems([]);
      return;
    }

    fetchIndicacaoOrcItemsForSelect(centroId);
  }, [propItemData?.indicacao?.centroDeCustoRubr_id]);

  useEffect(() => {
    if (!modalPropItemOpen && !modalPropItemEditOpen) return;

    const selectedPropItemId = propItemData?.propItem_id ?? propItemData?.value;
    if (selectedPropItemId === null || selectedPropItemId === undefined) return;

    setPropItemData((prev) => {
      const currentIndicacao = prev?.indicacao || {};
      if (currentIndicacao.propItem_id === selectedPropItemId) return prev;

      return {
        ...prev,
        indicacao: {
          ...currentIndicacao,
          propItem_id: selectedPropItemId,
        },
      };
    });
  }, [modalPropItemOpen, modalPropItemEditOpen, propItemData?.propItem_id, propItemData?.value]);

  return (
    <div style={{ padding: '2rem', paddingTop: 'calc(5rem + 56px)' }}>
      {/* <div
        style={{
          position: 'fixed',
          top: '8rem',
          left: '10rem',
          right: '10rem',
          zIndex: 4,
          display: 'grid',
          gridTemplateColumns: 'minmax(300px, 1.25fr) minmax(480px, 2fr)',
          gap: '8px',
          padding: '8px',
          border: '1px solid #e2e4ea',
          borderRadius: '10px',
          backgroundColor: 'rgba(255, 255, 255, 0.96)',
          boxShadow: '0 4px 12px rgba(15, 23, 42, 0.05)',
          backdropFilter: 'blur(6px)',
          marginRight: '5rem'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            minWidth: 0,
            padding: '10px 12px',
            borderRadius: '8px',
            backgroundColor: 'rgba(248, 250, 252, 0.95)',
            border: '1px solid rgba(226, 232, 240, 0.9)',
          }}
        >
          <span
            style={{
              display: 'block',
              marginBottom: '4px',
              fontSize: '8px',
              fontWeight: 700,
              lineHeight: 1.15,
              letterSpacing: '0.04em',
              textTransform: 'uppercase',
              color: '#6c757d',
            }}
          >
            Nome da proposta
          </span>

          <strong
            style={{
              display: 'block',
              fontSize: '13px',
              lineHeight: 1.25,
              color: '#111827',
              fontWeight: 700,
              wordBreak: 'break-word',
              overflowWrap: 'anywhere',
            }}
          >
            {nomeProposta}
          </strong>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateRows: '1fr 1fr',
            gap: '6px',
            minWidth: 0,
          }}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
              gap: '6px',
            }}
          >
            {infoHeaderTopItems.map((item) => (
              <div
                key={item.label}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  gap: '2px',
                  minWidth: 0,
                  padding: '7px 9px',
                  borderRadius: '7px',
                  border: '1px solid rgba(226, 232, 240, 0.9)',
                  backgroundColor: 'rgba(248, 250, 252, 0.95)',
                }}
              >
                <span
                  style={{
                    fontSize: '8px',
                    fontWeight: 700,
                    lineHeight: 1.15,
                    letterSpacing: '0.03em',
                    textTransform: 'uppercase',
                    color: '#6c757d',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {item.label}
                </span>

                <strong
                  style={{
                    fontSize: '10.5px',
                    lineHeight: 1.2,
                    color: '#111827',
                    fontWeight: 700,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                  title={String(item.value)}
                >
                  {item.value}
                </strong>
              </div>
            ))}
          </div>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
              gap: '6px',
            }}
          >
            {infoHeaderBottomItems.map((item) => (
              <div
                key={item.label}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  gap: '2px',
                  minWidth: 0,
                  padding: '7px 9px',
                  borderRadius: '7px',
                  border: item.highlight
                    ? '1px solid rgba(34, 197, 94, 0.25)'
                    : '1px solid rgba(226, 232, 240, 0.9)',
                  backgroundColor: item.highlight
                    ? 'rgba(240, 253, 244, 0.95)'
                    : 'rgba(248, 250, 252, 0.95)',
                }}
              >
                <span
                  style={{
                    fontSize: '8px',
                    fontWeight: 700,
                    lineHeight: 1.15,
                    letterSpacing: '0.03em',
                    textTransform: 'uppercase',
                    color: '#6c757d',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {item.label}
                </span>

                <strong
                  style={{
                    fontSize: item.highlight ? '11px' : '10.5px',
                    lineHeight: 1.2,
                    color: item.highlight ? '#166534' : '#111827',
                    fontWeight: 700,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                  title={String(item.value)}
                >
                  {item.value}
                </strong>
              </div>
            ))}
          </div>
        </div>
      </div> */}
      <Row className="mt-2" style={{ paddingTop: '2.5rem' }}>
        <Col>
          <div className="d-flex align-items-center">
            <h3 className="mb-0">{propostaData?.prop_nome ?? "Sem nome"}</h3>
          </div>
          <Row className="mt-2 flex-grow-1">
            <Col className="col-md-auto d-flex flex-column">
              <span style={labelStyle}>
                Status
              </span>
              <span style={contentHeaderStyle}>
                {propostaData?.propStatus_nome ?? "Sem status"}
              </span>
            </Col>
            <Col className="col-md-auto d-flex flex-column">
              <span style={labelStyle}>
                Cliente
              </span>
              <span style={contentHeaderStyle}>
                {propostaData?.pj_nomefanta || propostaData?.pj_razaosocial || "Sem cliente"}
              </span>
            </Col>
            <Col className="col-md-auto d-flex flex-column">
              <span style={labelStyle}>
                Prazo de envio
              </span>
              <span style={contentHeaderStyle}>
                {moment(propostaData?.negociacao_prazo).isValid() ? moment(propostaData.negociacao_prazo).format('DD/MM/YYYY') : "Sem prazo de envio"}
              </span>
            </Col>
            <Col className="col-md-auto d-flex flex-column">
              <span style={labelStyle}>
                Preço da proposta
              </span>
              <span style={contentHeaderStyle}>
                {currencyFormatter.format(precoFinalPropostaAtual)}
              </span>
            </Col>
            <Col className="col-md-auto d-flex flex-column">
              <span style={labelStyle}>
                Soma das % dos eventos
              </span>
              <span style={contentHeaderStyle}>
                {formatPercent(somaPercentualEventosPagamento)}
              </span>
            </Col>
            <Col className="col-md-auto d-flex flex-column">
              <span style={labelStyle}>
                ID do Bitrix
              </span>
              <span style={contentHeaderStyle}>
                {propostaData?.bitrix_id ?? "Sem ID"}
              </span>
            </Col>
            <Col className="col-md-auto d-flex flex-column">
              <span style={labelStyle}>
                Serviço
              </span>
              <span style={contentHeaderStyle}>
                {propostaData?.servico_nome ?? "Sem serviço"}
              </span>
            </Col>
          </Row>
        </Col>
      </Row>

      <div className="timeline-tabs">
      {/* LEFT: timeline tabs */}
      <aside className="timeline-tabs__sidebar">
        <ul className="timeline">
          {TABS.map((tab, index) => (
            <li
              key={tab.id}
              className={
                "timeline__item" +
                (tab.id === activeId ? " timeline__item--active" : "") +
                (index === 0 ? " timeline__item--first" : "") +
                (index === TABS.length - 1 ? " timeline__item--last" : "")
              }
            >
              <button
                type="button"
                className="timeline__button"
                onClick={() => setActiveId(tab.id)}
              >
                <span className="timeline__marker" />
                <div className="timeline__text">
                  <span className="timeline__label">{tab.label}</span>
                  {tab.subtitle && (
                    <span className="timeline__subtitle">
                      {tab.subtitle}
                    </span>
                  )}
                </div>
              </button>
            </li>
          ))}
          {/* <li style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <span style={{ fontWeight: 600 }}>Preço da proposta</span>
            <span>{currencyFormatter.format(precoFinalPropostaAtual)}</span>
          </li> */}
          <li className="timeline__action-item">
            <Button
              type="button"
              color="primary"
              className="timeline__action-button"
              onClick={handleOpenSalvarModeloModal}
              disabled={isSubmitEntityLoading}
            >
              {isSubmitEntityLoading ? 'Salvando...' : 'Salvar como modelo'}
            </Button>
          </li>
          {[6, 2].includes(propostaData.propStatus_id) &&
            <li className="timeline__action-item">
              <Button
                type="button"
                color="primary"
                className="timeline__action-button"
                onClick={salvarRascunhoProdsProp}
                disabled={isSubmitEntityLoading}
              >
                {isSubmitEntityLoading ? 'Salvando...' : 'Salvar Rascunho'}
              </Button>
            </li>
          }
          {(propostaData.propStatus_id === 2) &&
            <li className="timeline__action-item">
              <Button
                type="button"
                color="primary"
                className="timeline__action-button"
                onClick={handleConcluirOrcamento}
                disabled={isSubmitEntityLoading}
              >
                {isSubmitEntityLoading ? 'Salvando...' : 'Concluir orçamento'}
              </Button>
            </li>
          }
          {(propostaData.propStatus_id === 4) &&
            <li className="timeline__action-item">
              <Button
                type="button"
                color="primary"
                className="timeline__action-button"
                onClick={() => {
                  window.location.href = 'https://oikos.ecoss.is/oikos-client/comercial/acompanhamento';
                }}
              >
                Ir para negociações
              </Button>
            </li>
          }
        </ul>
      </aside>

      {/* RIGHT: content */}
      <section className={`timeline-tabs__content${activeId === "tab-3" ? " timeline-tabs__content--overview" : ""}`}>
        {activeTab?.content}
      </section>
      </div>

      <Modal
        centered={false}
        isOpen={modalSalvarModeloOpen}
        toggle={handleCloseSalvarModeloModal}
      >
        <ModalHeader toggle={handleCloseSalvarModeloModal}>Salvar como modelo</ModalHeader>
        <ModalBody>
          <FormGroup>
            <label>Nome do modelo</label>
            <Input
              type="text"
              value={modeloPropostaData.modeloProp_nome || ''}
              onChange={(event) =>
                setModeloPropostaData((prevState) => ({
                  ...prevState,
                  modeloProp_nome: event.target.value,
                }))
              }
              placeholder="Digite o nome do modelo"
              maxLength={255}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="light" onClick={handleCloseSalvarModeloModal} disabled={isSubmitEntityLoading}>
            Cancelar
          </Button>
          <Button color="primary" onClick={handleSalvarModeloProposta} disabled={isSubmitEntityLoading}>
            {isSubmitEntityLoading ? 'Salvando...' : 'Salvar'}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        centered={false}
        size="xl"
        isOpen={modalPropItemOpen}
        toggle={() => setModalPropItemOpen(false)}
      >
        <ModalHeader>Adicionar {propItemData.propItemGr_label}</ModalHeader>

        <ModalBody>
          <Tabs>
            <TabList>
              <Tab>Item orçamentário</Tab>
              <Tab>Indicação</Tab>
            </TabList>

            <TabPanel>
              <Row>
                {
                  propItemData.propItemGr_id === 1 ?
                  <>
                    <Col xs="12">
                      <FormGroup>
                        <span>
                          Atuação
                        </span>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          isClearable={true}
                          isSearchable={true}
                          value={projAtuacoes.find((projAtuacao) => Number(projAtuacao.value) === Number(propItemData.projAtuacao_id)) || null}
                          options={projAtuacoes}
                          onChange={(e) => {
                            setPropItemData((prev) => ({
                              ...prev,
                              projAtuacao_id: e?.value ?? null,
                            }))
                          }}
                        />
                      </FormGroup>
                    </Col>

                    <Col xs="12">
                      <FormGroup>
                        <div className='d-flex justify-content-between align-items-center'>
                          <span>
                            Selecione a profissão
                          </span>
                          <Button
                            size="sm"
                            color="link"
                            className="ml-2 px-0"
                            onClick={() => {
                              setInsertPropItemData({});
                              setModalInsertPropItemOpen(true);
                            }}
                          >
                            Criar item
                          </Button>
                        </div>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          isClearable={true}
                          isSearchable={true}
                          value={propItensUnicos.find((pi) => {
                            const descSelecionada = propItemData.propItem_desc ?? propItemData.label;
                            return (
                              Number(pi.propItemGr_id) === Number(propItemData.propItemGr_id) &&
                              pi.propItem_desc === descSelecionada
                            );
                          })}
                          options={propItensUnicos.filter((pi) => Number(pi.propItemGr_id) === Number(propItemData.propItemGr_id))}
                          onChange={async (e) => {
                            if (e) {
                              const unidadeAtualAindaDisponivel = getUnidadesDisponiveisPorGrupoEDescricao(
                                1,
                                e.propItem_desc
                              ).some((unidade) => Number(unidade.value) === Number(propItemData.unidade_id));

                              if (propItemData.unidade_id && propItemData.escol_id && unidadeAtualAindaDisponivel) {
                                const findedPropItem = getRhPropItemByProfissaoEUnidade(e.propItem_desc, propItemData.unidade_id);
                                setPropItemData(prev => ({
                                  ...prev,
                                  ...(findedPropItem || {}),
                                  propItem_id: null,
                                  value: null,
                                  label: e.label,
                                  propItem_desc: e.propItem_desc,
                                  propItem_refVlr: findedPropItem?.propItem_refVlr ?? null,
                                  propOrcItem_valor: getRhValorComEscolaridade({
                                    propItemBase: findedPropItem,
                                    escolId: propItemData.escol_id,
                                  }),
                                }));
                              } else {
                                setPropItemData(prev => ({
                                  ...prev,
                                  propItem_id: null,
                                  value: null,
                                  label: e.label,
                                  propItem_desc: e.propItem_desc,
                                  unidade_id: null,
                                  unidade_label: null,
                                  propItem_refVlr: null,
                                  propOrcItem_valor: null,
                                }));
                              }
                            } else {
                              console.log('limpou profissão', e);
                              setPropItemData({
                                propItemGr_id: propItemData.propItemGr_id,
                                propItemGr_label: propItemData.propItemGr_label,
                                propOrcItem_equipeClt: Boolean(propItemData.propOrcItem_equipeClt),
                                projAtuacao_id: propItemData.projAtuacao_id ?? null,
                                indicacao: propItemData.indicacao || {},
                              })
                            }
                          }}
                        />
                      </FormGroup>
                    </Col>

                    <Col xs="12">
                      <FormGroup>
                        <span>
                          Selecione a escolaridade
                        </span>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          isClearable={true}
                          isSearchable={true}
                          value={escolaridades.find(pi => Number(pi.value) === Number(propItemData.escol_id)) || null}
                          options={escolaridades}
                          onChange={async (e) => {
                            if (e) {
                              if (propItemData.unidade_id && propItemData.propItem_desc) {
                                const findedPropItem = getRhPropItemByProfissaoEUnidade(propItemData.propItem_desc, propItemData.unidade_id);
                                setPropItemData(
                                  {
                                    ...propItemData,
                                    ...findedPropItem,
                                    escol_id: e.value,
                                    propOrcItem_valor: getRhValorComEscolaridade({
                                      propItemBase: findedPropItem,
                                      escolId: e.value,
                                      fallbackValorBase: propItemData.propItem_refVlr,
                                    })
                                  }
                                )
                              } else {
                                setPropItemData(prev => ({
                                  ...prev,
                                  escol_id: e.value,
                                  propItem_id: null,
                                  value: null,
                                  propOrcItem_valor: null
                                }))
                              }
                            } else {
                              setPropItemData(prev => ({
                                ...prev,
                                escol_id: null,
                                propItem_refVlr: prev.unidade_id ? Number(prev.propItem_refVlr) : null,
                                propOrcItem_valor: null
                              }))
                            }
                          }}
                        />
                      </FormGroup>
                    </Col>

                    <Col xs="12">
                      <FormGroup>
                        <span>
                          Unidade
                        </span>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          isClearable={true}
                          isSearchable={true}
                          value={unidadesDisponiveisPropItem.find((pi) => Number(pi.value) === Number(propItemData.unidade_id)) || null}
                          options={unidadesDisponiveisPropItem}
                          onChange={async (e) => {
                            if (e) {
                              const findedPropItem = getRhPropItemByProfissaoEUnidade(propItemData.propItem_desc, e.value);

                              setPropItemData((prev) => ({
                                ...prev,
                                ...(findedPropItem || {}),
                                unidade_id: e.value,
                                unidade_label: e.label,
                                propItem_id: findedPropItem?.propItem_id ?? null,
                                value: findedPropItem?.value ?? null,
                                propItem_refVlr: Number(findedPropItem?.propItem_refVlr) ?? null,
                                propOrcItem_valor: findedPropItem
                                  ? getRhValorComEscolaridade({
                                    propItemBase: findedPropItem,
                                    escolId: propItemData.escol_id,
                                  })
                                  : null,
                              }));
                            } else {
                              setPropItemData(prev => ({
                                ...prev,
                                propItem_id: null,
                                value: null,
                                unidade_id: null,
                                unidade_label: null,
                                propItem_refVlr: null,
                                propOrcItem_valor: null
                              }))
                            }
                          }}
                        />
                      </FormGroup>
                    </Col>

                    <Col xs="12">
                      <FormGroup check className="mb-3">
                        <Input
                          id="equipe-clt"
                          type="checkbox"
                          checked={Boolean(propItemData.propOrcItem_equipeClt)}
                          onChange={(e) => {
                            const equipeClt = e.target.checked;
                            setPropItemData((prev) => {
                              return {
                                ...prev,
                                propOrcItem_equipeClt: equipeClt,
                                ...(equipeClt ? {propEstrut_id: 1} : {propEstrut_id: 2})
                              };
                            });
                          }}
                        />
                        <label htmlFor="equipe-clt" className="form-check-label">
                          Equipe CLT?
                        </label>
                      </FormGroup>
                    </Col>
                  </>
                  :
                  <>
                    <Col xs="12">
                      <FormGroup>
                        <div className='d-flex justify-content-between align-items-center'>
                          <span>
                            Selecione o item orçamentário
                          </span>
                          <Button
                            size="sm"
                            color="link"
                            className="ml-2 px-0"
                            onClick={() => {
                              setInsertPropItemData({});
                              setModalInsertPropItemOpen(true);
                            }}
                          >
                            Criar item
                          </Button>
                        </div>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          isClearable={true}
                          isSearchable={true}
                          value={propItensUnicos.find((pi) => {
                            const descSelecionada = propItemData.propItem_desc ?? propItemData.label;
                            return (
                              Number(pi.propItemGr_id) === Number(propItemData.propItemGr_id) &&
                              pi.propItem_desc === descSelecionada
                            );
                          })}
                          options={propItensUnicos.filter(pi => pi.propItemGr_id === propItemData.propItemGr_id)}
                          onChange={async (e) => {
                            if (e) {
                              const unidadeAtualAindaDisponivel = getUnidadesDisponiveisPorGrupoEDescricao(
                                propItemData.propItemGr_id,
                                e.propItem_desc
                              ).some((unidade) => Number(unidade.value) === Number(propItemData.unidade_id));

                              if (propItemData.unidade_id && unidadeAtualAindaDisponivel) {
                                const findedPropItem = getPropItemByGrupoDescricaoEUnidade(
                                  propItemData.propItemGr_id,
                                  e.label,
                                  propItemData.unidade_id
                                );
                                setPropItemData(prev => ({
                                  ...prev,
                                  ...findedPropItem,
                                  propItem_id: null,
                                  value: null,
                                  label: e.label,
                                  propItem_desc: e.propItem_desc,
                                  propItem_refVlr: findedPropItem?.propItem_refVlr ?? null,
                                  propOrcItem_valor: findedPropItem?.propItem_refVlr ?? null,
                                }))
                              } else {
                                setPropItemData(prev => ({
                                  ...prev,
                                  propItem_id: null,
                                  value: null,
                                  label: e.label,
                                  propItem_desc: e.propItem_desc,
                                  unidade_id: null,
                                  unidade_label: null,
                                  propItem_refVlr: null,
                                  propOrcItem_valor: null,
                                }))
                              }
                            } else {
                              setPropItemData({
                                propItemGr_id: propItemData.propItemGr_id,
                                propItemGr_label: propItemData.propItemGr_label,
                                indicacao: propItemData.indicacao || {},
                              })
                            }
                          }}
                        />
                      </FormGroup>
                    </Col>

                    <Col xs="12">
                      <FormGroup>
                        <span>
                          Unidade
                        </span>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          isClearable={true}
                          isSearchable={true}
                          value={unidadesDisponiveisPropItem.find((pi) => Number(pi.value) === Number(propItemData.unidade_id)) || null}
                          options={unidadesDisponiveisPropItem}
                          onChange={async (e) => {
                            if (e) {
                              const findedPropItem = getPropItemByGrupoDescricaoEUnidade(
                                propItemData.propItemGr_id,
                                propItemData.propItem_desc,
                                e.value
                              );

                              setPropItemData(prev => ({
                                ...prev,
                                ...(findedPropItem || {}),
                                unidade_id: e.value,
                                unidade_label: e.label,
                                propItem_id: findedPropItem?.propItem_id ?? null,
                                value: findedPropItem?.value ?? null,
                                propItem_refVlr: Number(findedPropItem?.propItem_refVlr) ?? null,
                                propOrcItem_valor: Number(findedPropItem?.propItem_refVlr) ?? null,
                              }))
                            } else {
                              setPropItemData(prev => ({
                                ...prev,
                                propItem_id: null,
                                value: null,
                                unidade_id: null,
                                unidade_label: null,
                                propItem_refVlr: null,
                                propOrcItem_valor: null,
                              }))
                            }
                          }}
                        />
                      </FormGroup>
                    </Col>
                  </>
                }

                <Col xs="12">
                  <FormGroup>
                    <span>
                      Descrição
                    </span>
                    <Input
                      value={propItemData.propOrcItem_desc}
                      onChange={async (e) => {
                        if (propItemData.propItem_id) {
                          setPropItemData({ ...propItemData, propOrcItem_desc: e.target.value })
                        }
                      }}
                    />
                  </FormGroup>
                </Col>

                <Col xs="12">
                  <FormGroup>
                    <div className='d-flex justify-content-between align-items-center'>
                      <span>
                        Valor unitário de referência
                      </span>
                      <div className='d-flex'>
                        <Button
                          size="sm"
                          color="link"
                          className="ml-2 px-0"
                          onClick={() => setIsPropItemValorEditavel(prev => !prev)}
                        >
                          {isPropItemValorEditavel ? 'Bloquear edição de valor' : 'Editar valor'}
                        </Button>
                        { isPropItemValorEditavel &&
                          <Button
                            size="sm"
                            color="link"
                            className="ml-2 px-0"
                            onClick={() => setOpenModalSalvarValorRef(true)}
                          >
                            Salvar na tabela geral
                          </Button>
                        }
                      </div>

                    </div>
                    <MaskedInput
                      unmask
                      mask="R$ num"
                      disabled={!isPropItemValorEditavel}
                      blocks={{
                        num: {
                          mask: Number,
                          scale: 2,
                          signed: false,
                          thousandsSeparator: '.',
                          padFractionalZeros: false,
                          normalizeZeros: false,
                          radix: ',',
                          min: 0,
                          max: 1000000000,
                        },
                      }}
                      lazy={false}
                      value={String(propItemData?.propOrcItem_valor ?? '')}
                      onAccept={value => {
                        setPropItemData((prev) => {
                          return { ...prev, propOrcItem_valor: Number(value) };
                        });
                      }}
                    />
                  </FormGroup>
                </Col>

                {propItemData.propOrcItem_equipeClt && (
                  <Col xs="12">
                    <FormGroup>
                      <div className='d-flex justify-content-between align-items-center'>
                        <span>
                          Valor com encargos
                        </span>
                      </div>
                      <MaskedInput
                        unmask
                        mask="R$ num"
                        disabled
                        blocks={{
                          num: {
                            mask: Number,
                            scale: 2,
                            signed: false,
                            thousandsSeparator: '.',
                            padFractionalZeros: false,
                            normalizeZeros: false,
                            radix: ',',
                            min: 0,
                            max: 1000000000,
                          },
                        }}
                        lazy={false}
                        value={propItemData.propOrcItem_equipeClt ? String(Number(propItemData?.propOrcItem_valor) * (1 + (Number(visaoGeralPercentuais.taxaEncargos)/100))) : String(Number(propItemData?.propOrcItem_valor))}
                      />
                    </FormGroup>
                  </Col>
                )}

                <Col xs="12">
                  <FormGroup>
                    <span>
                      Modalidade da quantidade
                    </span>
                    <Input
                      type="select"
                      value={modalidadeQuantidadePropItem}
                      onChange={(e) => {
                        const modalidade = e.target.value;
                        setModalidadeQuantidadePropItem(modalidade);
                        setQuantidadeMensalPropItem('');
                        setPropItemData((prev) => ({
                          ...prev,
                          propOrcItem_qtd: '',
                        }));
                      }}
                    >
                      <option value="total">Quantidade total</option>
                      <option value="mensal">Quantidade mensal</option>
                    </Input>
                  </FormGroup>
                </Col>

                <Col xs="12">
                  <FormGroup>
                    <span>
                      {modalidadeQuantidadePropItem === 'mensal' ? 'Quantidade mensal' : 'Quantidade total'}
                    </span>
                    <Input
                      value={modalidadeQuantidadePropItem === 'mensal' ? quantidadeMensalPropItem : propItemData.propOrcItem_qtd}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (!hasPropItemSelecionado()) {
                          if (value !== '') {
                            notifyError('Selecione um item orçamentário antes de informar a quantidade.');
                          }
                          setQuantidadeMensalPropItem('');
                          setPropItemData({
                            ...propItemData,
                            propOrcItem_qtd: ''
                          });
                          return;
                        }

                        if (value !== '' && isNaN(Number(value))) return;

                        if (modalidadeQuantidadePropItem === 'mensal') {
                          const quantidadeMensal = value === '' ? '' : Number(value);
                          const mesesAlocados = Math.max(0, Math.floor(Number(quantidadeColunas) || 0));
                          setQuantidadeMensalPropItem(quantidadeMensal);
                          setPropItemData({
                            ...propItemData,
                            propOrcItem_qtd: value === '' ? '' : Number(value) * mesesAlocados
                          });
                          return;
                        }

                        setPropItemData({
                          ...propItemData,
                          propOrcItem_qtd: value === '' ? '' : Number(value)
                        });
                      }}
                    />
                    {modalidadeQuantidadePropItem === 'mensal' && (
                      <small style={{ display: 'block', marginTop: '6px', color: '#6c757d' }}>
                        Quantidade total calculada: {getQuantidadeTotalPropItem()} ({parseNumericValue(quantidadeMensalPropItem) || 0} x {Math.max(0, Math.floor(Number(quantidadeColunas) || 0))} meses)
                      </small>
                    )}
                    <small style={{ display: 'block', marginTop: '6px', color: '#6c757d' }}>
                      Valor total calculado: {currencyFormatter.format(getValorTotalPropItemAdicao() || 0)}
                    </small>
                  </FormGroup>
                </Col>
              </Row>
            </TabPanel>

            <TabPanel>
              <IndicacaoCotacaoRapidaForm
                ref={indicacaoCotacaoRapidaFormRef}
                indicacao={propItemData.indicacao || {}}
                onChange={setIndicacaoPropItemData}
              />
            </TabPanel>
          </Tabs>
        </ModalBody>

        <ModalFooter>
          <Button
            type="button"
            onClick={() => setModalPropItemOpen(false)}
            color="light"
            className="waves-effect"
          >
            Cancelar
          </Button>

          {isSubmitEntityLoading ? (
            <Button type="button" disabled>
              <Spinner />
            </Button>
          ) : (
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={() => {
                const camposObrigatoriosPendentes = getCamposObrigatoriosPropItemParaAdicionar();
                if (camposObrigatoriosPendentes.length > 0) {
                  notifyError(`Preencha os campos obrigatórios antes de salvar: ${camposObrigatoriosPendentes.map((campo) => campo.label).join(', ')}.`);
                  return;
                }

                setIsSubmitEntityLoading(true);
                const isRecursoHumano = Number(propItemData?.propItemGr_id) === 1;
                const valorBaseRh =
                  parseNumericValue(propItemData?.propItem_refVlr) ??
                  parseNumericValue(propItemData?.propOrcItem_valor) ??
                  0;
                const indicacaoComPropostasPendentes = indicacaoCotacaoRapidaFormRef.current?.getValue?.();
                if (indicacaoComPropostasPendentes === null) {
                  setIsSubmitEntityLoading(false);
                  return;
                }
                const indicacaoSalva = {
                  ...(indicacaoComPropostasPendentes || propItemData.indicacao || {}),
                  filesPedidoCompra: indicacaoFilesPedidoCompra,
                };
                const novoPropItem = {
                  ...propItemData,
                  indicacao: indicacaoSalva,
                  propOrcItem_qtd: getQuantidadeTotalPropItem(),
                  value: Date.now(),
                };
                setPropostaData({
                  ...propostaData,
                  propItens: [...(propostaData.propItens ? propostaData.propItens : []), novoPropItem],
                });
                indicacaoCotacaoRapidaFormRef.current?.resetDraft?.();
                setIsSubmitEntityLoading(false);
                setModalPropItemOpen(false)
              }}
            >
              Salvar
            </Button>
          )}
        </ModalFooter>
      </Modal>

      <Modal
        centered={false}
        isOpen={modalInsertPropItemOpen}
        toggle={() => {
          setModalInsertPropItemOpen(false);
          setInsertPropItemData({});
        }}
      >
        <ModalHeader>Criar item orçamentário</ModalHeader>

        <ModalBody>
          <FormGroup>
            <span>Tipo</span>
            <Select
              className="basic-single"
              classNamePrefix="select"
              isClearable={true}
              isSearchable={true}
              value={gruposOrcItem.find(pi => pi.value === insertPropItemData.propItemGr_id) || null}
              options={gruposOrcItem}
              onChange={async (e) => {
                if (e) {
                  setInsertPropItemData((prev) => ({
                    ...prev,
                    propItemGr_id: e.value,
                    propItemGr_label: e.label,
                  }));
                } else {
                  setInsertPropItemData(prev => ({ ...prev, propItemGr_id: null, propItemGr_label: null }))
                }
              }}
            />
          </FormGroup>

          <FormGroup>
            <span>Grupo de Categoria</span>
            <Select
              className="basic-single"
              classNamePrefix="select"
              isClearable={true}
              isSearchable={true}
              value={gruposDeCategorias.find(pi => pi.value === insertPropItemData.categGr_id) || null}
              options={gruposDeCategorias}
              onChange={async (e) => {
                if (e) {
                  setInsertPropItemData((prev) => ({
                    ...prev,
                    categGr_id: e.value,
                    categGr_nome: e.label,
                  }));
                } else {
                  setInsertPropItemData(prev => ({ ...prev, categGr_id: null, categGr_nome: null, categ_id: null, categ_nome: null }) )
                }
              }}
            />
          </FormGroup>

          <FormGroup>
            <span>Categoria</span>
            <Select
              className="basic-single"
              classNamePrefix="select"
              isClearable={true}
              isSearchable={true}
              value={categorias.find(pi => pi.value === insertPropItemData.categ_id) || null}
              options={categorias.filter(c => c.categGr_id === insertPropItemData.categGr_id)}
              onChange={async (e) => {
                if (e) {
                  setInsertPropItemData((prev) => ({
                    ...prev,
                    categ_id: e.value,
                    categ_nome: e.label,
                  }));
                } else {
                  setInsertPropItemData(prev => ({ ...prev, categ_id: null, categ_nome: null }))
                }
              }}
            />
          </FormGroup>

          <FormGroup>
            <span>Descrição</span>
            <Input
              value={insertPropItemData.propItem_desc ?? ''}
              onChange={(e) => {
                setInsertPropItemData((prev) => ({
                  ...prev,
                  propItem_desc: e.target.value,
                }));
              }}
            />
          </FormGroup>

          <FormGroup>
            <span>
              Unidade
            </span>
            <Select
              className="basic-single"
              classNamePrefix="select"
              isClearable={true}
              isSearchable={true}
              value={unidades.find(pi => pi.value === insertPropItemData.unidade_id) || null}
              options={unidades}
              onChange={async (e) => {
                if (e) {
                  setInsertPropItemData((prev) => ({
                    ...prev,
                    unidade_id: e.value,
                  }));
                } else {
                  setInsertPropItemData(prev => ({ ...prev, unidade_id: null }))
                }
              }}
            />
          </FormGroup>

          <FormGroup>
            <span>Valor</span>
            <MaskedInput
              unmask
              mask="R$ num"
              blocks={{
                num: {
                  mask: Number,
                  scale: 2, // digits after point 0 for integers
                  signed: false, // disallow negative
                  thousandsSeparator: '.', // any single char
                  padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                  normalizeZeros: false, // appends or removes zeros at ends
                  radix: ',', // fractional delimiter
                  min: 0,
                  max: 1000000000,
                },
              }}
              lazy={false}
              value={String(insertPropItemData.propItem_refVlr ?? '')}
              onAccept={value => {
                setInsertPropItemData(prev => ({...prev, propItem_refVlr: value}))
              }}
            />
          </FormGroup>
        </ModalBody>

        <ModalFooter>
          <Button
            type="button"
            color="light"
            className="waves-effect"
            onClick={() => {
              setModalInsertPropItemOpen(false);
              setInsertPropItemData({});
            }}
          >
            Cancelar
          </Button>
          <Button
            type="button"
            color="primary"
            className="waves-effect waves-light"
            onClick={async () => {
              await handleInsertPropItem();
              setModalInsertPropItemOpen(false);
            }}
          >
            {isInsertPropItemLoading ? <Spinner /> : 'Salvar'}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        centered={false}
        isOpen={modalProdPropOpen}
        toggle={() => {
          setModalProdPropOpen(false);
          setProdPropData({});
        }}
      >
        <ModalHeader>{isEditingProdProp ? 'Editar Produto' : 'Adicionar Produto'}</ModalHeader>

        <ModalBody>

          <Tabs>
            <TabList>
              { /* <Tab>Modelo de produto</Tab> */}
              <Tab>{isEditingProdProp ? 'Editar produto' : 'Novo produto'}</Tab>
            </TabList>
            {/* <TabPanel>
              <FormGroup>
                <span>
                  Modelo de produto
                </span>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  options={prodsProp}
                  onChange={async (e) => {
                    setProdPropData(e)
                  }}
                />
              </FormGroup>
              <FormGroup>
                <span>
                  Prazo de entrega (dias)
                </span>
                <Input
                  value={prodPropData.prodProp_prazoEntrega}
                  onChange={(e) => {
                    const value = e.target.value

                    if (/^\d*$/.test(value)) {
                      setProdPropData({
                        ...prodPropData,
                        prodProp_prazoEntrega: value === ''
                          ? null
                          : Number(value)
                      })
                    }
                  }}
                />
              </FormGroup>
            </TabPanel> */}
            <TabPanel>
              <FormGroup>
                <span>
                  Nome do produto
                </span>
                <Input
                  value={prodPropData.prodProp_nome || ""}
                  onChange={e => setProdPropData({...prodPropData, prodProp_nome: e.target.value})}
                />
              </FormGroup>

              <FormGroup>
                <span>
                  Prazo de entrega (dias)
                </span>
                <Input
                  value={prodPropData.prodProp_prazoEntrega ?? ''}
                  onChange={(e) => {
                    const value = e.target.value

                    if (/^\d*$/.test(value)) {
                      setProdPropData({
                        ...prodPropData,
                        prodProp_prazoEntrega: value === ''
                          ? null
                          : Number(value)
                      })
                    }
                  }}
                />
              </FormGroup>
            </TabPanel>
          </Tabs>

        </ModalBody>

        <ModalFooter>
          <Button
            type="button"
            onClick={() => {
              setModalProdPropOpen(false);
              setProdPropData({});
              setIsEditingProdProp(false);
            }}
            color="light"
            className="waves-effect"
          >
            Cancelar
          </Button>

          {isSubmitEntityLoading ? (
            <Button type="button" disabled>
              <Spinner />
            </Button>
          ) : (
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={async () => {
                if (isEditingProdProp) {
                  setPropostaData({
                    ...propostaData,
                    prodsProp: [
                      ...(propostaData.prodsProp ? propostaData.prodsProp.filter(pp => pp.value !== prodPropData.value) : []),
                      {...prodPropData, value: Date.now()}
                    ]})
                } else {
                  setPropostaData({
                    ...propostaData,
                    prodsProp: [
                      ...(propostaData.prodsProp ? propostaData.prodsProp : []),
                      {...prodPropData, value: Date.now()}
                    ]
                  })
                }
                setModalProdPropOpen(false);
                setIsEditingProdProp(false);
                setProdPropData({});
                setIsSubmitEntityLoading(false);
              }}
            >
              Salvar
            </Button>
          )}
        </ModalFooter>
      </Modal>

      <Modal
        centered={false}
        isOpen={modalEventosPagamentoOpen}
        toggle={() => {
          setModalEventosPagamentoOpen(false);
          setEventoPagamentoPropData({});
          setIsEditingEventoPagamentoProp(false);
        }}
      >
        <ModalHeader>{isEditingEventoPagamentoProp ? 'Editar evento de pagamento' : 'Adicionar evento de pagamento'}</ModalHeader>

        <ModalBody>
          <Tabs>
            <TabList>
              {/* <Tab>Modelo de evento de pagamento</Tab> */}
              <Tab>{isEditingEventoPagamentoProp ? 'Editar evento de pagamento' : 'Novo evento de pagamento'}</Tab>
            </TabList>
            {/* <TabPanel>
              <FormGroup>
                <span>
                  Modelo de evento de pagamento
                </span>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  options={eventosPagamentoProp}
                  onChange={async (e) => {
                    setEventoPagamentoPropData(e);
                  }}
                />
              </FormGroup>
            </TabPanel> */}
            <TabPanel>
              <FormGroup>
                <span>
                  Nome do evento de pagamento
                </span>
                <Input
                  value={eventoPagamentoPropData.eventoPagamentoProp_nome || ""}
                  onChange={e => setEventoPagamentoPropData({...eventoPagamentoPropData, eventoPagamentoProp_nome: e.target.value})}
                />
              </FormGroup>

              <FormGroup>
                <span>Valor (%)</span>
                <MaskedInput
                  unmask
                  mask="num %"
                  blocks={{
                    num: {
                      mask: Number,
                      scale: 2, // digits after point 0 for integers
                      signed: false, // disallow negative
                      thousandsSeparator: '.', // any single char
                      padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                      normalizeZeros: false, // appends or removes zeros at ends
                      radix: ',', // fractional delimiter
                      min: 0,
                      max: 100,
                    },
                  }}
                  lazy={false}
                  value={String(eventoPagamentoPropData.eventoPagamentoProp_vlr || "")}
                  onAccept={value => {
                    setEventoPagamentoPropData({...eventoPagamentoPropData, eventoPagamentoProp_vlr: Number(value)});
                  }}
                />
              </FormGroup>

              <FormGroup>
                <span>
                  Prazo de pagamento (dias)
                </span>
                <Input
                  value={eventoPagamentoPropData.eventoPagamentoProp_prazoPgto ?? ''}
                  onChange={(e) => {
                    const value = e.target.value

                    if (/^\d*$/.test(value)) {
                      setEventoPagamentoPropData({
                        ...eventoPagamentoPropData,
                        eventoPagamentoProp_prazoPgto: value === ''
                          ? null
                          : Number(value)
                      })
                    }
                  }}
                />
              </FormGroup>
            </TabPanel>
          </Tabs>

        </ModalBody>

        <ModalFooter>
          <Button
            type="button"
            onClick={() => {
              setModalEventosPagamentoOpen(false);
              setEventoPagamentoPropData({});
              setIsEditingEventoPagamentoProp(false);
            }}
            color="light"
            className="waves-effect"
          >
            Cancelar
          </Button>

          {isSubmitEntityLoading ? (
            <Button type="button" disabled>
              <Spinner />
            </Button>
          ) : (
          <Button
            type="button"
            color="primary"
            className="waves-effect waves-light"
            onClick={async () => {
              const eventosAtualizados = isEditingEventoPagamentoProp
                ? [
                  ...(propostaData.eventosPagamentoProp ? propostaData.eventosPagamentoProp.filter(pp => pp.value !== eventoPagamentoPropData.value) : []),
                  { ...eventoPagamentoPropData, value: Date.now() },
                ]
                : [
                  ...(propostaData.eventosPagamentoProp ? propostaData.eventosPagamentoProp : []),
                  { ...eventoPagamentoPropData, value: Date.now() },
                ];

              if (!validarSomaPercentualEventosPagamento(eventosAtualizados)) return;

              setPropostaData({
                ...propostaData,
                eventosPagamentoProp: eventosAtualizados
              });
              setModalEventosPagamentoOpen(false);
              setIsEditingEventoPagamentoProp(false);
              setEventoPagamentoPropData({});
              setIsSubmitEntityLoading(false);
            }}
            >
              Salvar
            </Button>
          )}
        </ModalFooter>
      </Modal>

      {
        Object.keys(propostaData).length > 0 && Object.keys(propItemData).length > 0 &&
        <Modal
          centered={false}
          size="xl"
          isOpen={modalPropItemEditOpen}
          toggle={() => setModalPropItemEditOpen(false)}
        >
          <ModalHeader>Edição {propItemData.propItemGr_label}</ModalHeader>

          <ModalBody>
            <Tabs>
              <TabList>
                <Tab>Item orçamentário</Tab>
                <Tab>Indicação</Tab>
              </TabList>

              <TabPanel>
                <Row>
                  <Col xs="12">
                    <FormGroup>
                      <span>
                        Selecione o item orçamentário
                      </span>
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        isDisabled={true}
                        value={propItens.find((pi) => {
                          return pi.propItem_id === propItemData.propItem_id;
                        })}
                      />
                    </FormGroup>
                  </Col>

                  {Number(propItemData?.propItemGr_id) === 1 && (
                    <Col xs="12">
                      <FormGroup>
                        <span>
                          Escolaridade
                        </span>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          isClearable={true}
                          isSearchable={true}
                          value={getEscolaridadeSelecionada(propItemData.escol_id)}
                          options={escolaridades}
                          onChange={(e) => {
                            const rhSelecionado = getRhPropItemByProfissaoEUnidade(
                              propItemData.propItem_desc,
                              propItemData.unidade_id
                            );

                            setPropItemData((prev) => ({
                              ...prev,
                              ...(rhSelecionado ? {
                                propItem_id: rhSelecionado.propItem_id,
                                propItem_refVlr: parseNumericValue(rhSelecionado.propItem_refVlr),
                                unidade_id: rhSelecionado.unidade_id ?? prev.unidade_id,
                                unidade_label: rhSelecionado.unidade_label ?? prev.unidade_label,
                              } : {}),
                              escol_id: e?.value ?? null,
                              propOrcItem_valor: e ? getRhValorComEscolaridade({
                                propItemBase: rhSelecionado || prev,
                                escolId: e.value,
                                fallbackValorBase: prev.propItem_refVlr,
                              }) : null,
                            }));
                          }}
                        />
                      </FormGroup>
                    </Col>
                  )}

                  <Col xs="12">
                    <FormGroup>
                      <div className='d-flex justify-content-between align-items-center'>
                        <span>
                          Valor unitário de referência
                        </span>
                        <div className='d-flex'>
                          <Button
                            size="sm"
                            color="link"
                            className="ml-2 px-0"
                            disabled={!propItemData.propItem_id}
                            onClick={() => setIsPropItemValorEditavel(prev => !prev)}
                          >
                            {isPropItemValorEditavel ? 'Bloquear edição de valor' : 'Editar valor'}
                          </Button>
                          { isPropItemValorEditavel &&
                            <Button
                              size="sm"
                              color="link"
                              className="ml-2 px-0"
                              disabled={!propItemData.propItem_id}
                              onClick={() => setOpenModalSalvarValorRef(true)}
                            >
                              Salvar na tabela geral
                            </Button>
                          }
                        </div>

                      </div>
                      <MaskedInput
                        unmask
                        mask="R$ num"
                        disabled={!isPropItemValorEditavel}
                        blocks={{
                          num: {
                            mask: Number,
                            scale: 2,
                            signed: false,
                            thousandsSeparator: '.',
                            padFractionalZeros: false,
                            normalizeZeros: false,
                            radix: ',',
                            min: 0,
                            max: 1000000000,
                          },
                        }}
                        lazy={false}
                        value={String(propItemData?.propOrcItem_valor ?? '')}
                        onAccept={value => {
                          setPropItemData((prev) => {
                            return { ...prev, propOrcItem_valor: value };
                          });
                        }}
                      />
                    </FormGroup>
                  </Col>

                  {Number(propItemData?.propItemGr_id) === 1 && (
                    <Col xs="12">
                      <FormGroup check className="mb-3">
                        <Input
                          id="equipe-clt-edicao"
                          type="checkbox"
                          checked={Boolean(propItemData.propOrcItem_equipeClt)}
                          onChange={(e) => {
                            const equipeClt = e.target.checked;
                            setPropItemData((prev) => {
                              return {
                                ...prev,
                                propOrcItem_equipeClt: equipeClt,
                                ...(equipeClt ? {propEstrut_id: 1} : {propEstrut_id: 2})
                              };
                            });
                          }}
                        />
                        <label htmlFor="equipe-clt-edicao" className="form-check-label">
                          Equipe CLT?
                        </label>
                      </FormGroup>
                    </Col>
                  )}

                  <Col xs="12">
                    <FormGroup>
                      <span>
                        Valor com encargos
                      </span>
                      <MaskedInput
                        unmask
                        mask="R$ num"
                        disabled
                        blocks={{
                          num: {
                            mask: Number,
                            scale: 2,
                            signed: false,
                            thousandsSeparator: '.',
                            padFractionalZeros: false,
                            normalizeZeros: false,
                            radix: ',',
                            min: 0,
                            max: 1000000000,
                          },
                        }}
                        lazy={false}
                        value={String(propItemData?.propOrcItem_valor ? (propItemData.propOrcItem_equipeClt ? propItemData.propOrcItem_valor * (1 + (visaoGeralPercentuais.taxaEncargos/100)) : propItemData.propOrcItem_valor) : '')}
                      />
                    </FormGroup>
                  </Col>

                  {Number(propItemData?.propItemGr_id) === 1 && (
                    <Col xs="12">
                      <FormGroup>
                        <span>
                          Atuação
                        </span>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          isClearable={true}
                          isSearchable={true}
                          value={projAtuacoes.find((projAtuacao) => Number(projAtuacao.value) === Number(propItemData.projAtuacao_id)) || null}
                          options={projAtuacoes}
                          onChange={(e) => {
                            setPropItemData((prev) => ({
                              ...prev,
                              projAtuacao_id: e?.value ?? null,
                            }));
                          }}
                        />
                      </FormGroup>
                    </Col>
                  )}

                  <Col xs="12">
                    <FormGroup>
                      <span>
                        Quantidade
                      </span>
                      <Input
                      value={propItemData.propOrcItem_qtd}
                        onChange={async (e) => {
                          if (propItemData.propItem_id) {
                            if (e.target.value && e.target.value !== '' && !isNaN(Number(e.target.value))) {
                              setPropItemData({
                                ...propItemData,
                                propOrcItem_qtd: Number(e.target.value)
                              })
                            }
                            else {
                              setPropItemData({
                                ...propItemData,
                                propOrcItem_qtd: 0
                              })
                            }
                          }
                        }}
                      />
                      <small style={{ display: 'block', marginTop: '6px', color: '#6c757d' }}>
                        Valor total calculado: {currencyFormatter.format(getValorTotalPropItemEdicao() || 0)}
                      </small>
                    </FormGroup>
                  </Col>

                  <Col xs="12">
                    <FormGroup>
                      <span>
                        Descrição
                      </span>
                      <Input
                      value={propItemData.propOrcItem_desc}
                        onChange={async (e) => {
                          if (propItemData.propItem_id) {
                            if (e.target.value && e.target.value !== '') {
                              setPropItemData({
                                ...propItemData,
                                propOrcItem_desc: e.target.value
                              })
                            }
                            else {
                              setPropItemData({
                                ...propItemData,
                                propOrcItem_desc: null
                              })
                            }
                          }
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>

              </TabPanel>

              <TabPanel>
                <IndicacaoCotacaoRapidaForm
                  ref={indicacaoCotacaoRapidaFormRef}
                  indicacao={propItemData.indicacao || {}}
                  onChange={setIndicacaoPropItemData}
                />
                {/* <BlurOverlay blurAmount='2px'>
                </BlurOverlay> */}
              </TabPanel>
              
            </Tabs>

          </ModalBody>

          <ModalFooter>
            <Button
              type="button"
              onClick={() => setModalPropItemEditOpen(false)}
              color="light"
              className="waves-effect"
            >
              Cancelar
            </Button>

            {isSubmitEntityLoading ? (
              <Button type="button" disabled>
                <Spinner />
              </Button>
            ) : (
              <Button
                type="button"
                color="primary"
                className="waves-effect waves-light"
                onClick={()=>{
                  const propItemRowKey = getPropItemRowKey(propItemData);
                  const propItemId = Number(propItemData?.propItem_id ?? propItemData?.value) || 0;
                  setIsSubmitEntityLoading(true);
                  const indicacaoComPropostasPendentes = indicacaoCotacaoRapidaFormRef.current?.getValue?.();
                  if (indicacaoComPropostasPendentes === null) {
                    setIsSubmitEntityLoading(false);
                    return;
                  }
                  const propItemEditAtualizado = {
                    ...propItemData,
                    indicacao: {
                      ...(indicacaoComPropostasPendentes || propItemData.indicacao || {}),
                      filesPedidoCompra: indicacaoFilesPedidoCompra,
                    },
                  };
                  setPropostaData({...propostaData, propItens: propostaData.propItens.map(pi => {
                    if (getPropItemRowKey(pi) === propItemRowKey) {
                      return propItemEditAtualizado;
                    } else {
                      return pi;
                    }
                  })});
                  redistribuirQuantidadePropItemEditado({
                    rowKey: propItemRowKey,
                    propItemId,
                    quantidadeTotalAtualizada: propItemEditAtualizado.propOrcItem_qtd,
                  });
                  indicacaoCotacaoRapidaFormRef.current?.resetDraft?.();
                  setPropItemData({});
                  setIsSubmitEntityLoading(false);
                  setModalPropItemEditOpen(false);
                }}
              >
                Salvar
              </Button>
            )}
          </ModalFooter>
        </Modal>
      }

      <ModalConfirmacao
        openModal={openModalSalvarValorRef}
        onClosed={()=>setOpenModalSalvarValorRef(false)}
        title={'Confirma alteração do valor de referência?'}
        subtitle={`
          Deseja alterar o valor de referência do item ${propItemData.propItem_desc} (${propItemData.unidade_label})
          de ${currencyFormatter.format(propItemData.propItem_refVlr)} para ${currencyFormatter.format(propItemData.propOrcItem_valor)}? Novas orçamentações trarão o valor
          alterado como valor de refência.
        `}
        onConfirm={()=>handleSaveValorRef(propItemData)}
      />
    </div>
  )
}

export default RevisarOrcamento
